var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/Button/Button.tsx
import { Slot } from "@radix-ui/react-slot";

// ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
__name(r, "r");
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
__name(clsx, "clsx");

// ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var falsyToString = /* @__PURE__ */ __name((value) => typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value, "falsyToString");
var cx = clsx;
var cva = /* @__PURE__ */ __name((base, config) => (props) => {
  var _config_compoundVariants;
  if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  const { variants, defaultVariants } = config;
  const getVariantClassNames = Object.keys(variants).map((variant) => {
    const variantProp = props === null || props === void 0 ? void 0 : props[variant];
    const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
    if (variantProp === null) return null;
    const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
    return variants[variant][variantKey];
  });
  const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
    let [key, value] = param;
    if (value === void 0) {
      return acc;
    }
    acc[key] = value;
    return acc;
  }, {});
  const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param) => {
    let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
    return Object.entries(compoundVariantOptions).every((param2) => {
      let [key, value] = param2;
      return Array.isArray(value) ? value.includes({
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key]) : {
        ...defaultVariants,
        ...propsWithoutUndefined
      }[key] === value;
    }) ? [
      ...acc,
      cvClass,
      cvClassName
    ] : acc;
  }, []);
  return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
}, "cva");

// src/components/Button/Button.tsx
import React2 from "react";

// ../../node_modules/.pnpm/tailwind-merge@3.7.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var concatArrays = /* @__PURE__ */ __name((array1, array2) => {
  const combinedArray = new Array(array1.length + array2.length);
  for (let i = 0; i < array1.length; i++) {
    combinedArray[i] = array1[i];
  }
  for (let i = 0; i < array2.length; i++) {
    combinedArray[array1.length + i] = array2[i];
  }
  return combinedArray;
}, "concatArrays");
var createClassValidatorObject = /* @__PURE__ */ __name((classGroupId, validator) => ({
  classGroupId,
  validator
}), "createClassValidatorObject");
var createClassPartObject = /* @__PURE__ */ __name((nextPart = /* @__PURE__ */ new Map(), validators = null, classGroupId) => ({
  nextPart,
  validators,
  classGroupId
}), "createClassPartObject");
var CLASS_PART_SEPARATOR = "-";
var EMPTY_CONFLICTS = [];
var ARBITRARY_PROPERTY_PREFIX = "arbitrary..";
var createClassGroupUtils = /* @__PURE__ */ __name((config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = /* @__PURE__ */ __name((className) => {
    if (className.startsWith("[") && className.endsWith("]")) {
      return getGroupIdForArbitraryProperty(className);
    }
    const classParts = className.split(CLASS_PART_SEPARATOR);
    const startIndex = classParts[0] === "" && classParts.length > 1 ? 1 : 0;
    return getGroupRecursive(classParts, startIndex, classMap);
  }, "getClassGroupId");
  const getConflictingClassGroupIds = /* @__PURE__ */ __name((classGroupId, hasPostfixModifier) => {
    if (hasPostfixModifier) {
      const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
      const baseConflicts = conflictingClassGroups[classGroupId];
      if (modifierConflicts) {
        if (baseConflicts) {
          return concatArrays(baseConflicts, modifierConflicts);
        }
        return modifierConflicts;
      }
      return baseConflicts || EMPTY_CONFLICTS;
    }
    return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
  }, "getConflictingClassGroupIds");
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}, "createClassGroupUtils");
var getGroupRecursive = /* @__PURE__ */ __name((classParts, startIndex, classPartObject) => {
  const classPathsLength = classParts.length - startIndex;
  if (classPathsLength === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[startIndex];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  if (nextClassPartObject) {
    const result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
    if (result) return result;
  }
  const validators = classPartObject.validators;
  if (validators === null) {
    return void 0;
  }
  const classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
  const validatorsLength = validators.length;
  for (let i = 0; i < validatorsLength; i++) {
    const validatorObj = validators[i];
    if (validatorObj.validator(classRest)) {
      return validatorObj.classGroupId;
    }
  }
  return void 0;
}, "getGroupRecursive");
var getGroupIdForArbitraryProperty = /* @__PURE__ */ __name((className) => className.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const content = className.slice(1, -1);
  const colonIndex = content.indexOf(":");
  const property = content.slice(0, colonIndex);
  return property ? ARBITRARY_PROPERTY_PREFIX + property : void 0;
})(), "getGroupIdForArbitraryProperty");
var createClassMap = /* @__PURE__ */ __name((config) => {
  const {
    theme,
    classGroups
  } = config;
  return processClassGroups(classGroups, theme);
}, "createClassMap");
var processClassGroups = /* @__PURE__ */ __name((classGroups, theme) => {
  const classMap = createClassPartObject();
  for (const classGroupId in classGroups) {
    const group = classGroups[classGroupId];
    processClassesRecursively(group, classMap, classGroupId, theme);
  }
  return classMap;
}, "processClassGroups");
var processClassesRecursively = /* @__PURE__ */ __name((classGroup, classPartObject, classGroupId, theme) => {
  const len = classGroup.length;
  for (let i = 0; i < len; i++) {
    const classDefinition = classGroup[i];
    processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
  }
}, "processClassesRecursively");
var processClassDefinition = /* @__PURE__ */ __name((classDefinition, classPartObject, classGroupId, theme) => {
  if (typeof classDefinition === "string") {
    processStringDefinition(classDefinition, classPartObject, classGroupId);
    return;
  }
  if (typeof classDefinition === "function") {
    processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
    return;
  }
  processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
}, "processClassDefinition");
var processStringDefinition = /* @__PURE__ */ __name((classDefinition, classPartObject, classGroupId) => {
  const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
  classPartObjectToEdit.classGroupId = classGroupId;
}, "processStringDefinition");
var processFunctionDefinition = /* @__PURE__ */ __name((classDefinition, classPartObject, classGroupId, theme) => {
  if (isThemeGetter(classDefinition)) {
    processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
    return;
  }
  if (classPartObject.validators === null) {
    classPartObject.validators = [];
  }
  classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
}, "processFunctionDefinition");
var processObjectDefinition = /* @__PURE__ */ __name((classDefinition, classPartObject, classGroupId, theme) => {
  const entries = Object.entries(classDefinition);
  const len = entries.length;
  for (let i = 0; i < len; i++) {
    const [key, value] = entries[i];
    processClassesRecursively(value, getPart(classPartObject, key), classGroupId, theme);
  }
}, "processObjectDefinition");
var getPart = /* @__PURE__ */ __name((classPartObject, path) => {
  let current = classPartObject;
  const parts = path.split(CLASS_PART_SEPARATOR);
  const len = parts.length;
  for (let i = 0; i < len; i++) {
    const part = parts[i];
    let next = current.nextPart.get(part);
    if (!next) {
      next = createClassPartObject();
      current.nextPart.set(part, next);
    }
    current = next;
  }
  return current;
}, "getPart");
var isThemeGetter = /* @__PURE__ */ __name((func) => "isThemeGetter" in func && func.isThemeGetter === true, "isThemeGetter");
var createLruCache = /* @__PURE__ */ __name((maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: /* @__PURE__ */ __name(() => void 0, "get"),
      set: /* @__PURE__ */ __name(() => {
      }, "set")
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ Object.create(null);
  let previousCache = /* @__PURE__ */ Object.create(null);
  const update = /* @__PURE__ */ __name((key, value) => {
    cache[key] = value;
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ Object.create(null);
    }
  }, "update");
  return {
    get(key) {
      let value = cache[key];
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache[key]) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (key in cache) {
        cache[key] = value;
      } else {
        update(key, value);
      }
    }
  };
}, "createLruCache");
var IMPORTANT_MODIFIER = "!";
var MODIFIER_SEPARATOR = ":";
var EMPTY_MODIFIERS = [];
var createResultObject = /* @__PURE__ */ __name((modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) => ({
  modifiers,
  hasImportantModifier,
  baseClassName,
  maybePostfixModifierPosition,
  isExternal
}), "createResultObject");
var createParseClassName = /* @__PURE__ */ __name((config) => {
  const {
    prefix,
    experimentalParseClassName
  } = config;
  let parseClassName = /* @__PURE__ */ __name((className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let parenDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    const len = className.length;
    for (let index = 0; index < len; index++) {
      const currentCharacter = className[index];
      if (bracketDepth === 0 && parenDepth === 0) {
        if (currentCharacter === MODIFIER_SEPARATOR) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + 1;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") bracketDepth++;
      else if (currentCharacter === "]") bracketDepth--;
      else if (currentCharacter === "(") parenDepth++;
      else if (currentCharacter === ")") parenDepth--;
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
    let baseClassName = baseClassNameWithImportantModifier;
    let hasImportantModifier = false;
    if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
      baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
      hasImportantModifier = true;
    } else if (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)
    ) {
      baseClassName = baseClassNameWithImportantModifier.slice(1);
      hasImportantModifier = true;
    }
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
  }, "parseClassName");
  if (prefix) {
    const fullPrefix = prefix + MODIFIER_SEPARATOR;
    const parseClassNameOriginal = parseClassName;
    parseClassName = /* @__PURE__ */ __name((className) => className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, void 0, true), "parseClassName");
  }
  if (experimentalParseClassName) {
    const parseClassNameOriginal = parseClassName;
    parseClassName = /* @__PURE__ */ __name((className) => experimentalParseClassName({
      className,
      parseClassName: parseClassNameOriginal
    }), "parseClassName");
  }
  return parseClassName;
}, "createParseClassName");
var createSortModifiers = /* @__PURE__ */ __name((config) => {
  const modifierWeights = /* @__PURE__ */ new Map();
  config.orderSensitiveModifiers.forEach((mod, index) => {
    modifierWeights.set(mod, 1e6 + index);
  });
  return (modifiers) => {
    const result = [];
    let currentSegment = [];
    for (let i = 0; i < modifiers.length; i++) {
      const modifier = modifiers[i];
      const isArbitrary = modifier[0] === "[";
      const isOrderSensitive = modifierWeights.has(modifier);
      if (isArbitrary || isOrderSensitive) {
        if (currentSegment.length > 0) {
          currentSegment.sort();
          result.push(...currentSegment);
          currentSegment = [];
        }
        result.push(modifier);
      } else {
        currentSegment.push(modifier);
      }
    }
    if (currentSegment.length > 0) {
      currentSegment.sort();
      result.push(...currentSegment);
    }
    return result;
  };
}, "createSortModifiers");
var createConfigUtils = /* @__PURE__ */ __name((config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  sortModifiers: createSortModifiers(config),
  postfixLookupClassGroupIds: createPostfixLookupClassGroupIds(config),
  ...createClassGroupUtils(config)
}), "createConfigUtils");
var createPostfixLookupClassGroupIds = /* @__PURE__ */ __name((config) => {
  const lookup = /* @__PURE__ */ Object.create(null);
  const classGroupIds = config.postfixLookupClassGroups;
  if (classGroupIds) {
    for (let i = 0; i < classGroupIds.length; i++) {
      lookup[classGroupIds[i]] = true;
    }
  }
  return lookup;
}, "createPostfixLookupClassGroupIds");
var SPLIT_CLASSES_REGEX = /\s+/;
var mergeClassList = /* @__PURE__ */ __name((classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds,
    sortModifiers,
    postfixLookupClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      isExternal,
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    if (isExternal) {
      result = originalClassName + (result.length > 0 ? " " + result : result);
      continue;
    }
    let hasPostfixModifier = !!maybePostfixModifierPosition;
    let classGroupId;
    if (hasPostfixModifier) {
      const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
      classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
      const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : void 0;
      if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
        classGroupId = classGroupIdWithPostfix;
        hasPostfixModifier = false;
      }
    } else {
      classGroupId = getClassGroupId(baseClassName);
    }
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = modifiers.length === 0 ? "" : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.indexOf(classId) > -1) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
}, "mergeClassList");
var twJoin = /* @__PURE__ */ __name((...classLists) => {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < classLists.length) {
    if (argument = classLists[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}, "twJoin");
var toValue = /* @__PURE__ */ __name((mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}, "toValue");
var createTailwindMerge = /* @__PURE__ */ __name((createConfigFirst, ...createConfigRest) => {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall;
  const initTailwindMerge = /* @__PURE__ */ __name((classList) => {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }, "initTailwindMerge");
  const tailwindMerge = /* @__PURE__ */ __name((classList) => {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }, "tailwindMerge");
  functionToCall = initTailwindMerge;
  return (...args) => functionToCall(twJoin(...args));
}, "createTailwindMerge");
var fallbackThemeArr = [];
var fromTheme = /* @__PURE__ */ __name((key) => {
  const themeGetter = /* @__PURE__ */ __name((theme) => theme[key] || fallbackThemeArr, "themeGetter");
  themeGetter.isThemeGetter = true;
  themeGetter.themeKey = key;
  return themeGetter;
}, "fromTheme");
var arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var isFraction = /* @__PURE__ */ __name((value) => fractionRegex.test(value), "isFraction");
var isNumber = /* @__PURE__ */ __name((value) => !!value && !Number.isNaN(Number(value)), "isNumber");
var isInteger = /* @__PURE__ */ __name((value) => !!value && Number.isInteger(Number(value)), "isInteger");
var isPercent = /* @__PURE__ */ __name((value) => value.endsWith("%") && isNumber(value.slice(0, -1)), "isPercent");
var isTshirtSize = /* @__PURE__ */ __name((value) => tshirtUnitRegex.test(value), "isTshirtSize");
var isAny = /* @__PURE__ */ __name(() => true, "isAny");
var isLengthOnly = /* @__PURE__ */ __name((value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
), "isLengthOnly");
var isNever = /* @__PURE__ */ __name(() => false, "isNever");
var isShadow = /* @__PURE__ */ __name((value) => shadowRegex.test(value), "isShadow");
var isImage = /* @__PURE__ */ __name((value) => imageRegex.test(value), "isImage");
var isAnyNonArbitrary = /* @__PURE__ */ __name((value) => !isArbitraryValue(value) && !isArbitraryVariable(value), "isAnyNonArbitrary");
var isNamedContainerQuery = /* @__PURE__ */ __name((value) => value.startsWith("@container") && (value[10] === "/" && value[11] !== void 0 || value[11] === "s" && value[16] !== void 0 && value.startsWith("-size/", 10) || value[11] === "n" && value[18] !== void 0 && value.startsWith("-normal/", 10)), "isNamedContainerQuery");
var isArbitrarySize = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelSize, isNever), "isArbitrarySize");
var isArbitraryValue = /* @__PURE__ */ __name((value) => arbitraryValueRegex.test(value), "isArbitraryValue");
var isArbitraryLength = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelLength, isLengthOnly), "isArbitraryLength");
var isArbitraryNumber = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelNumber, isNumber), "isArbitraryNumber");
var isArbitraryWeight = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelWeight, isAny), "isArbitraryWeight");
var isArbitraryFamilyName = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelFamilyName, isNever), "isArbitraryFamilyName");
var isArbitraryPosition = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelPosition, isNever), "isArbitraryPosition");
var isArbitraryImage = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelImage, isImage), "isArbitraryImage");
var isArbitraryShadow = /* @__PURE__ */ __name((value) => getIsArbitraryValue(value, isLabelShadow, isShadow), "isArbitraryShadow");
var isArbitraryVariable = /* @__PURE__ */ __name((value) => arbitraryVariableRegex.test(value), "isArbitraryVariable");
var isArbitraryVariableLength = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelLength), "isArbitraryVariableLength");
var isArbitraryVariableFamilyName = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelFamilyName), "isArbitraryVariableFamilyName");
var isArbitraryVariablePosition = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelPosition), "isArbitraryVariablePosition");
var isArbitraryVariableSize = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelSize), "isArbitraryVariableSize");
var isArbitraryVariableImage = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelImage), "isArbitraryVariableImage");
var isArbitraryVariableShadow = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelShadow, true), "isArbitraryVariableShadow");
var isArbitraryVariableWeight = /* @__PURE__ */ __name((value) => getIsArbitraryVariable(value, isLabelWeight, true), "isArbitraryVariableWeight");
var getIsArbitraryValue = /* @__PURE__ */ __name((value, testLabel, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
}, "getIsArbitraryValue");
var getIsArbitraryVariable = /* @__PURE__ */ __name((value, testLabel, shouldMatchNoLabel = false) => {
  const result = arbitraryVariableRegex.exec(value);
  if (result) {
    if (result[1]) {
      return testLabel(result[1]);
    }
    return shouldMatchNoLabel;
  }
  return false;
}, "getIsArbitraryVariable");
var isLabelPosition = /* @__PURE__ */ __name((label) => label === "position" || label === "percentage", "isLabelPosition");
var isLabelImage = /* @__PURE__ */ __name((label) => label === "image" || label === "url", "isLabelImage");
var isLabelSize = /* @__PURE__ */ __name((label) => label === "length" || label === "size" || label === "bg-size", "isLabelSize");
var isLabelLength = /* @__PURE__ */ __name((label) => label === "length", "isLabelLength");
var isLabelNumber = /* @__PURE__ */ __name((label) => label === "number", "isLabelNumber");
var isLabelFamilyName = /* @__PURE__ */ __name((label) => label === "family-name", "isLabelFamilyName");
var isLabelWeight = /* @__PURE__ */ __name((label) => label === "number" || label === "weight", "isLabelWeight");
var isLabelShadow = /* @__PURE__ */ __name((label) => label === "shadow", "isLabelShadow");
var getDefaultConfig = /* @__PURE__ */ __name(() => {
  const themeColor = fromTheme("color");
  const themeFont = fromTheme("font");
  const themeText = fromTheme("text");
  const themeFontWeight = fromTheme("font-weight");
  const themeTracking = fromTheme("tracking");
  const themeLeading = fromTheme("leading");
  const themeBreakpoint = fromTheme("breakpoint");
  const themeContainer = fromTheme("container");
  const themeSpacing = fromTheme("spacing");
  const themeRadius = fromTheme("radius");
  const themeShadow = fromTheme("shadow");
  const themeInsetShadow = fromTheme("inset-shadow");
  const themeTextShadow = fromTheme("text-shadow");
  const themeDropShadow = fromTheme("drop-shadow");
  const themeBlur = fromTheme("blur");
  const themePerspective = fromTheme("perspective");
  const themeAspect = fromTheme("aspect");
  const themeEase = fromTheme("ease");
  const themeAnimate = fromTheme("animate");
  const scaleBreak = /* @__PURE__ */ __name(() => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], "scaleBreak");
  const scalePosition = /* @__PURE__ */ __name(() => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], "scalePosition");
  const scalePositionWithArbitrary = /* @__PURE__ */ __name(() => [...scalePosition(), isArbitraryVariable, isArbitraryValue], "scalePositionWithArbitrary");
  const scaleOverflow = /* @__PURE__ */ __name(() => ["auto", "hidden", "clip", "visible", "scroll"], "scaleOverflow");
  const scaleOverscroll = /* @__PURE__ */ __name(() => ["auto", "contain", "none"], "scaleOverscroll");
  const scaleUnambiguousSpacing = /* @__PURE__ */ __name(() => [isArbitraryVariable, isArbitraryValue, themeSpacing], "scaleUnambiguousSpacing");
  const scaleInset = /* @__PURE__ */ __name(() => [isFraction, "full", "auto", ...scaleUnambiguousSpacing()], "scaleInset");
  const scaleGridTemplateColsRows = /* @__PURE__ */ __name(() => [isInteger, "none", "subgrid", isArbitraryVariable, isArbitraryValue], "scaleGridTemplateColsRows");
  const scaleGridColRowStartAndEnd = /* @__PURE__ */ __name(() => ["auto", {
    span: ["full", isInteger, isArbitraryVariable, isArbitraryValue]
  }, isInteger, isArbitraryVariable, isArbitraryValue], "scaleGridColRowStartAndEnd");
  const scaleGridColRowStartOrEnd = /* @__PURE__ */ __name(() => [isInteger, "auto", isArbitraryVariable, isArbitraryValue], "scaleGridColRowStartOrEnd");
  const scaleGridAutoColsRows = /* @__PURE__ */ __name(() => ["auto", "min", "max", "fr", isArbitraryVariable, isArbitraryValue], "scaleGridAutoColsRows");
  const scaleAlignPrimaryAxis = /* @__PURE__ */ __name(() => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], "scaleAlignPrimaryAxis");
  const scaleAlignSecondaryAxis = /* @__PURE__ */ __name(() => ["start", "end", "center", "stretch", "center-safe", "end-safe"], "scaleAlignSecondaryAxis");
  const scaleMargin = /* @__PURE__ */ __name(() => ["auto", ...scaleUnambiguousSpacing()], "scaleMargin");
  const scaleSizing = /* @__PURE__ */ __name(() => [isFraction, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()], "scaleSizing");
  const scaleSizingInline = /* @__PURE__ */ __name(() => [themeContainer, isFraction, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...scaleUnambiguousSpacing()], "scaleSizingInline");
  const scaleSizingBlock = /* @__PURE__ */ __name(() => [isFraction, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...scaleUnambiguousSpacing()], "scaleSizingBlock");
  const scaleColor = /* @__PURE__ */ __name(() => [themeColor, isArbitraryVariable, isArbitraryValue], "scaleColor");
  const scaleBgPosition = /* @__PURE__ */ __name(() => [...scalePosition(), isArbitraryVariablePosition, isArbitraryPosition, {
    position: [isArbitraryVariable, isArbitraryValue]
  }], "scaleBgPosition");
  const scaleBgRepeat = /* @__PURE__ */ __name(() => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], "scaleBgRepeat");
  const scaleBgSize = /* @__PURE__ */ __name(() => ["auto", "cover", "contain", isArbitraryVariableSize, isArbitrarySize, {
    size: [isArbitraryVariable, isArbitraryValue]
  }], "scaleBgSize");
  const scaleGradientStopPosition = /* @__PURE__ */ __name(() => [isPercent, isArbitraryVariableLength, isArbitraryLength], "scaleGradientStopPosition");
  const scaleRadius = /* @__PURE__ */ __name(() => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    themeRadius,
    isArbitraryVariable,
    isArbitraryValue
  ], "scaleRadius");
  const scaleBorderWidth = /* @__PURE__ */ __name(() => ["", isNumber, isArbitraryVariableLength, isArbitraryLength], "scaleBorderWidth");
  const scaleLineStyle = /* @__PURE__ */ __name(() => ["solid", "dashed", "dotted", "double"], "scaleLineStyle");
  const scaleBlendMode = /* @__PURE__ */ __name(() => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], "scaleBlendMode");
  const scaleMaskImagePosition = /* @__PURE__ */ __name(() => [isNumber, isPercent, isArbitraryVariablePosition, isArbitraryPosition], "scaleMaskImagePosition");
  const scaleBlur = /* @__PURE__ */ __name(() => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    themeBlur,
    isArbitraryVariable,
    isArbitraryValue
  ], "scaleBlur");
  const scaleRotate = /* @__PURE__ */ __name(() => ["none", isNumber, isArbitraryVariable, isArbitraryValue], "scaleRotate");
  const scaleScale = /* @__PURE__ */ __name(() => ["none", isNumber, isArbitraryVariable, isArbitraryValue], "scaleScale");
  const scaleSkew = /* @__PURE__ */ __name(() => [isNumber, isArbitraryVariable, isArbitraryValue], "scaleSkew");
  const scaleTranslate = /* @__PURE__ */ __name(() => [isFraction, "full", ...scaleUnambiguousSpacing()], "scaleTranslate");
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [isTshirtSize],
      breakpoint: [isTshirtSize],
      color: [isAny],
      container: [isTshirtSize],
      "drop-shadow": [isTshirtSize],
      ease: ["in", "out", "in-out"],
      font: [isAnyNonArbitrary],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [isTshirtSize],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [isTshirtSize],
      shadow: [isTshirtSize],
      spacing: ["px", isNumber],
      text: [isTshirtSize],
      "text-shadow": [isTshirtSize],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", isFraction, isArbitraryValue, isArbitraryVariable, themeAspect]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [isNamedContainerQuery],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isNumber, "auto", isArbitraryValue, isArbitraryVariable, themeContainer]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": scaleBreak()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": scaleBreak()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: scalePositionWithArbitrary()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: scaleOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": scaleOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": scaleOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: scaleOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": scaleOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": scaleOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: scaleInset()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": scaleInset()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": scaleInset()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: scaleInset()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": scaleInset(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: scaleInset()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": scaleInset()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": scaleInset()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: scaleInset()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: scaleInset()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: scaleInset()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: scaleInset()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [isInteger, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [isFraction, "full", "auto", themeContainer, ...scaleUnambiguousSpacing()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [isNumber, isFraction, "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [isInteger, "first", "last", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": scaleGridTemplateColsRows()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: scaleGridColRowStartAndEnd()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": scaleGridColRowStartOrEnd()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": scaleGridAutoColsRows()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": scaleGridAutoColsRows()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: scaleUnambiguousSpacing()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": scaleUnambiguousSpacing()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": scaleUnambiguousSpacing()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...scaleAlignPrimaryAxis(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...scaleAlignSecondaryAxis(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...scaleAlignPrimaryAxis()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...scaleAlignSecondaryAxis(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": scaleAlignPrimaryAxis()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...scaleAlignSecondaryAxis(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...scaleAlignSecondaryAxis()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: scaleUnambiguousSpacing()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: scaleUnambiguousSpacing()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: scaleMargin()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: scaleMargin()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: scaleMargin()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: scaleMargin()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: scaleMargin()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: scaleMargin()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: scaleMargin()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: scaleMargin()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: scaleMargin()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: scaleMargin()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: scaleMargin()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": scaleUnambiguousSpacing()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: scaleSizing()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */
      "inline-size": [{
        inline: ["auto", ...scaleSizingInline()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...scaleSizingInline()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */
      "max-inline-size": [{
        "max-inline": ["none", ...scaleSizingInline()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */
      "block-size": [{
        block: ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */
      "min-block-size": [{
        "min-block": ["auto", ...scaleSizingBlock()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */
      "max-block-size": [{
        "max-block": ["none", ...scaleSizingBlock()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [themeContainer, "screen", ...scaleSizing()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          themeContainer,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...scaleSizing()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          themeContainer,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [themeBreakpoint]
          },
          ...scaleSizing()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...scaleSizing()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", "none", ...scaleSizing()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", themeText, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [themeFontWeight, isArbitraryVariableWeight, isArbitraryWeight]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", isPercent, isArbitraryValue]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isArbitraryVariableFamilyName, isArbitraryFamilyName, themeFont]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [isArbitraryValue]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [themeTracking, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [isNumber, "none", isArbitraryVariable, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          themeLeading,
          ...scaleUnambiguousSpacing()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: scaleColor()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: scaleColor()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...scaleLineStyle(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [isNumber, "from-font", "auto", isArbitraryVariable, isArbitraryLength]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: scaleColor()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [isNumber, "auto", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: scaleUnambiguousSpacing()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [isInteger, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: scaleBgPosition()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: scaleBgRepeat()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: scaleBgSize()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, isInteger, isArbitraryVariable, isArbitraryValue],
          radial: ["", isArbitraryVariable, isArbitraryValue],
          conic: ["", isInteger, isArbitraryVariable, isArbitraryValue]
        }, isArbitraryVariableImage, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: scaleColor()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: scaleGradientStopPosition()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: scaleColor()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: scaleColor()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: scaleColor()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: scaleRadius()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": scaleRadius()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": scaleRadius()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": scaleRadius()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": scaleRadius()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": scaleRadius()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": scaleRadius()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": scaleRadius()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": scaleRadius()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": scaleRadius()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": scaleRadius()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": scaleRadius()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": scaleRadius()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": scaleRadius()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": scaleRadius()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: scaleBorderWidth()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": scaleBorderWidth()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": scaleBorderWidth()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": scaleBorderWidth()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": scaleBorderWidth()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": scaleBorderWidth()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": scaleBorderWidth()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": scaleBorderWidth()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": scaleBorderWidth()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": scaleBorderWidth()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": scaleBorderWidth()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": scaleBorderWidth()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": scaleBorderWidth()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...scaleLineStyle(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: scaleColor()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": scaleColor()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": scaleColor()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": scaleColor()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": scaleColor()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": scaleColor()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": scaleColor()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": scaleColor()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": scaleColor()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": scaleColor()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": scaleColor()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: scaleColor()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...scaleLineStyle(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", isNumber, isArbitraryVariableLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: scaleColor()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          // Deprecated since Tailwind CSS v4.0.0
          "inner",
          "none",
          themeShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: scaleColor()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", themeInsetShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": scaleColor()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: scaleBorderWidth()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: scaleColor()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [isNumber, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": scaleColor()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": scaleBorderWidth()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": scaleColor()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", themeTextShadow, isArbitraryVariableShadow, isArbitraryShadow]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": scaleColor()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...scaleBlendMode(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": scaleBlendMode()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [isNumber]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": scaleMaskImagePosition()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": scaleMaskImagePosition()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": scaleColor()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": scaleColor()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": scaleMaskImagePosition()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": scaleMaskImagePosition()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": scaleColor()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": scaleColor()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": scaleMaskImagePosition()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": scaleMaskImagePosition()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": scaleColor()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": scaleColor()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": scaleMaskImagePosition()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": scaleMaskImagePosition()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": scaleColor()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": scaleColor()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": scaleMaskImagePosition()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": scaleMaskImagePosition()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": scaleColor()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": scaleColor()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": scaleMaskImagePosition()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": scaleMaskImagePosition()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": scaleColor()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": scaleColor()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": scaleMaskImagePosition()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": scaleMaskImagePosition()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": scaleColor()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": scaleColor()
      }],
      "mask-image-radial": [{
        "mask-radial": [isArbitraryVariable, isArbitraryValue]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": scaleMaskImagePosition()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": scaleMaskImagePosition()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": scaleColor()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": scaleColor()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": scalePosition()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [isNumber]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": scaleMaskImagePosition()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": scaleMaskImagePosition()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": scaleColor()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": scaleColor()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: scaleBgPosition()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: scaleBgRepeat()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: scaleBgSize()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: scaleBlur()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          themeDropShadow,
          isArbitraryVariableShadow,
          isArbitraryShadow
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": scaleColor()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          isArbitraryVariable,
          isArbitraryValue
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": scaleBlur()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": scaleUnambiguousSpacing()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": scaleUnambiguousSpacing()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [isNumber, "initial", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", themeEase, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [isNumber, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", themeAnimate, isArbitraryVariable, isArbitraryValue]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [themePerspective, isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": scalePositionWithArbitrary()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: scaleRotate()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": scaleRotate()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": scaleRotate()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": scaleRotate()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: scaleScale()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": scaleScale()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": scaleScale()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": scaleScale()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: scaleSkew()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": scaleSkew()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": scaleSkew()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [isArbitraryVariable, isArbitraryValue, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: scalePositionWithArbitrary()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: scaleTranslate()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": scaleTranslate()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": scaleTranslate()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": scaleTranslate()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [isInteger, isArbitraryVariable, isArbitraryValue]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: scaleColor()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: scaleColor()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryVariable, isArbitraryValue]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": scaleColor()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": scaleColor()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": scaleUnambiguousSpacing()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryVariable, isArbitraryValue]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...scaleColor()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isNumber, isArbitraryVariableLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...scaleColor()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["start", "end", "right", "left"],
      "inset-y": ["inset-bs", "inset-be", "top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["ps", "pe", "pr", "pl"],
      py: ["pbs", "pbe", "pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["ms", "me", "mr", "ml"],
      my: ["mbs", "mbe", "mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-s", "border-w-e", "border-w-r", "border-w-l"],
      "border-w-y": ["border-w-bs", "border-w-be", "border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-s", "border-color-e", "border-color-r", "border-color-l"],
      "border-color-y": ["border-color-bs", "border-color-be", "border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-ms", "scroll-me", "scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-ps", "scroll-pe", "scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, "getDefaultConfig");
var mergeConfigs = /* @__PURE__ */ __name((baseConfig, {
  cacheSize,
  prefix,
  experimentalParseClassName,
  extend = {},
  override = {}
}) => {
  overrideProperty(baseConfig, "cacheSize", cacheSize);
  overrideProperty(baseConfig, "prefix", prefix);
  overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
  overrideConfigProperties(baseConfig.theme, override.theme);
  overrideConfigProperties(baseConfig.classGroups, override.classGroups);
  overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
  overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
  overrideProperty(baseConfig, "postfixLookupClassGroups", override.postfixLookupClassGroups);
  overrideProperty(baseConfig, "orderSensitiveModifiers", override.orderSensitiveModifiers);
  mergeConfigProperties(baseConfig.theme, extend.theme);
  mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
  mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
  mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
  mergeArrayProperties(baseConfig, extend, "postfixLookupClassGroups");
  mergeArrayProperties(baseConfig, extend, "orderSensitiveModifiers");
  return baseConfig;
}, "mergeConfigs");
var overrideProperty = /* @__PURE__ */ __name((baseObject, overrideKey, overrideValue) => {
  if (overrideValue !== void 0) {
    baseObject[overrideKey] = overrideValue;
  }
}, "overrideProperty");
var overrideConfigProperties = /* @__PURE__ */ __name((baseObject, overrideObject) => {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
}, "overrideConfigProperties");
var mergeConfigProperties = /* @__PURE__ */ __name((baseObject, mergeObject) => {
  if (mergeObject) {
    for (const key in mergeObject) {
      mergeArrayProperties(baseObject, mergeObject, key);
    }
  }
}, "mergeConfigProperties");
var mergeArrayProperties = /* @__PURE__ */ __name((baseObject, mergeObject, key) => {
  const mergeValue = mergeObject[key];
  if (mergeValue !== void 0) {
    baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
  }
}, "mergeArrayProperties");
var extendTailwindMerge = /* @__PURE__ */ __name((configExtension, ...createConfig) => typeof configExtension === "function" ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig), "extendTailwindMerge");

// src/utils/tailwindHelper.ts
var customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "xxs",
            "xs",
            "sm",
            "base-text",
            "2xl",
            "header-base-regular",
            "header-base-bold",
            "header-2xl-regular",
            "header-2xl-bold",
            "label-xxs-regular",
            "label-xxs-bold",
            "label-xs-regular",
            "label-xs-bold",
            "label-sm-regular",
            "label-sm-bold",
            "paragraph-xxs-regular",
            "paragraph-xxs-bold",
            "paragraph-xs-regular",
            "paragraph-xs-bold",
            "paragraph-sm-regular",
            "paragraph-sm-bold",
            "paragraph-text-base-regular",
            "paragraph-text-base-bold"
          ]
        }
      ]
    }
  }
});
var cn = /* @__PURE__ */ __name((...inputs) => {
  return customTwMerge(clsx(inputs));
}, "cn");

// src/components/Button/ButtonLoadingSpinner.tsx
import React from "react";
var ButtonLoadingSpinner = /* @__PURE__ */ __name(() => {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "aria-label": "Loading",
    role: "img"
  }, /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
    opacity: "0.4"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "currentColor",
    d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
  }));
}, "ButtonLoadingSpinner");
ButtonLoadingSpinner.displayName = "ButtonLoadingSpinner";

// src/components/Button/Button.tsx
var buttonVariants = cva("rounded-none px-6 py-3 h-[36px] flex justify-center items-center gap-2 outline-none cursor-pointer", {
  variants: {
    variant: {
      primary: [
        "bg-main-pure-black",
        "text-text-inverted",
        "text-header-base-bold",
        "[&>svg]:stroke-[2.25]"
      ],
      secondary: [
        "border border-main-pure-black",
        "bg-main-primary-white",
        "text-main-pure-black",
        "text-header-base-bold",
        "[&>svg]:stroke-[2.25]"
      ],
      noStyle: [
        "bg-transparent",
        "text-label-sm-regular",
        "text-primary",
        "[&>svg]:stroke-[1.25]"
      ]
    },
    state: {
      loading: [
        "[&>svg]:animate-spin [&>svg]:h-5 [&>svg]:w-5",
        "cursor-not-allowed"
      ],
      disabled: [
        "cursor-not-allowed",
        "text-text-disabled"
      ],
      default: ""
    },
    size: {
      small: [
        "w-fit"
      ],
      medium: [
        "min-w-[200px]"
      ]
    }
  },
  defaultVariants: {
    variant: "secondary",
    size: "medium"
  },
  compoundVariants: [
    {
      variant: [
        "primary"
      ],
      state: "disabled",
      class: [
        "bg-neutral-grey-200"
      ]
    },
    {
      variant: [
        "secondary"
      ],
      state: "disabled",
      class: [
        "border-neutral-grey-200"
      ]
    },
    {
      variant: [
        "noStyle"
      ],
      size: [
        "small"
      ],
      class: [
        "px-0"
      ]
    }
  ]
});
var Button = /* @__PURE__ */ React2.forwardRef(({ className, variant = "primary", size = "medium", asChild = false, state = "default", iconStart, iconEnd, children, ...props }, ref) => {
  const Comp = asChild ? Slot : "button";
  const hoverStyles = state == "disabled" || state == "loading" ? "cursor-not-allowed" : variant == "noStyle" ? "hover:underline" : "hover:text-base-pure-black hover:border-neutral-grey-200 hover:bg-neutral-grey-200 hover:text-main-pure-black";
  return /* @__PURE__ */ React2.createElement(Comp, {
    className: cn(buttonVariants({
      variant,
      size,
      state
    }), hoverStyles, className),
    disabled: state == "disabled" || state == "loading",
    ref,
    ...props
  }, state !== "loading" && iconStart, state == "loading" ? /* @__PURE__ */ React2.createElement(ButtonLoadingSpinner, null) : children, state !== "loading" && iconEnd);
});
Button.displayName = "Button";

// src/components/Button/IconButton.tsx
import React3 from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
var iconButtonVariants = cva("rounded-none p-1 w-fit h-fit flex justify-center items-center outline-none", {
  variants: {
    variant: {
      default: [
        "text-icon-primary",
        "bg-transparent",
        "border-none"
      ],
      inverted: [
        "text-icon-inverted",
        "bg-transparent",
        "border-none"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "text-icon-disabled"
      ],
      default: "",
      selected: ""
    },
    size: {
      small: [
        "[&>svg]:h-[18px] [&>svg]:w-[18px]"
      ],
      medium: [
        "[&>svg]:h-[24px] [&>svg]:w-[24px]"
      ]
    }
  },
  defaultVariants: {
    variant: "default",
    size: "medium"
  },
  compoundVariants: [
    {
      variant: [
        "default"
      ],
      state: "selected",
      class: [
        "bg-main-pure-black",
        "text-icon-inverted"
      ]
    },
    {
      variant: [
        "inverted"
      ],
      state: "selected",
      class: [
        "bg-main-primary-white",
        "text-icon-primary"
      ]
    }
  ]
});
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = /* @__PURE__ */ React3.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ React3.createElement(TooltipPrimitive.Content, {
  ref,
  sideOffset,
  className: cn("z-1000 max-w-[200px] text-wrap truncate rounded-none bg-[#323232] py-4 px-3 text-text-inverted text-paragraph-xxs-regular shadow-interface zoom-in-95 data-[state=closed]:zoom-out-95", className),
  ...props
}));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
var IconButton = /* @__PURE__ */ React3.forwardRef(({ className, variant = "default", size = "medium", state = "default", labelText, icon, placement = "top", contentAlign = "center", asChild = false, contentClassName, hideTooltip = false, ...props }, ref) => {
  const hoverStyles = state == "disabled" ? "cursor-not-allowed" : "hover:bg-interaction-hover hover:cursor-pointer";
  return /* @__PURE__ */ React3.createElement(TooltipProvider, {
    disableHoverableContent: true,
    ...props
  }, /* @__PURE__ */ React3.createElement(Tooltip, null, /* @__PURE__ */ React3.createElement(TooltipTrigger, {
    className: cn(iconButtonVariants({
      variant,
      size,
      state
    }), hoverStyles, className),
    disabled: state === "disabled",
    ref,
    asChild,
    ...props
  }, asChild ? /* @__PURE__ */ React3.createElement("div", null, icon) : icon), !hideTooltip && /* @__PURE__ */ React3.createElement(TooltipContent, {
    side: placement,
    align: contentAlign,
    className: contentClassName
  }, /* @__PURE__ */ React3.createElement(TooltipPrimitive.Arrow, {
    className: "fill-[#323232]"
  }), /* @__PURE__ */ React3.createElement("p", null, labelText))));
});
IconButton.displayName = "IconButton";

// src/components/Checkbox/Checkbox.tsx
import * as React4 from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

// src/components/Checkbox/checkboxVariants.ts
var checkboxWrapperVariants = cva([
  "grid gap-2 items-baseline"
], {
  variants: {
    size: {
      sm: [
        "grid-cols-[16px_auto]"
      ],
      md: [
        "grid-cols-[18px_auto]"
      ]
    }
  }
});
var checkboxVariants = cva([
  "rounded-none",
  "peer",
  "border",
  "bg-main-primary-white",
  "group",
  "outline-none"
], {
  variants: {
    variant: {
      primary: [
        "data-[state=checked]:bg-text-primary",
        "data-[state=checked]:text-main-primary-white"
      ],
      indeterminate: [
        "data-[state=checked]:bg-main-primary-white"
      ]
    },
    state: {
      default: [
        "border-text-primary",
        "data-[state=checked]:bg-text-primary",
        "data-[state=checked]:text-main-primary-white"
      ],
      disabled: [
        "cursor-not-allowed",
        "border-text-disabled",
        "data-[state=checked]:text-main-primary-white"
      ],
      error: [
        "border-signal-error",
        "text-text-error",
        "data-[state=checked]:text-main-primary-white"
      ]
    },
    size: {
      sm: [
        "h-4",
        "w-4"
      ],
      md: [
        "h-[18px]",
        "w-[18px]"
      ]
    }
  },
  compoundVariants: [
    {
      state: "default",
      variant: "indeterminate",
      className: [
        "data-[state=checked]:bg-main-primary-white"
      ]
    },
    {
      state: "disabled",
      variant: "primary",
      className: [
        "data-[state=checked]:bg-text-disabled"
      ]
    },
    {
      state: "error",
      variant: "primary",
      className: [
        "data-[state=checked]:bg-signal-error"
      ]
    }
  ]
});
var indeterminateCheckboxVariants = cva([
  "group-data-[state=indeterminate]:block group-data-[state=checked]:hidden"
], {
  variants: {
    state: {
      default: [
        "bg-text-primary"
      ],
      disabled: [
        "bg-text-disabled"
      ],
      error: [
        "bg-signal-error"
      ]
    },
    size: {
      sm: [
        "h-2",
        "w-2"
      ],
      md: [
        "h-[10px]",
        "w-[10px]"
      ]
    }
  }
});
var labelVariants = cva([
  "text-wrap",
  "self-center",
  "w-fit"
], {
  variants: {
    size: {
      sm: [
        "text-label-xs-regular"
      ],
      md: [
        "text-label-sm-regular"
      ]
    },
    state: {
      default: [
        "text-text-primary",
        "cursor-pointer"
      ],
      disabled: [
        "text-text-disabled",
        "cursor-not-allowed"
      ],
      error: [
        "text-signal-error",
        "cursor-pointer"
      ]
    }
  }
});

// src/components/Checkbox/Checkbox.tsx
var Checkbox = /* @__PURE__ */ React4.forwardRef(({ name, state = "default", size = "sm", variant = "primary", checked, label, className, containerClassName, ...props }, ref) => /* @__PURE__ */ React4.createElement("div", {
  className: cn(checkboxWrapperVariants({
    size
  }), containerClassName)
}, /* @__PURE__ */ React4.createElement(CheckboxPrimitive.Root, {
  ref,
  className: cn(checkboxVariants({
    state,
    size,
    variant: checked === "indeterminate" || variant === "indeterminate" ? "indeterminate" : "primary"
  }), className),
  checked,
  id: name,
  disabled: state === "disabled",
  ...props
}, /* @__PURE__ */ React4.createElement(CheckboxPrimitive.Indicator, {
  id: "indicator",
  className: cn("flex items-center justify-center text-current")
}, /* @__PURE__ */ React4.createElement(Check, {
  className: cn("group-data-[state=indeterminate]:hidden group-data-[state=checked]:block", size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"),
  strokeWidth: 3
}), /* @__PURE__ */ React4.createElement("div", {
  className: cn(indeterminateCheckboxVariants({
    state,
    size
  }))
}))), /* @__PURE__ */ React4.createElement("label", {
  htmlFor: name,
  className: cn(labelVariants({
    size,
    state
  }))
}, label)));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

// src/components/Checkbox/CheckboxForm.tsx
import * as React5 from "react";
import { Controller, useFormState } from "react-hook-form";

// src/utils/reactHookFormErrorHelper.ts
var checkFormErrors = /* @__PURE__ */ __name((errors, name) => {
  const nameList = name.split(".");
  const checkError = /* @__PURE__ */ __name((errors2, nameArr) => {
    if (!errors2) return false;
    const [firstKey, ...restKeys] = nameArr;
    if (restKeys.length === 0 && firstKey && errors2[firstKey] && "ref" in errors2[firstKey]) {
      return true;
    }
    if (firstKey && errors2[firstKey]) {
      return checkError(errors2[firstKey], restKeys);
    }
    return false;
  }, "checkError");
  return checkError(errors, nameList);
}, "checkFormErrors");

// src/components/Checkbox/CheckboxForm.tsx
import { ErrorMessage } from "@hookform/error-message";
import * as CheckboxPrimitive2 from "@radix-ui/react-checkbox";
import { Check as Check2 } from "lucide-react";

// src/utils/mergeRefs.ts
function isCallbackRef(ref) {
  return typeof ref === "function";
}
__name(isCallbackRef, "isCallbackRef");
function isMutableRef(ref) {
  return ref !== null && ref !== void 0 && typeof ref === "object" && "current" in ref;
}
__name(isMutableRef, "isMutableRef");
var mergeRefs = /* @__PURE__ */ __name((refs) => (value) => {
  refs.forEach((ref) => {
    if (!ref) return;
    if (isCallbackRef(ref)) {
      ref(value);
    } else if (isMutableRef(ref)) {
      ref.current = value;
    }
  });
}, "mergeRefs");

// src/components/Checkbox/CheckboxForm.tsx
var CheckboxForm = /* @__PURE__ */ React5.forwardRef(({ methods, name, checked, state = "default", size = "sm", validateFunction, onCheckedChange, label, className, containerClassName, ...props }, ref) => {
  const { control } = methods;
  const { errors } = useFormState({
    control,
    name
  });
  const areThereErrors = checkFormErrors(errors, name);
  return /* @__PURE__ */ React5.createElement("div", {
    className: "grid gap-1 w-fit"
  }, /* @__PURE__ */ React5.createElement(Controller, {
    control,
    name,
    rules: {
      validate: {
        ...validateFunction
      }
    },
    render: /* @__PURE__ */ __name(({ field: { onChange, value, ref: fieldRef } }) => {
      return /* @__PURE__ */ React5.createElement("div", {
        className: cn(checkboxWrapperVariants({
          size
        }), containerClassName)
      }, /* @__PURE__ */ React5.createElement(CheckboxPrimitive2.Root, {
        ref: mergeRefs([
          ref,
          fieldRef
        ]),
        className: cn(checkboxVariants({
          state,
          size,
          variant: checked === "indeterminate" ? "indeterminate" : "primary"
        }), className),
        checked: value,
        id: name,
        disabled: state === "disabled",
        onCheckedChange: /* @__PURE__ */ __name((checked2) => {
          onChange(checked2);
          onCheckedChange && onCheckedChange(checked2);
        }, "onCheckedChange"),
        ...props
      }, /* @__PURE__ */ React5.createElement(CheckboxPrimitive2.Indicator, {
        className: cn("flex items-center justify-center")
      }, /* @__PURE__ */ React5.createElement(Check2, {
        className: "h-4 w-4 group-data-[state=indeterminate]:hidden group-data-[state=checked]:block",
        strokeWidth: 3
      }), /* @__PURE__ */ React5.createElement("div", {
        className: cn(indeterminateCheckboxVariants({
          state,
          size
        }))
      }))), /* @__PURE__ */ React5.createElement("label", {
        htmlFor: name,
        className: cn(labelVariants({
          size,
          state: areThereErrors ? "error" : state
        }))
      }, label));
    }, "render")
  }), /* @__PURE__ */ React5.createElement(ErrorMessage, {
    errors,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React5.createElement("p", {
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }));
});
CheckboxForm.displayName = "CheckboxForm";

// src/components/TextInput/TextInput.tsx
import * as React8 from "react";

// src/components/TextInput/textInputStyleVariants.ts
var textInputVariants = cva([
  "flex",
  "gap-1",
  "items-center",
  "px-1",
  "bg-main-primary-white",
  "[&>span]:w-full",
  "focus:[&_input]:ring-0",
  "[&_input]:w-full",
  "[&_input]:bg-transparent",
  "[&_input]:py-[6px]",
  "[&_input]:px-0",
  "[&_input]:outline-0",
  "[&_input]:ring-0",
  "[&_input]:leading-5",
  "[&_input]:border-0",
  "[&_input]:text-text-primary",
  "[&_input]:overflow-hidden",
  "[&_input]:text-ellipsis",
  "[&_input]:whitespace-nowrap",
  "min-h-[36px]",
  "[&_input]:placeholder-text-disabled"
], {
  variants: {
    variant: {
      underline: [
        "border-0",
        "border-b",
        "border-main-pure-black"
      ],
      outline: [
        "border",
        "border-main-pure-black",
        "px-2"
      ],
      hot: [
        "border-0",
        "border-b",
        "border-signal-hot"
      ],
      cold: [
        "border-0",
        "border-b",
        "border-signal-cold"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "[&_input]:cursor-not-allowed",
        "bg-interaction-disabled",
        "[&_input]:text-text-disabled"
      ],
      error: [
        "[&_input]:text-text-error",
        "!border-signal-error",
        "!border"
      ],
      locked: [
        "cursor-not-allowed",
        "[&_input]:cursor-not-allowed",
        "bg-interaction-disabled",
        "[&_input]:overflow-hidden",
        "[&_input]:text-ellipsis"
      ],
      active: [
        "[&_input]:bg-main-primary-white"
      ]
    },
    textSize: {
      xs: "[&_input]:text-label-xs-regular",
      sm: "[&_input]:text-label-sm-regular"
    }
  },
  compoundVariants: [
    {
      variant: [
        "underline"
      ],
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "outline"
      ],
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "underline"
      ],
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "outline"
      ],
      state: "locked",
      class: [
        "border-none"
      ]
    }
  ]
});

// src/components/Tooltip/Tooltip.tsx
import React6 from "react";
import * as TooltipPrimitive2 from "@radix-ui/react-tooltip";
var tooltipVariants = cva("z-50 max-w-[200px] w-fit text-left overflow-hidden rounded-none py-4 px-3 text-paragraph-xxs-regular shadow-interface", {
  variants: {
    variant: {
      default: [
        "bg-neutral-grey-800",
        "text-text-inverted"
      ],
      info: [
        "bg-main-primary-white",
        "text-main-pure-black",
        "border border-2 border-signal-info"
      ]
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var TooltipProvider2 = TooltipPrimitive2.Provider;
var TooltipComponent = TooltipPrimitive2.Root;
var TooltipTrigger2 = TooltipPrimitive2.Trigger;
var TooltipContent2 = /* @__PURE__ */ React6.forwardRef(({ className, sideOffset = 4, variant, children, ...props }, ref) => /* @__PURE__ */ React6.createElement(TooltipPrimitive2.Content, {
  ref,
  sideOffset,
  className: cn(tooltipVariants({
    variant
  }), className),
  ...props
}, children));
TooltipContent2.displayName = TooltipPrimitive2.Content.displayName;
var Tooltip2 = /* @__PURE__ */ React6.forwardRef(({ className, variant = "default", content, placement = "top", contentAlign = "center", asChild = true, sideOffset = 4, disabled = false, contentClassName, children, defaultOpen, open, onOpenChange, delayDuration = 1e3, skipDelayDuration = 300, disableHoverableContent = true, ...props }, ref) => {
  return /* @__PURE__ */ React6.createElement(TooltipProvider2, {
    delayDuration,
    skipDelayDuration,
    disableHoverableContent
  }, /* @__PURE__ */ React6.createElement(TooltipComponent, {
    open: disabled ? false : open,
    defaultOpen,
    onOpenChange
  }, /* @__PURE__ */ React6.createElement(TooltipTrigger2, {
    className: cn(className),
    ref,
    asChild,
    ...props
  }, children), /* @__PURE__ */ React6.createElement(TooltipPrimitive2.Portal, null, /* @__PURE__ */ React6.createElement(TooltipContent2, {
    side: placement,
    align: contentAlign,
    sideOffset,
    className: contentClassName,
    variant
  }, /* @__PURE__ */ React6.createElement(TooltipPrimitive2.Arrow, {
    className: cn("fill-neutral-grey-800", {
      "fill-signal-info": variant === "info"
    }),
    height: 8,
    width: 16
  }), content))));
});
Tooltip2.displayName = "Tooltip";

// src/hooks/useOverflowObserver.ts
import * as React7 from "react";

// src/hooks/resizeObserverPool.ts
var ResizeObserverPool = class ResizeObserverPool2 {
  static {
    __name(this, "ResizeObserverPool");
  }
  observer = null;
  callbacks = /* @__PURE__ */ new Map();
  constructor() {
    if (typeof window === "undefined" || !window.ResizeObserver) {
      return;
    }
    this.observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const callback = this.callbacks.get(entry.target);
        if (callback) {
          callback(entry.target);
        }
      }
    });
  }
  observe(element, callback) {
    if (!this.observer) return;
    this.callbacks.set(element, callback);
    this.observer.observe(element);
  }
  unobserve(element) {
    if (!this.observer) return;
    this.callbacks.delete(element);
    this.observer.unobserve(element);
  }
  disconnect() {
    if (!this.observer) return;
    this.callbacks.clear();
    this.observer.disconnect();
  }
  get size() {
    return this.callbacks.size;
  }
};
var sharedPool = null;
function getResizeObserverPool() {
  if (!sharedPool) {
    sharedPool = new ResizeObserverPool();
  }
  return sharedPool;
}
__name(getResizeObserverPool, "getResizeObserverPool");

// src/hooks/useOverflowObserver.ts
function useOverflowObserver({ locked = false, enableOverflowDetection = false } = {}) {
  const ref = React7.useRef(null);
  const isOverflowingRef = React7.useRef(false);
  const [isOverflowing, setIsOverflowing] = React7.useState(false);
  const checkOverflow = React7.useCallback((element, currentOverflowState) => {
    const originalOverflow = element.style.overflow;
    element.style.overflow = "auto";
    const scrollWidth = element.scrollWidth;
    const clientWidth = element.clientWidth;
    if (scrollWidth === 0 || clientWidth === 0) {
      element.style.overflow = originalOverflow;
      return currentOverflowState ?? false;
    }
    const isOverflowing2 = scrollWidth > clientWidth;
    element.style.overflow = originalOverflow;
    return isOverflowing2;
  }, []);
  const updateOverflow = React7.useCallback((element) => {
    const inputElement = element;
    const newOverflowing = checkOverflow(inputElement, isOverflowingRef.current);
    if (newOverflowing !== isOverflowingRef.current) {
      isOverflowingRef.current = newOverflowing;
      setIsOverflowing(newOverflowing);
    }
  }, [
    checkOverflow
  ]);
  React7.useEffect(() => {
    if (typeof window === "undefined") return;
    const shouldObserve = locked || enableOverflowDetection;
    if (!shouldObserve) {
      if (isOverflowingRef.current) {
        isOverflowingRef.current = false;
        setIsOverflowing(false);
      }
      return;
    }
    if (!ref.current) return;
    const pool = getResizeObserverPool();
    const timeoutId = setTimeout(() => {
      if (ref.current) {
        updateOverflow(ref.current);
      }
    }, 50);
    pool.observe(ref.current, updateOverflow);
    const elementToObserve = ref.current;
    return () => {
      clearTimeout(timeoutId);
      if (elementToObserve) {
        pool.unobserve(elementToObserve);
      }
    };
  }, [
    locked,
    enableOverflowDetection,
    updateOverflow
  ]);
  const onMouseLeave = React7.useCallback(() => {
    if (ref.current && !locked && // Don't reset in locked state
    document.activeElement !== ref.current) {
      ref.current.scrollLeft = 0;
    }
  }, [
    locked
  ]);
  return {
    ref,
    isOverflowing,
    onMouseLeave
  };
}
__name(useOverflowObserver, "useOverflowObserver");

// src/components/TextInput/TextInput.tsx
import { mergeRefs as mergeRefs2 } from "react-merge-refs";
var TextInputComponent = /* @__PURE__ */ React8.forwardRef(({ name, variant = "underline", state = "active", textSize = "xs", helperText, prefixIcon, icon, errorMessage, onPrefixIconClick, onIconClick, className, placeholder, isRequired, prefix, suffix, ...props }, ref) => {
  const isControlled = props.value !== void 0;
  const { ref: overflowRef, isOverflowing } = useOverflowObserver({
    locked: state === "locked"
  });
  const mergedRef = React8.useMemo(() => mergeRefs2([
    ref,
    overflowRef
  ]), [
    ref,
    overflowRef
  ]);
  const tooltipContent = React8.useMemo(() => {
    if (state === "locked" && isOverflowing) {
      return String(props.value ?? props.defaultValue ?? "");
    }
    return null;
  }, [
    state,
    isOverflowing,
    props.value,
    props.defaultValue
  ]);
  const inputElement = /* @__PURE__ */ React8.createElement("input", {
    id: name,
    name,
    ref: mergedRef,
    type: "text",
    disabled: state == "disabled",
    readOnly: state == "locked",
    placeholder,
    "aria-invalid": state === "error",
    // ACCESSIBILITY: Use aria-errormessage for error announcements (preferred over aria-describedby)
    "aria-errormessage": state === "error" && errorMessage ? `${name}-error` : void 0,
    // ACCESSIBILITY: Use aria-describedby only for helper text
    "aria-describedby": helperText && !(state === "error" && errorMessage) ? `${name}-helper` : void 0,
    // ACCESSIBILITY: Set both required and aria-required for maximum compatibility
    required: isRequired || props.required,
    "aria-required": isRequired || props.required,
    ...props,
    // PERFORMANCE: Direct prop passing for uncontrolled inputs
    // No wrapper function = no extra render cycles
    onChange: props.onChange,
    onBlur: props.onBlur,
    ...isControlled ? {
      value: props.value
    } : {
      defaultValue: props.defaultValue
    }
  });
  const inputWithTooltip = tooltipContent !== null ? /* @__PURE__ */ React8.createElement(Tooltip2, {
    content: tooltipContent,
    delayDuration: 200,
    skipDelayDuration: 0,
    asChild: false,
    className: "w-full"
  }, /* @__PURE__ */ React8.createElement("span", {
    className: "w-full"
  }, inputElement)) : inputElement;
  return /* @__PURE__ */ React8.createElement("div", {
    className: "grid gap-1 w-full"
  }, /* @__PURE__ */ React8.createElement("div", {
    className: cn(textInputVariants({
      variant,
      state,
      textSize
    }), className)
  }, prefixIcon && /* @__PURE__ */ React8.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-icon-primary p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onPrefixIconClick
    }),
    onClick: onPrefixIconClick,
    "aria-label": "Icon action",
    tabIndex: onPrefixIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, prefixIcon), prefix && /* @__PURE__ */ React8.createElement("div", {
    className: cn("p-0 prefix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "prefix"
  }, prefix), inputWithTooltip, icon && /* @__PURE__ */ React8.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-icon-primary p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onIconClick
    }),
    onClick: onIconClick,
    "aria-label": "Icon action",
    tabIndex: onIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, icon), suffix && /* @__PURE__ */ React8.createElement("div", {
    className: cn("p-0 suffix border-0 bg-transparent outline-none text-text-disabled ", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "suffix"
  }, suffix)), helperText && !(state === "error" && errorMessage) && /* @__PURE__ */ React8.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right break-words"
  }, helperText), state === "error" && errorMessage && /* @__PURE__ */ React8.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error break-words"
  }, errorMessage));
});
TextInputComponent.displayName = "TextInput";
var TextInput = /* @__PURE__ */ React8.memo(TextInputComponent);

// src/components/TextInput/TextInputForm.tsx
import * as React9 from "react";
import { useWatch } from "react-hook-form";

// src/hooks/useFormFieldState.ts
import { useFormState as useFormState2 } from "react-hook-form";
function useFormFieldState({ control, name }) {
  const { errors } = useFormState2({
    control,
    name
  });
  const fieldError = name.split(".").reduce((acc, key) => {
    return acc?.[key];
  }, errors);
  return {
    error: fieldError,
    hasError: !!fieldError
  };
}
__name(useFormFieldState, "useFormFieldState");

// src/components/TextInput/TextInputForm.tsx
import { ErrorMessage as ErrorMessage2 } from "@hookform/error-message";
import { mergeRefs as mergeRefs3 } from "react-merge-refs";
var TextInputFormComponent = /* @__PURE__ */ React9.forwardRef(({ methods, name, validationRule, validateFunction, isRequired, variant = "underline", state = "active", textSize = "xs", helperText, prefixIcon, icon, errorMessage, onPrefixIconClick, onIconClick, className, placeholder, prefix, suffix, ...props }, ref) => {
  const { register, control, formState: { errors } } = methods;
  const { hasError } = useFormFieldState({
    control,
    name
  });
  const { ref: overflowRef, isOverflowing } = useOverflowObserver({
    locked: state === "locked"
  });
  const watchedValue = useWatch({
    name,
    control,
    defaultValue: props.defaultValue || ""
  });
  const { ref: registerRef, onChange: registerOnChange, onBlur: registerOnBlur, ...registerProps } = register(name, {
    required: isRequired ? "Required field" : false,
    ...validationRule,
    validate: validateFunction
  });
  const { onChange: propsOnChange, onBlur: propsOnBlur, ...restProps } = props;
  const combinedOnChange = React9.useCallback((e) => {
    registerOnChange?.(e);
    propsOnChange?.(e);
  }, [
    registerOnChange,
    propsOnChange
  ]);
  const combinedOnBlur = React9.useCallback((e) => {
    registerOnBlur?.(e);
    propsOnBlur?.(e);
  }, [
    registerOnBlur,
    propsOnBlur
  ]);
  const mergedRef = React9.useMemo(() => mergeRefs3([
    registerRef,
    overflowRef,
    ref
  ]), [
    registerRef,
    overflowRef,
    ref
  ]);
  const tooltipContent = React9.useMemo(() => {
    if (state === "locked" && isOverflowing) {
      return String(watchedValue || props.value || props.defaultValue || "");
    }
    return null;
  }, [
    state,
    isOverflowing,
    watchedValue,
    props.value,
    props.defaultValue
  ]);
  const inputElement = /* @__PURE__ */ React9.createElement("input", {
    id: name,
    ...registerProps,
    ref: mergedRef,
    onChange: combinedOnChange,
    onBlur: combinedOnBlur,
    type: "text",
    // ACCESSIBILITY: Set aria-invalid only when there's an error
    // When no error, omit the attribute entirely (not "false")
    "aria-invalid": hasError ? "true" : void 0,
    // ACCESSIBILITY: Use aria-errormessage for error announcements (preferred over aria-describedby)
    "aria-errormessage": hasError ? `${name}-error` : void 0,
    // ACCESSIBILITY: Point to helper text when no error
    "aria-describedby": helperText && !hasError ? `${name}-helper` : void 0,
    disabled: state == "disabled",
    readOnly: state == "locked",
    placeholder,
    // ACCESSIBILITY: Set both required and aria-required for maximum compatibility
    required: isRequired,
    "aria-required": isRequired,
    ...restProps
  });
  const inputWithTooltip = tooltipContent !== null ? /* @__PURE__ */ React9.createElement(Tooltip2, {
    content: tooltipContent,
    delayDuration: 200,
    skipDelayDuration: 0,
    asChild: false,
    className: "w-full"
  }, /* @__PURE__ */ React9.createElement("span", {
    className: "w-full"
  }, inputElement)) : inputElement;
  return /* @__PURE__ */ React9.createElement("div", {
    className: "grid gap-1 w-full"
  }, /* @__PURE__ */ React9.createElement("div", {
    className: cn(textInputVariants({
      variant,
      // IMPORTANT: Show error state when form validation fails
      state: hasError ? "error" : state,
      textSize
    }), className)
  }, prefixIcon && /* @__PURE__ */ React9.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-main-pure-black p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onPrefixIconClick
    }),
    onClick: onPrefixIconClick,
    "aria-label": "Icon action",
    tabIndex: onPrefixIconClick ? 0 : -1,
    disabled: state === "disabled"
  }, prefixIcon), prefix && /* @__PURE__ */ React9.createElement("div", {
    className: cn("p-0 prefix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "prefix"
  }, prefix), inputWithTooltip, icon && /* @__PURE__ */ React9.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-main-pure-black p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onIconClick
    }),
    onClick: onIconClick,
    "aria-label": "Icon action",
    tabIndex: onIconClick ? 0 : -1,
    disabled: state === "disabled"
  }, icon), suffix && /* @__PURE__ */ React9.createElement("div", {
    className: cn("p-0 suffix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "suffix"
  }, suffix)), helperText && !hasError && !(state === "error" && errorMessage) && /* @__PURE__ */ React9.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right break-words"
  }, helperText), /* @__PURE__ */ React9.createElement(ErrorMessage2, {
    errors,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React9.createElement("p", {
      id: `${name}-error`,
      role: "alert",
      className: "text-label-xxs-regular text-text-error break-words"
    }, message), "render")
  }), !hasError && errorMessage && /* @__PURE__ */ React9.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error break-words"
  }, errorMessage));
});
TextInputFormComponent.displayName = "TextInputForm";
var TextInputForm = /* @__PURE__ */ React9.memo(TextInputFormComponent);

// src/components/Textarea/Textarea.tsx
import * as React10 from "react";
import TextareaAutosize from "react-textarea-autosize";

// src/components/Textarea/textareaStyleVariants.ts
var textareaVariants = cva([
  "w-full",
  "h-full",
  "bg-main-primary-white",
  "text-text-primary",
  "focus:ring-0",
  "py-2",
  "ring-none",
  "outline-none",
  "border-0",
  "placeholder-text-disabled",
  "rounded-none"
], {
  variants: {
    variant: {
      underline: [
        "border border-transparent",
        "border-b border-b-main-pure-black",
        "px-1",
        "focus:border",
        "focus:border-main-pure-black"
      ],
      outline: [
        "border border-main-pure-black",
        "px-2",
        "focus:border",
        "focus:border-main-pure-black"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-disabled",
        "border-none"
      ],
      error: [
        "border border-signal-error",
        "text-text-error"
      ],
      locked: [
        "cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-primary",
        "border-none"
      ],
      default: ""
    },
    size: {
      xs: [
        "text-paragraph-xs-regular"
      ],
      sm: [
        "text-paragraph-sm-regular"
      ]
    },
    heightType: {
      resizable: "resize",
      nonResizable: [
        "resize-none",
        "text-wrap"
      ],
      growth: [
        "resize-none"
      ]
    }
  }
});

// src/components/Textarea/Textarea.tsx
var TextareaComponent = /* @__PURE__ */ React10.forwardRef(({ name, variant = "outline", state = "default", size = "xs", heightType = "resizable", helperText, errorMessage, placeholder, className, containerClassName, ...props }, ref) => {
  const ariaDescribedBy = React10.useMemo(() => errorMessage ? `${name}-error` : helperText ? `${name}-helper` : void 0, [
    name,
    errorMessage,
    helperText
  ]);
  const textareaClassName = React10.useMemo(() => cn(textareaVariants({
    variant,
    state,
    size,
    heightType
  }), className), [
    variant,
    state,
    size,
    heightType,
    className
  ]);
  const commonProps = {
    id: name,
    name,
    placeholder,
    ref,
    disabled: state === "disabled",
    readOnly: state === "locked",
    "aria-invalid": state === "error",
    "aria-describedby": ariaDescribedBy,
    className: textareaClassName,
    ...props
  };
  return /* @__PURE__ */ React10.createElement("div", {
    className: cn("flex flex-col", containerClassName)
  }, heightType != "growth" ? /* @__PURE__ */ React10.createElement("textarea", commonProps) : /* @__PURE__ */ React10.createElement(TextareaAutosize, commonProps), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React10.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : null, errorMessage ? /* @__PURE__ */ React10.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : null);
});
TextareaComponent.displayName = "Textarea";
var Textarea = /* @__PURE__ */ React10.memo(TextareaComponent);

// src/components/Textarea/TextareaForm.tsx
import * as React11 from "react";
import TextareaAutosize2 from "react-textarea-autosize";
import { useFormState as useFormState3 } from "react-hook-form";
import { ErrorMessage as ErrorMessage3 } from "@hookform/error-message";
import { mergeRefs as mergeRefs4 } from "react-merge-refs";
var TextareaFormComponent = /* @__PURE__ */ React11.forwardRef(({ name, methods, variant = "outline", state = "default", size = "xs", heightType = "resizable", helperText, errorMessage, placeholder, isRequired, validationRule, validateFunction, className, containerClassName, ...props }, ref) => {
  const { register, control } = methods;
  const { errors } = useFormState3({
    control,
    name
  });
  const areThereErrors = checkFormErrors(errors, name);
  const validationRules = React11.useMemo(() => ({
    required: isRequired ? "Required field" : false,
    ...validationRule,
    validate: validateFunction
  }), [
    isRequired,
    validationRule,
    validateFunction
  ]);
  const { ref: registerRef, ...restRegister } = register(name, validationRules);
  const textareaClassName = React11.useMemo(() => cn(textareaVariants({
    variant,
    state: areThereErrors ? "error" : state,
    size,
    heightType
  }), className), [
    variant,
    areThereErrors,
    state,
    size,
    heightType,
    className
  ]);
  const mergedRef = React11.useMemo(() => mergeRefs4([
    registerRef,
    ref
  ]), [
    registerRef,
    ref
  ]);
  const commonProps = {
    id: name,
    ref: mergedRef,
    placeholder,
    disabled: state === "disabled",
    readOnly: state === "locked",
    className: textareaClassName,
    ...props
  };
  return /* @__PURE__ */ React11.createElement("div", {
    className: cn("flex flex-col", containerClassName)
  }, heightType != "growth" ? /* @__PURE__ */ React11.createElement("textarea", {
    ...restRegister,
    ...commonProps
  }) : /* @__PURE__ */ React11.createElement(TextareaAutosize2, {
    ...restRegister,
    ...commonProps
  }), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React11.createElement("p", {
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : null, /* @__PURE__ */ React11.createElement(ErrorMessage3, {
    errors,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React11.createElement("p", {
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }), errorMessage ? /* @__PURE__ */ React11.createElement("p", {
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : null);
});
TextareaFormComponent.displayName = "TextareaForm";
var TextareaForm = /* @__PURE__ */ React11.memo(TextareaFormComponent);

// src/components/NumberInput/NumberInput.tsx
import React14 from "react";

// src/components/NumberInput/numberInputStyleVariant.ts
var numberInputVariants = cva([
  "flex",
  "gap-1",
  "items-center",
  "px-1",
  "bg-main-primary-white",
  "focus:[&>input]:ring-0",
  "[&>input]:w-full",
  "[&>input]:bg-transparent",
  "[&>input]:py-[6px]",
  "[&>input]:px-0",
  "[&>input]:outline-0",
  "[&>input]:ring-0",
  "[&>input]:leading-5",
  "[&>input]:border-0",
  "min-h-[36px]",
  "[&>input]:placeholder-text-disabled",
  "text-[length:inherit]"
], {
  variants: {
    variant: {
      underline: [
        "border-0 border-b border-main-pure-black"
      ],
      outline: [
        "border border-main-pure-black focus:border-main-pure-black",
        "px-2"
      ],
      hot: [
        "border-0 border-b border-signal-hot focus:border-signal-hot"
      ],
      cold: [
        "border-0 border-b border-signal-cold focus:border-signal-cold"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "[&>input]:cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-disabled"
      ],
      error: [
        "text-text-error",
        "border-signal-error",
        "border"
      ],
      locked: [
        "cursor-not-allowed",
        "[&>input]:cursor-not-allowed",
        "bg-interaction-disabled"
      ],
      active: [
        "bg-main-primary-white"
      ]
    },
    textSize: {
      xs: "[&>input]:text-label-xs-regular",
      sm: "[&>input]:text-label-sm-regular"
    }
  },
  compoundVariants: [
    {
      variant: [
        "underline"
      ],
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "outline"
      ],
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "underline"
      ],
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: [
        "outline"
      ],
      state: "locked",
      class: [
        "border-none"
      ]
    }
  ]
});

// src/components/NumberInput/useNumberInput.ts
import React12 from "react";

// src/utils/formatNumber.ts
function isString(value) {
  return typeof value === "string";
}
__name(isString, "isString");
var sanitizeNumericInput = /* @__PURE__ */ __name((value) => {
  let sanitized = value.replace(/^,/, "");
  sanitized = sanitized.replace(/[^0-9eE+.,-]/g, "");
  sanitized = sanitized.replace(/([eE].*)[eE]/, "$1");
  sanitized = sanitized.replace(/^[eE]|[eE]$/, "");
  sanitized = sanitized.replace(/([eE][^+-]|\.[eE])/g, "");
  sanitized = sanitized.replace(/(\..*)\./, "$1");
  sanitized = sanitized.replace(/([+].*[-+]|[.].*[.])/g, "");
  sanitized = sanitized.replace(/(?!^)-/g, "");
  return sanitized;
}, "sanitizeNumericInput");
var sanitizeAndHandleDecimal = /* @__PURE__ */ __name((value) => {
  if (!isString(value) || value === "") {
    return null;
  }
  let sanitized = value;
  if (sanitized.includes(",")) {
    sanitized = sanitized.replace(",", ".");
  }
  return sanitizeNumericInput(sanitized);
}, "sanitizeAndHandleDecimal");
var handleNegativeValue = /* @__PURE__ */ __name((value) => {
  if (value === void 0 || value === null) {
    return null;
  }
  let valueString = value.toString();
  const numberOfMinus = (valueString.match(/-/g) || []).length;
  if (numberOfMinus >= 2) {
    return valueString.replaceAll("-", "");
  } else if (numberOfMinus < 2) {
    if (valueString.includes("-")) {
      valueString = valueString.replaceAll("-", "");
      return "-" + valueString;
    }
  }
  return valueString;
}, "handleNegativeValue");
var formatNumber = /* @__PURE__ */ __name((inputValue) => {
  if (inputValue === void 0 || inputValue === null) {
    return null;
  }
  const value = sanitizeAndHandleDecimal(inputValue.toString());
  if (value === null) {
    return null;
  }
  if (value.endsWith(".") || value === "-" || // This is to handle the case when user type 9.90(....) or 9.01. It allow user to type the 0.
  // We handle the part where user just type an 0 at the end in onBlur
  value.endsWith("0") || // This is to handle the case when the value is 54
  // and the user move to front and want to add 0. to create 0.54
  value.startsWith("0") || // This is to handle the case when the value is -54
  // and the user move to front and want to add 0. to create -0.54
  value.startsWith("-0") || // This is to handle the case when user type 1.54
  // and the user move to front and remove 1 and changing to another number
  value.startsWith(".") || // This is to handle the case when user type -1.54
  // and the user move to front and remove 1 and changing to another number
  value.startsWith("-.")) {
    return value;
  }
  const number = parseFloat(value);
  return number;
}, "formatNumber");

// src/utils/roundNumber.ts
function isValidNumber(value) {
  return typeof value === "number" && !isNaN(value) && isFinite(value);
}
__name(isValidNumber, "isValidNumber");
var countLeadingZeros = /* @__PURE__ */ __name((decimalPart) => {
  let count = 0;
  for (const char of decimalPart) {
    if (char === "0") {
      count++;
    } else {
      break;
    }
  }
  return count;
}, "countLeadingZeros");
var getNumberParts = /* @__PURE__ */ __name((value) => {
  if (value === void 0 || value === null) return null;
  const numberComposition = value.toString().split(".");
  return {
    integerPart: Math.floor(parseFloat(value)),
    decimalPart: numberComposition[1] || "",
    numberComposition
  };
}, "getNumberParts");
var roundNumberToPrecision = /* @__PURE__ */ __name((number, precision) => {
  if (!isValidNumber(number)) return null;
  precision = precision == null ? 0 : precision >= 0 ? Math.min(precision, 292) : Math.max(precision, -292);
  if (precision) {
    const factor = Math.pow(10, precision);
    const adjustedNumber = number * factor;
    const roundedValue = Math.sign(number) * Math.round(Math.abs(adjustedNumber));
    return roundedValue / factor;
  }
  return Math.sign(number) * Math.round(Math.abs(number));
}, "roundNumberToPrecision");
var dynamicRoundingNumber = /* @__PURE__ */ __name((value) => {
  if (value === void 0 || value === null) {
    return null;
  }
  const numberParts = getNumberParts(value);
  let integerPart, numberComposition;
  if (numberParts) {
    integerPart = numberParts.integerPart;
    numberComposition = numberParts.numberComposition;
  } else {
    return null;
  }
  if (numberComposition.length > 1) {
    if (numberComposition[1] && numberComposition[1].trim().length === 0) {
      return null;
    }
    const onlyZerosRegex = /^0+$/;
    if (numberComposition[1] && onlyZerosRegex.test(numberComposition[1])) {
      if (numberComposition[1] && numberComposition[1].length > 2 && integerPart > 0) {
        return parseFloat(value).toFixed(2);
      } else {
        return value;
      }
    }
  }
  const number = parseFloat(value);
  if (integerPart > 0) {
    return roundNumberToPrecision(number, 2);
  } else {
    const decimalPart = number.toString().split(".")[1] || "";
    const leadingZeros = countLeadingZeros(decimalPart);
    if (leadingZeros > 0) {
      const roundingPosition = leadingZeros + 2;
      return roundNumberToPrecision(number, roundingPosition);
    } else {
      return roundNumberToPrecision(number, 2);
    }
  }
}, "dynamicRoundingNumber");
var getPrecision = /* @__PURE__ */ __name((value) => {
  if (value === void 0 || value === null) {
    return null;
  }
  const numberParts = getNumberParts(value);
  let integerPart, numberComposition, decimalPart;
  if (numberParts) {
    integerPart = numberParts.integerPart;
    numberComposition = numberParts.numberComposition;
    decimalPart = numberParts.decimalPart;
  } else {
    return null;
  }
  if (numberComposition.length > 1) {
    if (numberComposition[1] && numberComposition[1].trim().length === 0) {
      return null;
    }
    const onlyZerosRegex = /^0+$/;
    if (numberComposition[1] && onlyZerosRegex.test(numberComposition[1])) {
      return 0;
    }
  }
  if (integerPart > 0) {
    return 2;
  } else {
    const leadingZeros = countLeadingZeros(decimalPart);
    if (leadingZeros > 0) {
      const roundingPosition = leadingZeros + 2;
      return roundingPosition;
    } else {
      return 2;
    }
  }
}, "getPrecision");

// src/components/NumberInput/useNumberInput.ts
function useNumberInput({ allowNegative = true, precision, value, onValueChange }) {
  const [inputValue, setInputValue] = React12.useState(value ?? "");
  const cursorRef = React12.useRef(null);
  React12.useEffect(() => {
    if (value !== void 0 && value !== null) {
      setInputValue(value);
    } else {
      setInputValue(null);
    }
  }, [
    value
  ]);
  const handleChange = React12.useCallback((rawValue) => {
    let formattedValue;
    if (allowNegative) {
      if (rawValue.includes("-")) {
        formattedValue = handleNegativeValue(rawValue);
      } else {
        formattedValue = rawValue;
      }
    } else {
      formattedValue = rawValue.includes("-") ? rawValue.replaceAll("-", "") : rawValue;
    }
    formattedValue = formatNumber(formattedValue);
    if (formattedValue !== inputValue) {
      setInputValue(formattedValue);
      onValueChange?.(formattedValue);
    }
    return formattedValue;
  }, [
    allowNegative,
    inputValue,
    onValueChange
  ]);
  const handleBlur = React12.useCallback((value2) => {
    let newValue = value2?.toString();
    if (!newValue) {
      return null;
    }
    if (newValue.endsWith(".")) {
      newValue = newValue.slice(0, -1);
    }
    if (/^\d+(\.0+)?$/.test(newValue)) {
      newValue = String(parseFloat(newValue));
    }
    const parsedValue = parseFloat(newValue);
    if (isNaN(parsedValue)) {
      return null;
    }
    const finalValue = precision ? roundNumberToPrecision(parsedValue, precision) : parsedValue;
    setInputValue(finalValue);
    onValueChange?.(finalValue);
    return finalValue;
  }, [
    precision,
    onValueChange
  ]);
  const displayValue = React12.useMemo(() => {
    if (inputValue === void 0 || inputValue === null || isNaN(parseFloat(inputValue.toString())) && inputValue !== "-") {
      return "";
    }
    return inputValue;
  }, [
    inputValue
  ]);
  return {
    displayValue,
    inputValue,
    handleChange,
    handleBlur,
    setInputValue,
    cursorRef
  };
}
__name(useNumberInput, "useNumberInput");

// src/components/NumberInput/NumberInput.tsx
import { mergeRefs as mergeRefs5 } from "react-merge-refs";

// src/components/NumberInput/numberInputStepperHelpers.ts
var countDecimals = /* @__PURE__ */ __name((value) => {
  const decimals = value.toString().split(".")[1];
  return decimals ? decimals.length : 0;
}, "countDecimals");
var toStepperBound = /* @__PURE__ */ __name((value) => {
  if (value === void 0 || value === null || value === "") return void 0;
  const parsedValue = Number(value);
  return isNaN(parsedValue) ? void 0 : parsedValue;
}, "toStepperBound");
var clampStepperValue = /* @__PURE__ */ __name(({ value, min, max, allowNegative = true }) => {
  const lowerBound = min ?? (allowNegative ? void 0 : 0);
  let clampedValue = value;
  if (lowerBound !== void 0 && clampedValue < lowerBound) {
    clampedValue = lowerBound;
  }
  if (max !== void 0 && clampedValue > max) {
    clampedValue = max;
  }
  return clampedValue;
}, "clampStepperValue");
var stepNumberValue = /* @__PURE__ */ __name(({ value, step, direction, min, max, precision, allowNegative = true }) => {
  const parsedValue = parseFloat(String(value ?? ""));
  const currentValue = isNaN(parsedValue) ? 0 : parsedValue;
  const decimals = precision ?? Math.max(countDecimals(currentValue), countDecimals(step));
  const steppedValue = roundNumberToPrecision(currentValue + direction * step, decimals) ?? currentValue;
  return clampStepperValue({
    value: steppedValue,
    min,
    max,
    allowNegative
  });
}, "stepNumberValue");
var getStepperAvailability = /* @__PURE__ */ __name(({ value, min, max, allowNegative = true }) => {
  const parsedValue = parseFloat(String(value ?? ""));
  if (isNaN(parsedValue)) {
    return {
      canStepUp: true,
      canStepDown: true
    };
  }
  const lowerBound = min ?? (allowNegative ? void 0 : 0);
  return {
    canStepUp: max === void 0 || parsedValue < max,
    canStepDown: lowerBound === void 0 || parsedValue > lowerBound
  };
}, "getStepperAvailability");

// src/components/NumberInput/NumberInputStepper.tsx
import React13 from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
var stepperButtonClassName = cva([
  "flex items-center justify-center p-0 border-0 bg-transparent outline-none",
  "[&>svg]:h-[18px] [&>svg]:w-[18px] [&>svg]:stroke-icon-primary"
], {
  variants: {
    state: {
      default: "cursor-pointer",
      disabled: [
        "cursor-not-allowed [&>svg]:stroke-stoke-disabled"
      ],
      locked: [
        "hidden cursor-not-allowed"
      ]
    }
  }
});
var NumberInputStepper = /* @__PURE__ */ __name(({ onStepUp, onStepDown, state, canStepUp = true, canStepDown = true, className }) => {
  const handleMouseDown = React13.useCallback((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ React13.createElement("div", {
    className: cn("flex flex-col shrink-0 self-center", className)
  }, /* @__PURE__ */ React13.createElement("button", {
    type: "button",
    className: stepperButtonClassName({
      state
    }),
    onClick: onStepUp,
    onMouseDown: handleMouseDown,
    "aria-label": "Increase value",
    tabIndex: -1,
    disabled: state == "disabled" || state == "locked" || !canStepUp
  }, /* @__PURE__ */ React13.createElement(ChevronUp, {
    height: 18,
    width: 18
  })), /* @__PURE__ */ React13.createElement("button", {
    type: "button",
    className: stepperButtonClassName({
      state
    }),
    onClick: onStepDown,
    onMouseDown: handleMouseDown,
    "aria-label": "Decrease value",
    tabIndex: -1,
    disabled: state == "disabled" || state == "locked" || !canStepDown
  }, /* @__PURE__ */ React13.createElement(ChevronDown, {
    height: 18,
    width: 18
  })));
}, "NumberInputStepper");
NumberInputStepper.displayName = "NumberInputStepper";

// src/components/NumberInput/NumberInput.tsx
var NumberInput = /* @__PURE__ */ React14.forwardRef(({ name, variant = "underline", state = "active", textSize = "xs", helperText, placeholder, icon, errorMessage, isRequired = false, precision, allowNegative = true, value, onIconClick, onValueChange, className, prefix, suffix, prefixIcon, onPrefixIconClick, containerClassName, showStepper = false, step = 1, unitConversionText, ...props }, ref) => {
  const { displayValue, handleChange, handleBlur, cursorRef, setInputValue } = useNumberInput({
    allowNegative,
    precision,
    value,
    onValueChange
  });
  const inputRef = React14.useRef(null);
  const handleInputChange = React14.useCallback((e) => {
    const { value: inputValue, selectionStart } = e.target;
    cursorRef.current = selectionStart;
    const formattedValue = handleChange(inputValue);
    requestAnimationFrame(() => {
      if (cursorRef.current !== null && inputRef.current) {
        let adjustedCursorPosition = cursorRef.current;
        if (inputValue.includes("-") && formattedValue !== null) {
          const minusCount = (inputValue.match(/-/g) || []).length;
          const formattedValueStr = formattedValue.toString();
          const formattedMinusCount = (formattedValueStr.match(/-/g) || []).length;
          if (minusCount > formattedMinusCount) {
            adjustedCursorPosition = Math.max(0, adjustedCursorPosition - (minusCount - formattedMinusCount));
          }
        }
        inputRef.current.setSelectionRange(adjustedCursorPosition, adjustedCursorPosition);
      }
    });
    if (props.onChange) {
      props.onChange(e);
    }
  }, [
    handleChange,
    cursorRef,
    props
  ]);
  const handleInputBlur = React14.useCallback((e) => {
    handleBlur(e.target.value);
    if (props.onBlur) {
      props.onBlur(e);
    }
  }, [
    handleBlur,
    props
  ]);
  const minValue = toStepperBound(props.min);
  const maxValue = toStepperBound(props.max);
  const isStepperDisabled = state === "disabled" || state === "locked";
  const { canStepUp, canStepDown } = getStepperAvailability({
    value: displayValue,
    min: minValue,
    max: maxValue,
    allowNegative
  });
  const handleStep = React14.useCallback((direction) => {
    const steppedValue = stepNumberValue({
      value: displayValue,
      step,
      direction,
      min: minValue,
      max: maxValue,
      precision,
      allowNegative
    });
    inputRef.current?.focus();
    setInputValue(steppedValue);
    onValueChange?.(steppedValue);
  }, [
    displayValue,
    step,
    minValue,
    maxValue,
    precision,
    allowNegative,
    setInputValue,
    onValueChange
  ]);
  const handleStepUp = React14.useCallback(() => handleStep(1), [
    handleStep
  ]);
  const handleStepDown = React14.useCallback(() => handleStep(-1), [
    handleStep
  ]);
  const handleKeyDown = React14.useCallback((e) => {
    if (showStepper && !isStepperDisabled && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault();
      handleStep(e.key === "ArrowUp" ? 1 : -1);
    }
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  }, [
    showStepper,
    isStepperDisabled,
    handleStep,
    props
  ]);
  return /* @__PURE__ */ React14.createElement("div", {
    className: cn("grid gap-1 w-full", containerClassName)
  }, /* @__PURE__ */ React14.createElement("div", {
    className: cn(numberInputVariants({
      variant,
      state,
      textSize
    }), className)
  }, prefixIcon && /* @__PURE__ */ React14.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-icon-primary p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onPrefixIconClick
    }),
    onClick: onPrefixIconClick,
    "aria-label": "Icon action",
    tabIndex: onPrefixIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, prefixIcon), prefix && /* @__PURE__ */ React14.createElement("div", {
    className: cn("p-0 prefix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "prefix"
  }, prefix), /* @__PURE__ */ React14.createElement("input", {
    id: name,
    name,
    ref: mergeRefs5([
      inputRef,
      ref
    ]),
    type: "text",
    disabled: state == "disabled",
    readOnly: state == "locked",
    value: displayValue,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    required: isRequired,
    min: allowNegative ? void 0 : 0,
    placeholder,
    "aria-invalid": state === "error",
    "aria-describedby": errorMessage ? `${name}-error` : helperText ? `${name}-helper` : void 0,
    inputMode: "numeric",
    ...props,
    onKeyDown: handleKeyDown
  }), icon && /* @__PURE__ */ React14.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-main-pure-black p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onIconClick
    }),
    onClick: onIconClick,
    "aria-label": "Icon action",
    tabIndex: onIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, icon), suffix && /* @__PURE__ */ React14.createElement("div", {
    className: cn("p-0 suffix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "suffix"
  }, suffix), showStepper && /* @__PURE__ */ React14.createElement(NumberInputStepper, {
    onStepUp: handleStepUp,
    onStepDown: handleStepDown,
    state: state == "active" || state == "error" ? "default" : state,
    canStepUp,
    canStepDown
  })), helperText && !(state === "error" && errorMessage) && /* @__PURE__ */ React14.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText), errorMessage && /* @__PURE__ */ React14.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage), unitConversionText && /* @__PURE__ */ React14.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary"
  }, "\u2248\xA0", unitConversionText));
});
NumberInput.displayName = "NumberInput";
var MemoizedNumberInput = /* @__PURE__ */ React14.memo(NumberInput);

// src/components/NumberInput/NumberInputForm.tsx
import React15 from "react";
import { useController, useFormState as useFormState4 } from "react-hook-form";
import { ErrorMessage as ErrorMessage4 } from "@hookform/error-message";
import { mergeRefs as mergeRefs6 } from "react-merge-refs";
var NumberInputForm = /* @__PURE__ */ React15.forwardRef(({ name, methods, variant = "underline", state = "active", textSize = "xs", helperText, placeholder, icon, errorMessage, isRequired, precision, allowNegative = true, onIconClick, onValueChange, validateFunction, defaultValue, className, prefix, suffix, prefixIcon, onPrefixIconClick, containerClassName, useDynamicRounding = true, showStepper = false, step = 1, unitConversionText, ...props }, ref) => {
  const { control } = methods;
  const { errors } = useFormState4({
    control,
    name
  });
  const { field: { onChange: fieldOnChange, onBlur: fieldOnBlur, value, ref: fieldRef } } = useController({
    name,
    control,
    defaultValue: defaultValue ?? null,
    rules: {
      required: isRequired ? "Required field" : false,
      min: props.min ? `Min value is ${props.min}` : void 0,
      max: props.max ? `Max value is ${props.max}` : void 0,
      maxLength: props.maxLength,
      minLength: props.minLength,
      validate: validateFunction
    }
  });
  const { displayValue, handleChange, handleBlur, cursorRef, setInputValue } = useNumberInput({
    allowNegative,
    precision,
    value,
    onValueChange: /* @__PURE__ */ __name((newValue) => {
      fieldOnChange(newValue);
      onValueChange?.(newValue);
    }, "onValueChange")
  });
  const [isFocused, setIsFocused] = React15.useState(false);
  const maskedDisplayValue = React15.useMemo(() => {
    if (!isFocused && useDynamicRounding && value != null) {
      const rounded = dynamicRoundingNumber(value);
      if (rounded != null) return rounded;
    }
    return displayValue;
  }, [
    isFocused,
    useDynamicRounding,
    value,
    displayValue
  ]);
  const inputRef = React15.useRef(null);
  const areThereErrors = checkFormErrors(errors, name);
  const handleInputChange = React15.useCallback((e) => {
    const { value: inputValue, selectionStart } = e.target;
    cursorRef.current = selectionStart;
    const formattedValue = handleChange(inputValue);
    requestAnimationFrame(() => {
      if (cursorRef.current !== null && inputRef.current) {
        let adjustedCursorPosition = cursorRef.current;
        if (inputValue.includes("-") && formattedValue !== null) {
          const minusCount = (inputValue.match(/-/g) || []).length;
          const formattedValueStr = formattedValue.toString();
          const formattedMinusCount = (formattedValueStr.match(/-/g) || []).length;
          if (minusCount > formattedMinusCount) {
            adjustedCursorPosition = Math.max(0, adjustedCursorPosition - (minusCount - formattedMinusCount));
          }
        }
        inputRef.current.setSelectionRange(adjustedCursorPosition, adjustedCursorPosition);
      }
    });
    if (props.onChange) {
      props.onChange(e);
    }
  }, [
    handleChange,
    cursorRef,
    props
  ]);
  const handleInputBlur = React15.useCallback((e) => {
    setIsFocused(false);
    const blurredValue = handleBlur(e.target.value);
    fieldOnChange(blurredValue);
    fieldOnBlur();
    if (props.onBlur) {
      props.onBlur(e);
    }
  }, [
    handleBlur,
    fieldOnChange,
    fieldOnBlur,
    props
  ]);
  const handleFocus = React15.useCallback((e) => {
    setIsFocused(true);
    if (useDynamicRounding && value != null) {
      const rounded = dynamicRoundingNumber(value);
      if (rounded != null) {
        setInputValue(rounded);
      }
    }
    if (props.onFocus) {
      props.onFocus(e);
    }
  }, [
    useDynamicRounding,
    value,
    setInputValue,
    props
  ]);
  const minValue = toStepperBound(props.min);
  const maxValue = toStepperBound(props.max);
  const isStepperDisabled = state === "disabled" || state === "locked";
  const { canStepUp, canStepDown } = getStepperAvailability({
    value: displayValue,
    min: minValue,
    max: maxValue,
    allowNegative
  });
  const handleStep = React15.useCallback((direction) => {
    const steppedValue = stepNumberValue({
      value: displayValue,
      step,
      direction,
      min: minValue,
      max: maxValue,
      precision,
      allowNegative
    });
    inputRef.current?.focus();
    setInputValue(steppedValue);
    fieldOnChange(steppedValue);
    onValueChange?.(steppedValue);
  }, [
    displayValue,
    step,
    minValue,
    maxValue,
    precision,
    allowNegative,
    setInputValue,
    fieldOnChange,
    onValueChange
  ]);
  const handleStepUp = React15.useCallback(() => handleStep(1), [
    handleStep
  ]);
  const handleStepDown = React15.useCallback(() => handleStep(-1), [
    handleStep
  ]);
  const handleKeyDown = React15.useCallback((e) => {
    if (showStepper && !isStepperDisabled && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault();
      handleStep(e.key === "ArrowUp" ? 1 : -1);
    }
    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  }, [
    showStepper,
    isStepperDisabled,
    handleStep,
    props
  ]);
  return /* @__PURE__ */ React15.createElement("div", {
    className: cn("grid gap-1 w-full", containerClassName)
  }, /* @__PURE__ */ React15.createElement("div", {
    className: cn(numberInputVariants({
      variant,
      state: areThereErrors ? "error" : state,
      textSize
    }), className)
  }, prefixIcon && /* @__PURE__ */ React15.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-icon-primary p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onPrefixIconClick
    }),
    onClick: onPrefixIconClick,
    "aria-label": "Icon action",
    tabIndex: onPrefixIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, prefixIcon), prefix && /* @__PURE__ */ React15.createElement("div", {
    className: cn("p-0 prefix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "prefix"
  }, prefix), /* @__PURE__ */ React15.createElement("input", {
    id: name,
    name,
    ref: mergeRefs6([
      inputRef,
      fieldRef,
      ref
    ]),
    type: "text",
    disabled: state === "disabled",
    readOnly: state === "locked",
    value: maskedDisplayValue,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    min: allowNegative ? void 0 : 0,
    placeholder,
    "aria-invalid": areThereErrors,
    "aria-describedby": areThereErrors ? `${name}-error` : helperText ? `${name}-helper` : void 0,
    inputMode: "numeric",
    ...props,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown
  }), icon && /* @__PURE__ */ React15.createElement("button", {
    type: "button",
    className: cn("[&>svg]:stroke-bold [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-main-pure-black p-0 border-0 bg-transparent cursor-pointer outline-none", {
      "[&>svg]:stroke-icon-disabled cursor-auto": !onIconClick
    }),
    onClick: onIconClick,
    "aria-label": "Icon action",
    tabIndex: onIconClick ? 0 : -1,
    disabled: state === "disabled" || state === "locked"
  }, icon), suffix && /* @__PURE__ */ React15.createElement("div", {
    className: cn("p-0 suffix border-0 bg-transparent outline-none text-text-disabled", {
      "text-label-xs-regular": textSize == "xs",
      "text-label-sm-regular": textSize == "sm"
    }),
    "aria-label": "suffix"
  }, suffix), showStepper && /* @__PURE__ */ React15.createElement(NumberInputStepper, {
    onStepUp: handleStepUp,
    onStepDown: handleStepDown,
    state: state == "active" || state == "error" ? "default" : state,
    canStepUp,
    canStepDown
  })), helperText && !areThereErrors && !errorMessage && /* @__PURE__ */ React15.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText), /* @__PURE__ */ React15.createElement(ErrorMessage4, {
    errors,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React15.createElement("p", {
      id: `${name}-error`,
      role: "alert",
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }), errorMessage && !areThereErrors && /* @__PURE__ */ React15.createElement("p", {
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage), unitConversionText && /* @__PURE__ */ React15.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary"
  }, "\u2248\xA0", unitConversionText));
});
NumberInputForm.displayName = "NumberInputForm";
var MemoizedNumberInputForm = /* @__PURE__ */ React15.memo(NumberInputForm);

// src/components/RadioButton/RadioButton.tsx
import * as React16 from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";

// src/components/RadioButton/radioButtonStyleVariant.ts
var radioPrimitiveVariants = cva([
  "aspect-square rounded-full bg-main-primary-white border focus:outline-none"
], {
  variants: {
    size: {
      small: "h-4 w-4",
      medium: "h-[18px] w-[18px]"
    },
    state: {
      default: [
        "border-text-primary"
      ],
      error: [
        "border-signal-error"
      ],
      disabled: [
        "border-text-disabled cursor-not-allowed"
      ]
    }
  }
});
var radioIndicatorVariants = cva([
  ""
], {
  variants: {
    size: {
      small: "h-2 w-2",
      medium: "h-[10px] w-[10px]"
    },
    state: {
      default: [
        "fill-text-primary stroke-text-primary"
      ],
      error: [
        "fill-signal-error stroke-signal-error"
      ],
      disabled: [
        "fill-text-disabled stroke-text-disabled cursor-not-allowed"
      ]
    }
  }
});
var radioLabelVariants = cva([
  ""
], {
  variants: {
    size: {
      small: "text-label-xs-regular",
      medium: "text-label-sm-regular"
    },
    state: {
      default: "text-primary",
      error: "text-signal-error",
      disabled: "text-text-disabled cursor-not-allowed"
    }
  }
});
var radioSecondLabelVariants = cva([
  ""
], {
  variants: {
    size: {
      small: "text-paragraph-xxs-regular",
      medium: "text-paragraph-xs-regular"
    },
    state: {
      default: "text-primary",
      error: "text-primary",
      disabled: "text-text-disabled cursor-not-allowed"
    }
  }
});

// src/components/RadioButton/RadioButton.tsx
var RadioGroup = /* @__PURE__ */ React16.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ React16.createElement(RadioGroupPrimitive.Root, {
    className: cn("grid gap-2", className),
    ...props,
    ref
  });
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = /* @__PURE__ */ React16.forwardRef(({ id, size = "small", state = "default", label, secondLabel = "", rootClassName, indicatorClassName, labelClassName, secondLabelClassName, className, ...props }, ref) => {
  return /* @__PURE__ */ React16.createElement("div", {
    className: cn("flex gap-2", rootClassName)
  }, /* @__PURE__ */ React16.createElement(RadioGroupPrimitive.Item, {
    ref,
    className: cn(radioPrimitiveVariants({
      size,
      state
    }), "peer", className),
    id,
    ...props
  }, /* @__PURE__ */ React16.createElement(RadioGroupPrimitive.Indicator, {
    className: cn("flex items-center justify-center", indicatorClassName)
  }, /* @__PURE__ */ React16.createElement(Circle, {
    className: cn(radioIndicatorVariants({
      size,
      state
    }))
  }))), /* @__PURE__ */ React16.createElement("label", {
    htmlFor: id,
    className: cn("flex flex-col gap-1 cursor-pointer peer-data-[state=checked]:[&>div]:text-label-xs-bold peer-disabled:cursor-not-allowed", {
      "peer-data-[state=checked]:[&>div]:text-label-sm-bold": size === "medium"
    })
  }, /* @__PURE__ */ React16.createElement("div", {
    className: cn(radioLabelVariants({
      size,
      state
    }), labelClassName)
  }, label), /* @__PURE__ */ React16.createElement("span", {
    className: cn(radioSecondLabelVariants({
      size,
      state
    }), secondLabelClassName)
  }, secondLabel)));
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// src/components/RadioButton/RadioButtonForm.tsx
import * as React17 from "react";
import * as RadioGroupPrimitive2 from "@radix-ui/react-radio-group";
import { Circle as Circle2 } from "lucide-react";
import { Controller as Controller2 } from "react-hook-form";
var RadioGroupForm = /* @__PURE__ */ React17.forwardRef(({ methods, name, onChange, className, ...props }, ref) => {
  const { control } = methods;
  return /* @__PURE__ */ React17.createElement(Controller2, {
    control,
    name,
    render: /* @__PURE__ */ __name(({ field: { onChange: onFormChange, value } }) => /* @__PURE__ */ React17.createElement(RadioGroupPrimitive2.Root, {
      className: cn("grid gap-2", className),
      ...props,
      ref,
      onValueChange: /* @__PURE__ */ __name((value2) => {
        onFormChange(value2);
        onChange && onChange(value2);
      }, "onValueChange"),
      value
    }), "render")
  });
});
RadioGroupForm.displayName = RadioGroupPrimitive2.Root.displayName;
var RadioGroupItemForm = /* @__PURE__ */ React17.forwardRef(({ id, size = "small", state = "default", label, secondLabel = "", rootClassName, indicatorClassName, labelClassName, secondLabelClassName, className, ...props }, ref) => {
  return /* @__PURE__ */ React17.createElement("div", {
    className: cn("flex gap-2", rootClassName)
  }, /* @__PURE__ */ React17.createElement(RadioGroupPrimitive2.Item, {
    ref,
    className: cn(radioPrimitiveVariants({
      size,
      state
    }), className),
    id,
    disabled: state === "disabled",
    ...props
  }, /* @__PURE__ */ React17.createElement(RadioGroupPrimitive2.Indicator, {
    className: cn("flex items-center justify-center", indicatorClassName)
  }, /* @__PURE__ */ React17.createElement(Circle2, {
    className: cn(radioIndicatorVariants({
      size,
      state
    }))
  }))), /* @__PURE__ */ React17.createElement("label", {
    htmlFor: id,
    className: "flex flex-col gap-2"
  }, /* @__PURE__ */ React17.createElement("div", {
    className: cn(radioLabelVariants({
      size,
      state
    }), labelClassName)
  }, label), /* @__PURE__ */ React17.createElement("div", {
    className: cn(radioSecondLabelVariants({
      size,
      state
    }), secondLabelClassName)
  }, secondLabel)));
});
RadioGroupItemForm.displayName = RadioGroupPrimitive2.Item.displayName;

// src/components/Toggle/Toggle.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import React18 from "react";

// src/components/Toggle/toggleStyleVariants.ts
var toggleRootVariant = cva([
  "peer relative flex h-9 min-w-16 w-full items-center justify-between border px-1 gap-3 transition-all",
  "data-[state=unchecked]:bg-input",
  "data-[state=checked]:bg-main-pure-black data-[state=checked]:flex-row-reverse"
], {
  variants: {
    variant: {
      line: [
        "border-main-pure-black"
      ],
      stacked: [
        "border-main-pure-black"
      ],
      hot: [
        "!bg-signal-hot !border-signal-hot"
      ],
      cold: [
        "!bg-signal-cold !border-signal-cold"
      ]
    },
    state: {
      disabled: [
        "border-interaction-disabled cursor-not-allowed",
        "data-[state=unchecked]:bg-main-primary-white",
        "data-[state=checked]:bg-interaction-disabled"
      ],
      locked: [
        "border-interaction-disabled cursor-not-allowed",
        "data-[state=unchecked]:bg-main-primary-white",
        "data-[state=checked]:bg-interaction-disabled"
      ],
      default: [
        ""
      ]
    }
  },
  compoundVariants: [
    {
      variant: "hot",
      state: "locked",
      class: [
        "justify-start data-[state=checked]:flex-row h-[25px]"
      ]
    },
    {
      variant: "cold",
      state: "locked",
      class: [
        "justify-start data-[state=checked]:flex-row h-[25px]"
      ]
    }
  ]
});
var toggleThumbVariant = cva([
  "peer absolute pointer-events-none block h-7 w-7 transition-all",
  "data-[state=unchecked]:left-1 data-[state=checked]:bg-main-primary-white data-[state=checked]:left-[calc(100%_-_32px)]"
], {
  variants: {
    variant: {
      line: [
        "bg-main-pure-black"
      ],
      stacked: [
        "bg-main-pure-black"
      ],
      hot: [
        "!bg-main-primary-white"
      ],
      cold: [
        "!bg-main-primary-white"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "data-[state=unchecked]:bg-interaction-disabled",
        "data-[state=checked]:bg-main-primary-white"
      ],
      locked: [
        "cursor-not-allowed",
        "data-[state=unchecked]:bg-interaction-disabled",
        "data-[state=checked]:bg-main-primary-white"
      ],
      default: [
        ""
      ]
    }
  },
  compoundVariants: [
    {
      variant: "hot",
      state: "locked",
      class: [
        "hidden"
      ]
    },
    {
      variant: "cold",
      state: "locked",
      class: [
        "hidden"
      ]
    }
  ]
});
var toggleTextVariant = cva("", {
  variants: {
    variant: {
      line: [
        ""
      ],
      stacked: [
        ""
      ],
      hot: [
        "!text-main-primary-white"
      ],
      cold: [
        "!text-main-primary-white"
      ]
    },
    state: {
      disabled: [
        "text-text-disabled"
      ],
      locked: [
        "text-text-primary"
      ],
      default: [
        ""
      ]
    }
  }
});

// src/components/Toggle/Toggle.tsx
var Toggle = /* @__PURE__ */ React18.forwardRef(({ ...props }, ref) => {
  const { className, rootClassName, thumbClassName, textClassName, labelClassName, label, leftOption, rightOption, variant = "line", state = "default", onCheckChange } = props;
  const isLine = variant === "line";
  const isHot = variant === "hot";
  const isCold = variant === "cold";
  const isDisabled = state === "disabled";
  const isLocked = state === "locked";
  const { label: leftLabel, value: leftValue } = leftOption;
  const { label: rightLabel, value: rightValue } = rightOption;
  return /* @__PURE__ */ React18.createElement("div", {
    ref,
    className: cn("group flex flex-col gap-2", {
      "flex-row items-center": isLine
    }, className)
  }, isLine ? /* @__PURE__ */ React18.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-xs font-bold invisible", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, leftLabel), /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-xs group-has-[button[data-state='unchecked']]:font-bold absolute top-0", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, leftLabel)) : /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-label-xs-bold break-words", toggleTextVariant({
      state,
      variant
    }), {
      "!text-signal-hot": isHot,
      "!text-signal-cold": isCold
    }, labelClassName)
  }, label), /* @__PURE__ */ React18.createElement(SwitchPrimitives.Root, {
    className: cn(toggleRootVariant({
      state,
      variant
    }), rootClassName),
    onCheckedChange: /* @__PURE__ */ __name((checked) => {
      if (isDisabled || isLocked) return;
      if (checked) return onCheckChange?.(rightValue);
      return onCheckChange?.(leftValue);
    }, "onCheckedChange"),
    disabled: isDisabled || isLocked,
    checked: props.value === rightValue,
    "aria-label": label || `Toggle between ${leftLabel} and ${rightLabel}`
  }, /* @__PURE__ */ React18.createElement(SwitchPrimitives.Thumb, {
    className: cn(toggleThumbVariant({
      state,
      variant
    }), thumbClassName)
  }), !isLine ? /* @__PURE__ */ React18.createElement(React18.Fragment, null, /* @__PURE__ */ React18.createElement("div", {
    className: cn("w-7 h-7", {
      hidden: isLocked && (isHot || isCold)
    })
  }), /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-label-xs-bold peer-data-[state=checked]:hidden whitespace-pre-wrap text-right", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, leftLabel), /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-label-xs-bold peer-data-[state=unchecked]:hidden text-text-inverted whitespace-pre-wrap text-left", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, rightLabel)) : null), isLine ? /* @__PURE__ */ React18.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-xs font-bold invisible", toggleTextVariant({
      state
    }), textClassName)
  }, rightLabel), /* @__PURE__ */ React18.createElement("div", {
    className: cn("text-xs group-has-[button[data-state='checked']]:font-bold absolute top-0", toggleTextVariant({
      state
    }), textClassName)
  }, rightLabel)) : null);
});
Toggle.displayName = "Toggle";

// src/components/Toggle/ToggleForm.tsx
import * as SwitchPrimitives2 from "@radix-ui/react-switch";
import React19 from "react";
import { Controller as Controller3 } from "react-hook-form";
var ToggleFormComponent = /* @__PURE__ */ __name(({ ...props }, ref) => {
  const { methods, name, className, rootClassName, thumbClassName, textClassName, labelClassName, label, leftOption, rightOption, variant = "line", state = "default", onCheckChange } = props;
  const { control } = methods;
  const isLine = variant === "line";
  const isHot = variant === "hot";
  const isCold = variant === "cold";
  const isDisabled = state === "disabled";
  const isLocked = state === "locked";
  const { label: leftLabel, value: leftValue } = leftOption;
  const { label: rightLabel, value: rightValue } = rightOption;
  return /* @__PURE__ */ React19.createElement("div", {
    ref,
    className: cn("group flex flex-col gap-2", {
      "flex-row items-center": isLine
    }, className)
  }, isLine ? /* @__PURE__ */ React19.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React19.createElement("div", {
    className: cn("text-xs font-bold invisible", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, leftLabel), /* @__PURE__ */ React19.createElement("div", {
    className: cn("text-xs group-has-[button[data-state='unchecked']]:font-bold absolute top-0", toggleTextVariant({
      state,
      variant
    }), textClassName)
  }, leftLabel)) : /* @__PURE__ */ React19.createElement("div", {
    className: cn("text-label-xs-bold break-words", toggleTextVariant({
      state,
      variant
    }), {
      "!text-signal-hot": isHot,
      "!text-signal-cold": isCold
    }, labelClassName)
  }, label), /* @__PURE__ */ React19.createElement(Controller3, {
    control,
    name,
    render: /* @__PURE__ */ __name(({ field: { onChange, value } }) => /* @__PURE__ */ React19.createElement(SwitchPrimitives2.Root, {
      className: cn(toggleRootVariant({
        state,
        variant
      }), rootClassName),
      checked: value === rightValue,
      onCheckedChange: /* @__PURE__ */ __name((checked) => {
        if (isDisabled || isLocked) return;
        if (checked) {
          onCheckChange && onCheckChange(rightValue);
          onChange(rightValue);
          return;
        }
        onCheckChange && onCheckChange(leftValue);
        onChange(leftValue);
      }, "onCheckedChange"),
      disabled: isDisabled || isLocked
    }, /* @__PURE__ */ React19.createElement(SwitchPrimitives2.Thumb, {
      className: cn(toggleThumbVariant({
        state,
        variant
      }), thumbClassName)
    }), !isLine ? /* @__PURE__ */ React19.createElement(React19.Fragment, null, /* @__PURE__ */ React19.createElement("div", {
      className: cn("w-7 h-7", {
        hidden: isLocked && (isHot || isCold)
      })
    }), /* @__PURE__ */ React19.createElement("div", {
      className: cn("text-label-xs-bold peer-data-[state=checked]:hidden whitespace-pre-wrap text-right", toggleTextVariant({
        state,
        variant
      }), textClassName)
    }, leftLabel), /* @__PURE__ */ React19.createElement("div", {
      className: cn("text-label-xs-bold peer-data-[state=unchecked]:hidden text-text-inverted whitespace-pre-wrap text-left", toggleTextVariant({
        state,
        variant
      }), textClassName)
    }, rightLabel)) : null), "render")
  }), isLine ? /* @__PURE__ */ React19.createElement("div", {
    className: "relative"
  }, /* @__PURE__ */ React19.createElement("div", {
    className: cn("text-xs font-bold invisible", toggleTextVariant({
      state
    }), textClassName)
  }, rightLabel), /* @__PURE__ */ React19.createElement("div", {
    className: cn("text-xs group-has-[button[data-state='checked']]:font-bold absolute top-0", toggleTextVariant({
      state
    }), textClassName)
  }, rightLabel)) : null);
}, "ToggleFormComponent");
ToggleFormComponent.displayName = "ToggleForm";
var ToggleForm = /* @__PURE__ */ React19.forwardRef(ToggleFormComponent);

// src/components/Toggle/HotAndColdToggle.tsx
import React20 from "react";
import { useWatch as useWatch2 } from "react-hook-form";
var HotAndColdToggle = /* @__PURE__ */ React20.forwardRef(({ ...props }, ref) => {
  const { methods, hotName, coldName, hotLabel, coldLabel, className, state = "default", plateSideEnum, shellSideEnum, onChangeHotSide, onChangeColdSide } = props;
  const validFieldName = hotName ?? coldName;
  const isHotFieldValid = !!hotName;
  const fieldValue = useWatch2({
    name: validFieldName ?? ""
  });
  const hotSide = isHotFieldValid ? fieldValue : fieldValue === plateSideEnum ? shellSideEnum : plateSideEnum;
  const coldSide = isHotFieldValid ? fieldValue === plateSideEnum ? shellSideEnum : plateSideEnum : fieldValue;
  const updateFormValue = /* @__PURE__ */ __name((newHotSide, newColdSide) => {
    if (validFieldName) {
      const newValue = isHotFieldValid ? newHotSide : newColdSide;
      methods.setValue(validFieldName, newValue);
    }
    onChangeHotSide?.(newHotSide);
    onChangeColdSide?.(newColdSide);
  }, "updateFormValue");
  const handleHotToggleChange = /* @__PURE__ */ __name((value) => {
    const newHotSide = typeof value === "string" ? parseInt(value) : value;
    const newColdSide = newHotSide === plateSideEnum ? shellSideEnum : plateSideEnum;
    updateFormValue(newHotSide, newColdSide);
  }, "handleHotToggleChange");
  const handleColdToggleChange = /* @__PURE__ */ __name((value) => {
    const newColdSide = typeof value === "string" ? parseInt(value) : value;
    const newHotSide = newColdSide === plateSideEnum ? shellSideEnum : plateSideEnum;
    updateFormValue(newHotSide, newColdSide);
  }, "handleColdToggleChange");
  return /* @__PURE__ */ React20.createElement("div", {
    className: cn("flex gap-5 items-end", className),
    ref
  }, /* @__PURE__ */ React20.createElement(Toggle, {
    label: hotLabel,
    leftOption: {
      label: "Shell",
      value: shellSideEnum
    },
    rightOption: {
      label: "Plate",
      value: plateSideEnum
    },
    className: "w-[85px]",
    variant: "hot",
    value: hotSide,
    state,
    onCheckChange: handleHotToggleChange
  }), /* @__PURE__ */ React20.createElement(Toggle, {
    label: coldLabel,
    leftOption: {
      label: "Shell",
      value: shellSideEnum
    },
    rightOption: {
      label: "Plate",
      value: plateSideEnum
    },
    className: "w-[85px]",
    variant: "cold",
    state,
    value: coldSide,
    onCheckChange: handleColdToggleChange
  }));
});
HotAndColdToggle.displayName = "HotAndColdToggle";

// src/components/Select/Select.tsx
import * as React21 from "react";

// src/components/Select/selectStyleVariant.ts
var selectToggleButtonVariant = cva([
  "w-full",
  "flex",
  "justify-between",
  "items-center",
  "px-1",
  "w-full"
], {
  variants: {
    variant: {
      underline: [
        "border border-transparent",
        "border-b border-b-main-pure-black",
        "bg-main-primary-white",
        "focus:border-b",
        "focus:border-b-main-pure-black"
      ],
      outline: [
        "border border-main-pure-black",
        "focus:border",
        "focus:border-main-pure-black",
        "bg-main-primary-white",
        "pl-[10px]"
      ],
      hot: [
        "border-0 border-b border-signal-hot focus:border-signal-hot"
      ],
      cold: [
        "border-0 border-b border-signal-cold focus:border-signal-cold"
      ],
      noStyle: [
        "bg-transparent"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-disabled"
      ],
      error: [
        "border-signal-error",
        "border",
        "text-text-error",
        "focus:border",
        "focus:border-signal-error"
      ],
      locked: [
        "cursor-not-allowed",
        "[&>input]:cursor-not-allowed",
        "bg-interaction-disabled"
      ],
      active: [
        ""
      ]
    },
    textSize: {
      xs: [
        "[&>div>.label]:text-label-xs-regular",
        "min-h-[36px]",
        "py-[4px]"
      ],
      sm: [
        "[&>div>.label]:text-label-sm-regular",
        "min-h-[36px]",
        "py-[2px]"
      ]
    }
  },
  compoundVariants: [
    {
      variant: "cold",
      state: "disabled",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "disabled",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "cold",
      state: "locked",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "locked",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: "noStyle",
      state: "disabled",
      class: [
        "border-none",
        "bg-transparent"
      ]
    },
    {
      variant: "noStyle",
      state: "locked",
      class: [
        "border-none",
        "bg-interaction-disabled"
      ]
    }
  ]
});
var labelWrapperVariant = cva("grid grid-cols-[2fr-1fr] justify-start items-center");
var selectOptionListVariant = cva([
  "shadow-interface",
  "absolute",
  "z-10",
  "h-fit",
  "max-h-[200px]",
  "overflow-y-auto",
  "overscroll-contain",
  "w-max",
  "max-w-[300px]",
  "min-w-full"
], {
  variants: {
    direction: {
      up: [
        "bottom-full mb-1"
      ],
      down: [
        "top-full mt-1"
      ]
    }
  }
});
var selectOptionVariant = cva([
  "px-4",
  "py-3",
  "cursor-pointer",
  "grid",
  "items-start",
  "text-left",
  "gap-[6px]",
  "bg-main-primary-white",
  "w-full"
], {
  variants: {
    textSize: {
      xs: [
        "[&>.label]:text-label-xs-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ],
      sm: [
        "[&>.label]:text-label-sm-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-main-primary-white",
        "text-text-disabled"
      ],
      active: [
        "[&>.subLabel]:text-text-secondary"
      ]
    }
  }
});

// src/components/Select/Select.tsx
import Downshift from "downshift";
import { Check as Check3, ChevronDown as ChevronDown2, ChevronUp as ChevronUp2 } from "lucide-react";
var SelectComponent = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", direction = "down", options, helperText, setFirstOption = true, placeholder, errorMessage, onSelectOption, defaultSelectedOption, selectedOption, className, iconClassName, labelClassName, disabled, ...props }, ref) => {
  const handleChange = React21.useCallback((selection) => {
    if (selection != null) {
      onSelectOption?.(selection.value);
    } else {
      onSelectOption?.(null);
    }
  }, [
    onSelectOption
  ]);
  const defaultOption = React21.useMemo(() => {
    if (defaultSelectedOption) {
      if (defaultSelectedOption.disabled) {
        return options[0];
      }
      return defaultSelectedOption;
    }
    if (setFirstOption) {
      return options[0];
    }
    return void 0;
  }, [
    defaultSelectedOption,
    options,
    setFirstOption
  ]);
  const itemToString = React21.useCallback((item) => item ? item.label : "", []);
  return /* @__PURE__ */ React21.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React21.createElement(Downshift, {
    onChange: handleChange,
    itemToString,
    ...selectedOption ? {
      selectedItem: selectedOption
    } : {
      initialSelectedItem: defaultOption
    }
  }, ({ isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, selectedItem }) => /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement("button", {
    className: cn(selectToggleButtonVariant({
      variant,
      state: disabled ? "disabled" : state,
      textSize
    })),
    ...getToggleButtonProps({
      ref,
      id: name,
      disabled: state == "disabled" || disabled || state == "locked",
      "aria-label": placeholder || "Select an option",
      "aria-invalid": state === "error",
      "aria-describedby": errorMessage ? `${name}-error` : helperText ? `${name}-helper` : void 0
    }),
    ...props
  }, /* @__PURE__ */ React21.createElement("div", {
    className: cn(labelWrapperVariant())
  }, /* @__PURE__ */ React21.createElement("div", {
    className: cn("w-full truncate text-left label", labelClassName)
  }, selectedItem ? /* @__PURE__ */ React21.createElement("span", null, selectedItem.label) : placeholder ? /* @__PURE__ */ React21.createElement("span", {
    className: "text-text-disabled"
  }, placeholder) : /* @__PURE__ */ React21.createElement("span", null, "Select an option")), selectedItem?.subLabel && /* @__PURE__ */ React21.createElement("span", {
    className: cn("w-full text-left text-text-secondary text-label-xxs-regular truncate h-fit", {
      "text-text-error": state === "error"
    })
  }, selectedItem?.subLabel)), /* @__PURE__ */ React21.createElement("div", {
    className: cn({
      "h-6": state === "locked"
    }, iconClassName)
  }, isOpen ? /* @__PURE__ */ React21.createElement(ChevronUp2, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }) : /* @__PURE__ */ React21.createElement(ChevronDown2, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }))), /* @__PURE__ */ React21.createElement("ul", {
    ...getMenuProps(),
    className: cn(selectOptionListVariant({
      direction
    }))
  }, isOpen && options.map((item, index) => /* @__PURE__ */ React21.createElement("li", {
    key: `${item.value}${index}`
  }, /* @__PURE__ */ React21.createElement("button", {
    ...getItemProps({
      item,
      index
    }),
    className: cn(selectOptionVariant({
      state: item.disabled ? "disabled" : "active",
      textSize
    }), {
      "bg-interaction-hover": highlightedIndex === index
    }),
    disabled: item.disabled
  }, /* @__PURE__ */ React21.createElement("span", {
    className: "label grid grid-cols-[1fr_16px] justify-between items-start gap-2"
  }, /* @__PURE__ */ React21.createElement("div", null, item?.label), /* @__PURE__ */ React21.createElement(Check3, {
    size: 16,
    className: cn("w-4 block", {
      hidden: selectedItem?.value !== item.value
    })
  })), item.subLabel && /* @__PURE__ */ React21.createElement("span", {
    className: "subLabel"
  }, item.subLabel))))))), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React21.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : /* @__PURE__ */ React21.createElement(React21.Fragment, null), errorMessage ? /* @__PURE__ */ React21.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : /* @__PURE__ */ React21.createElement(React21.Fragment, null, " "), /* @__PURE__ */ React21.createElement("div", {
    tabIndex: 0
  }));
}, "SelectComponent");
SelectComponent.displayName = "Select";
var SelectWithRef = /* @__PURE__ */ React21.forwardRef(SelectComponent);
var Select = /* @__PURE__ */ React21.memo(SelectWithRef);

// src/components/Select/SelectForm.tsx
import * as React23 from "react";
import { useController as useController2, useFormState as useFormState5 } from "react-hook-form";

// src/components/Select/SelectFormInput.tsx
import * as React22 from "react";
import { ErrorMessage as ErrorMessage5 } from "@hookform/error-message";
import Downshift2 from "downshift";
import { ChevronUp as ChevronUp3, ChevronDown as ChevronDown3, Check as Check4 } from "lucide-react";
var SelectFormInputComponent = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, placeholder, errorMessage, selectedItem, onSelectOption, onChangeForm, areThereErrors, formErrorMessage, disabled, className, ...props }, ref) => {
  const handleChange = React22.useCallback((selection) => {
    if (selection != null) {
      onChangeForm(selection.value);
      onSelectOption?.(selection.value);
    } else {
      onChangeForm(null);
      onSelectOption?.(null);
    }
  }, [
    onChangeForm,
    onSelectOption
  ]);
  const itemToString = React22.useCallback((item) => item ? item.label : "", []);
  const finalState = areThereErrors ? "error" : disabled ? "disabled" : state;
  return /* @__PURE__ */ React22.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React22.createElement(Downshift2, {
    onChange: handleChange,
    itemToString,
    selectedItem
  }, ({ isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, selectedItem: selectedItem2 }) => /* @__PURE__ */ React22.createElement("div", null, /* @__PURE__ */ React22.createElement("button", {
    className: cn(selectToggleButtonVariant({
      variant,
      state: finalState,
      textSize
    })),
    ...getToggleButtonProps({
      ref,
      id: name,
      disabled: state == "disabled" || disabled || state == "locked",
      "aria-label": placeholder || "Select an option",
      "aria-invalid": finalState === "error",
      "aria-describedby": errorMessage || formErrorMessage[name] ? `${name}-error` : helperText ? `${name}-helper` : void 0
    }),
    ...props
  }, /* @__PURE__ */ React22.createElement("div", {
    className: cn(labelWrapperVariant())
  }, /* @__PURE__ */ React22.createElement("div", {
    className: "h-fit w-full truncate text-left label"
  }, selectedItem2 ? /* @__PURE__ */ React22.createElement("span", null, selectedItem2.label) : placeholder ? /* @__PURE__ */ React22.createElement("span", {
    className: cn("text-text-disabled", {
      "text-text-error": finalState === "error"
    })
  }, placeholder) : /* @__PURE__ */ React22.createElement("span", null, "Select an option")), selectedItem2?.subLabel && /* @__PURE__ */ React22.createElement("span", {
    className: cn("sub-label w-full text-left text-text-secondary text-label-xxs-regular truncate h-fit", {
      "text-text-error": finalState === "error"
    })
  }, selectedItem2?.subLabel)), /* @__PURE__ */ React22.createElement("div", {
    className: cn({
      "h-6": state === "locked"
    })
  }, isOpen ? /* @__PURE__ */ React22.createElement(ChevronUp3, {
    className: cn("stroke-regular", {
      "text-icon-primary": finalState === "error",
      hidden: state === "locked"
    })
  }) : /* @__PURE__ */ React22.createElement(ChevronDown3, {
    className: cn("stroke-regular", {
      "text-icon-primary": finalState === "error",
      hidden: state === "locked"
    })
  }))), /* @__PURE__ */ React22.createElement("ul", {
    ...getMenuProps(),
    className: cn(selectOptionListVariant())
  }, isOpen && options.map((item, index) => /* @__PURE__ */ React22.createElement("li", {
    key: `${item.value}-${index}`
  }, /* @__PURE__ */ React22.createElement("button", {
    ...getItemProps({
      item,
      index
    }),
    className: cn(selectOptionVariant({
      state: item.disabled ? "disabled" : "active",
      textSize
    }), {
      "bg-interaction-hover": highlightedIndex === index
    }),
    disabled: item.disabled
  }, /* @__PURE__ */ React22.createElement("span", {
    className: "label grid grid-cols-[1fr_16px] justify-between items-start gap-2"
  }, /* @__PURE__ */ React22.createElement("div", null, item?.label), /* @__PURE__ */ React22.createElement(Check4, {
    size: 16,
    className: cn("w-4 block", {
      hidden: selectedItem2?.value !== item.value
    })
  })), item.subLabel && /* @__PURE__ */ React22.createElement("span", {
    className: "subLabel"
  }, item.subLabel))))))), helperText && !(finalState === "error" && errorMessage) ? /* @__PURE__ */ React22.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : /* @__PURE__ */ React22.createElement(React22.Fragment, null), /* @__PURE__ */ React22.createElement(ErrorMessage5, {
    errors: formErrorMessage,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React22.createElement("p", {
      id: `${name}-error`,
      role: "alert",
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }), errorMessage && !formErrorMessage[name] ? /* @__PURE__ */ React22.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : /* @__PURE__ */ React22.createElement(React22.Fragment, null, " "), /* @__PURE__ */ React22.createElement("div", {
    tabIndex: 0
  }));
}, "SelectFormInputComponent");
SelectFormInputComponent.displayName = "SelectFormInput";
var SelectFormInput = /* @__PURE__ */ React22.memo(/* @__PURE__ */ React22.forwardRef(SelectFormInputComponent));

// src/components/Select/SelectForm.tsx
var SelectFormComponent = /* @__PURE__ */ __name(({ name, methods, variant = "underline", state = "active", textSize = "xs", options, helperText, setFirstOption = true, placeholder, errorMessage, validateFunction, onSelectOption, isRequired, className, ...props }, ref) => {
  const { errors } = useFormState5({
    control: methods.control,
    name
  });
  const firstEnabled = React23.useMemo(() => options.find((o) => !o.disabled) ?? null, [
    options
  ]);
  const { field: { onChange, value } } = useController2({
    name,
    control: methods.control,
    rules: {
      validate: /* @__PURE__ */ __name((value2, formValues) => {
        if (isRequired && (value2 === "" || value2 === null || value2 === void 0)) {
          return "Required field";
        }
        if (validateFunction) {
          if (typeof validateFunction === "function") {
            return validateFunction(value2, formValues);
          } else {
            const validator = (
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              validateFunction[name]
            );
            return validator ? validator(value2, formValues) : true;
          }
        }
        return true;
      }, "validate")
    },
    defaultValue: setFirstOption ? firstEnabled?.value : void 0
  });
  React23.useEffect(() => {
    const currentOption = options.find((option) => option.value == value);
    let nextValue;
    if (currentOption && !currentOption.disabled) {
      nextValue = currentOption.value;
    } else if (setFirstOption) {
      nextValue = firstEnabled ? firstEnabled.value : null;
    } else {
      nextValue = null;
    }
    const isStillEmpty = nextValue == null && value == null;
    if (nextValue !== value && !isStillEmpty) onChange(nextValue);
  }, [
    options,
    value,
    setFirstOption,
    onChange,
    firstEnabled
  ]);
  const areThereErrors = checkFormErrors(errors, name);
  const selectedItem = React23.useMemo(() => {
    const current = options.find((o) => o.value == value);
    if (current && !current.disabled) return current;
    if (setFirstOption) return firstEnabled;
    return null;
  }, [
    options,
    value,
    setFirstOption,
    firstEnabled
  ]);
  return /* @__PURE__ */ React23.createElement(SelectFormInput, {
    ref,
    selectedItem,
    onChangeForm: onChange,
    formErrorMessage: errors,
    name,
    options,
    variant,
    state: areThereErrors ? "error" : state,
    textSize,
    helperText,
    placeholder,
    errorMessage,
    className,
    onSelectOption,
    ...props
  });
}, "SelectFormComponent");
SelectFormComponent.displayName = "SelectForm";
var SelectFormWithRef = /* @__PURE__ */ React23.forwardRef(SelectFormComponent);
var SelectForm = /* @__PURE__ */ React23.memo(SelectFormWithRef);

// src/components/Combobox/Combobox.tsx
import Downshift3 from "downshift";
import { Check as Check5, ChevronDown as ChevronDown4, ChevronUp as ChevronUp4 } from "lucide-react";
import * as React24 from "react";

// src/components/Combobox/comboboxStyleVariant.ts
var comboboxToggleButtonVariant = cva([
  "w-full",
  "flex",
  "justify-between",
  "items-center",
  "px-1"
], {
  variants: {
    variant: {
      underline: [
        "border border-transparent",
        "border-b border-b-main-pure-black",
        "bg-main-primary-white",
        "focus:border-b",
        "focus:border-b-main-pure-black"
      ],
      outline: [
        "border border-main-pure-black",
        "focus:border",
        "focus:border-main-pure-black",
        "bg-main-primary-white",
        "pl-[10px]"
      ],
      hot: [
        "border-0 border-b border-signal-hot focus:border-signal-hot"
      ],
      cold: [
        "border-0 border-b border-signal-cold focus:border-signal-cold"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-disabled"
      ],
      error: [
        "border-signal-error",
        "border",
        "text-text-error",
        "focus:border",
        "focus:border-signal-error"
      ],
      locked: [
        "cursor-not-allowed",
        "[&>input]:cursor-not-allowed",
        "bg-interaction-disabled"
      ],
      active: [
        ""
      ]
    },
    textSize: {
      xs: [
        "[&>div>.label]:text-label-xs-regular [&>input]:text-label-xs-regular",
        "min-h-[36px]",
        "py-[4px]"
      ],
      sm: [
        "[&>div>.label]:text-label-sm-regular [&>input]:text-label-sm-regular",
        "min-h-[36px]",
        "py-[2px]"
      ]
    }
  },
  compoundVariants: [
    {
      variant: "cold",
      state: "disabled",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "disabled",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "cold",
      state: "locked",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "locked",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "locked",
      class: [
        "border-none"
      ]
    }
  ]
});
var labelWrapperVariant2 = cva("grid grid-cols-[2fr-1fr] justify-start items-center");
var comboboxOptionListVariant = cva([
  "shadow-interface",
  "absolute",
  "z-10",
  "h-fit",
  "max-h-[200px]",
  "overflow-y-auto",
  "overscroll-contain",
  "w-max",
  "max-w-[300px]",
  "min-w-full"
]);
var comboboxOptionVariant = cva([
  "px-4",
  "py-3",
  "cursor-pointer",
  "grid",
  "items-start",
  "text-left",
  "gap-[6px]",
  "bg-main-primary-white",
  "w-full"
], {
  variants: {
    textSize: {
      xs: [
        "[&>.label]:text-label-xs-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ],
      sm: [
        "[&>.label]:text-label-sm-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-main-primary-white",
        "text-text-disabled"
      ],
      active: [
        "[&>.subLabel]:text-text-secondary"
      ]
    }
  }
});

// src/components/Combobox/Combobox.tsx
var ComboboxComponent = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, setFirstOption = true, placeholder, errorMessage, onSelectOption, defaultSelectedOption, className, onInputValueChange, ...props }, ref) => {
  const [inputItems, setInputItems] = React24.useState(options);
  const [isInputOverflowing, setIsInputOverflowing] = React24.useState(false);
  const getInitialValue = /* @__PURE__ */ __name(() => {
    if (defaultSelectedOption && !defaultSelectedOption.disabled) {
      return defaultSelectedOption.label;
    }
    if (setFirstOption && options[0]) {
      return options[0].label;
    }
    return "";
  }, "getInitialValue");
  const [currentInputValue, setCurrentInputValue] = React24.useState(getInitialValue());
  const inputRef = React24.useRef(null);
  const handleInputValueChange = /* @__PURE__ */ __name((inputValue) => {
    setInputItems(options.filter((item) => item.label.toLowerCase().includes(inputValue.toLowerCase())));
    onInputValueChange && onInputValueChange(inputValue);
  }, "handleInputValueChange");
  React24.useEffect(() => {
    const checkInputOverflow = /* @__PURE__ */ __name(() => {
      if (inputRef.current) {
        const input = inputRef.current;
        setIsInputOverflowing(input.scrollWidth > input.clientWidth);
      }
    }, "checkInputOverflow");
    const timer = setTimeout(checkInputOverflow, 50);
    window.addEventListener("resize", checkInputOverflow);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkInputOverflow);
    };
  }, [
    currentInputValue
  ]);
  return /* @__PURE__ */ React24.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React24.createElement(Downshift3, {
    onChange: /* @__PURE__ */ __name((selection) => {
      if (selection != null) {
        onSelectOption && onSelectOption(selection.value);
      } else {
        onSelectOption && onSelectOption(null);
      }
    }, "onChange"),
    itemToString: /* @__PURE__ */ __name((item) => item ? item.label : "", "itemToString"),
    initialSelectedItem: defaultSelectedOption ? defaultSelectedOption.disabled ? options[0] : defaultSelectedOption : setFirstOption ? options[0] : null,
    onInputValueChange: handleInputValueChange,
    onStateChange: /* @__PURE__ */ __name((changes) => {
      if (changes.inputValue !== void 0) {
        setCurrentInputValue(changes.inputValue || "");
      }
      if (changes.selectedItem !== void 0) {
        setCurrentInputValue(changes.selectedItem?.label || "");
      }
    }, "onStateChange")
  }, ({ isOpen, getToggleButtonProps, openMenu, getMenuProps, highlightedIndex, getItemProps, selectedItem, getInputProps, getRootProps, inputValue }) => {
    const inputElement = /* @__PURE__ */ React24.createElement(TextInput, {
      ...getInputProps({
        placeholder,
        ref: inputRef
      }),
      name: "combobox",
      className: cn(comboboxToggleButtonVariant({
        variant,
        state,
        textSize
      }), "pr-7 [&>input]:truncate"),
      onFocus: /* @__PURE__ */ __name((e) => {
        const input = e.target;
        setInputItems(options);
        setTimeout(() => {
          input.setSelectionRange(input.value.length, input.value.length);
          input.scrollLeft = input.scrollWidth;
        }, 0);
      }, "onFocus"),
      onClick: /* @__PURE__ */ __name(() => {
        if (!isOpen && state !== "disabled" && state !== "locked") {
          openMenu();
        }
      }, "onClick"),
      state
    });
    return /* @__PURE__ */ React24.createElement("div", getRootProps({}, {
      suppressRefError: true
    }), /* @__PURE__ */ React24.createElement("div", {
      className: cn("relative py-0")
    }, isInputOverflowing && inputValue && (state === "disabled" || state === "locked") ? /* @__PURE__ */ React24.createElement(Tooltip2, {
      content: inputValue,
      placement: "top",
      sideOffset: 4,
      className: "w-full",
      asChild: true
    }, inputElement) : inputElement, /* @__PURE__ */ React24.createElement("button", {
      ...getToggleButtonProps({
        ref,
        id: name,
        disabled: state == "disabled" || state == "locked",
        onClick: /* @__PURE__ */ __name(() => {
          if (!isOpen) {
            setInputItems(options);
          }
          if (inputRef.current) {
            const input = inputRef.current;
            input.focus();
            setTimeout(() => {
              input.setSelectionRange(input.value.length, input.value.length);
              input.scrollLeft = input.scrollWidth;
            }, 0);
          }
        }, "onClick")
      }),
      ...props,
      type: "button",
      className: cn("absolute right-[5px] inset-y-0 w-fit outline-none"),
      "aria-label": "toggle menu"
    }, /* @__PURE__ */ React24.createElement("div", {
      className: cn({
        "h-6": state === "locked"
      })
    }, isOpen ? /* @__PURE__ */ React24.createElement(ChevronUp4, {
      className: cn("stroke-regular", {
        "text-icon-primary": state === "error",
        "text-icon-disabled": state === "disabled",
        hidden: state === "locked"
      })
    }) : /* @__PURE__ */ React24.createElement(ChevronDown4, {
      className: cn("stroke-regular", {
        "text-icon-primary": state === "error",
        "text-icon-disabled": state === "disabled",
        hidden: state === "locked"
      })
    })))), /* @__PURE__ */ React24.createElement("ul", {
      ...getMenuProps(),
      className: cn(comboboxOptionListVariant())
    }, inputItems.length === 0 && inputValue && isOpen && /* @__PURE__ */ React24.createElement("div", {
      className: "p-2 text-xs text-text-disabled bg-main-primary-white"
    }, "No results."), isOpen && inputItems.map((item, index) => {
      return /* @__PURE__ */ React24.createElement("li", {
        key: `${item}${index}`
      }, /* @__PURE__ */ React24.createElement("button", {
        ...getItemProps({
          item,
          index
        }),
        className: cn(comboboxOptionVariant({
          state: item.disabled ? "disabled" : "active",
          textSize
        }), {
          "bg-interaction-hover": highlightedIndex === index
        }, "w-full"),
        disabled: item.disabled
      }, /* @__PURE__ */ React24.createElement("span", {
        className: "label grid grid-cols-[1fr_16px] justify-between items-start gap-2"
      }, /* @__PURE__ */ React24.createElement("div", {
        className: "text-left min-w-0"
      }, item?.label), /* @__PURE__ */ React24.createElement(Check5, {
        size: 16,
        className: cn("w-4 block", {
          hidden: selectedItem?.value !== item.value
        })
      })), item.subLabel && /* @__PURE__ */ React24.createElement("span", {
        className: "subLabel block w-full text-left"
      }, item.subLabel)));
    })));
  }), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React24.createElement("p", {
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : /* @__PURE__ */ React24.createElement(React24.Fragment, null), errorMessage ? /* @__PURE__ */ React24.createElement("p", {
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : /* @__PURE__ */ React24.createElement(React24.Fragment, null, " "), /* @__PURE__ */ React24.createElement("div", {
    tabIndex: 0
  }));
}, "ComboboxComponent");
ComboboxComponent.displayName = "Combobox";
var Combobox = /* @__PURE__ */ React24.forwardRef(ComboboxComponent);

// src/components/Combobox/ComboboxForm.tsx
import * as React26 from "react";
import { useController as useController3, useFormState as useFormState6 } from "react-hook-form";

// src/components/Combobox/ComboboxFormInput.tsx
import * as React25 from "react";
import Downshift4 from "downshift";
import { ChevronUp as ChevronUp5, ChevronDown as ChevronDown5, Check as Check6 } from "lucide-react";
import { ErrorMessage as ErrorMessage6 } from "@hookform/error-message";
var ComboboxFormInput = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, placeholder, errorMessage, onSelectOption, className, selectedItem, onInputValueChange, onChangeForm, formErrorMessage, ref, ...props }) => {
  const [inputItems, setInputItems] = React25.useState(options);
  const inputRef = React25.useRef(null);
  const handleInputValueChange = /* @__PURE__ */ __name((inputValue) => {
    setInputItems(options.filter((item) => item.label.toLowerCase().includes(inputValue.toLowerCase())));
    onInputValueChange && onInputValueChange(inputValue);
  }, "handleInputValueChange");
  return /* @__PURE__ */ React25.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React25.createElement(Downshift4, {
    onChange: /* @__PURE__ */ __name((selection) => {
      if (selection != null) {
        onChangeForm(selection.value);
        onSelectOption && onSelectOption(selection.value);
      } else {
        onChangeForm(null);
        onSelectOption && onSelectOption(null);
      }
    }, "onChange"),
    itemToString: /* @__PURE__ */ __name((item) => item ? item.label : "", "itemToString"),
    selectedItem,
    onInputValueChange: handleInputValueChange
  }, ({ isOpen, openMenu, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, selectedItem: selectedItem2, getInputProps, getRootProps, inputValue }) => /* @__PURE__ */ React25.createElement("div", getRootProps({}, {
    suppressRefError: true
  }), /* @__PURE__ */ React25.createElement("div", {
    className: cn("relative py-0")
  }, /* @__PURE__ */ React25.createElement(TextInput, {
    ...getInputProps({
      placeholder,
      ref: inputRef
    }),
    name: "combobox",
    className: cn(comboboxToggleButtonVariant({
      variant,
      state,
      textSize
    }), "pr-7 [&>input]:truncate"),
    onFocus: /* @__PURE__ */ __name((e) => {
      const input = e.target;
      setInputItems(options);
      setTimeout(() => {
        input.setSelectionRange(input.value.length, input.value.length);
        input.scrollLeft = input.scrollWidth;
      }, 0);
    }, "onFocus"),
    state,
    onClick: /* @__PURE__ */ __name(() => {
      if (!isOpen && state !== "disabled" && state !== "locked") {
        openMenu();
      }
    }, "onClick")
  }), /* @__PURE__ */ React25.createElement("button", {
    className: cn("absolute right-[5px] inset-y-0 w-fit"),
    ...getToggleButtonProps({
      ref,
      id: name,
      disabled: state == "disabled" || state == "locked",
      onClick: /* @__PURE__ */ __name(() => {
        if (!isOpen) {
          setInputItems(options);
        }
        if (inputRef.current) {
          const input = inputRef.current;
          input.focus();
          setTimeout(() => {
            input.setSelectionRange(input.value.length, input.value.length);
            input.scrollLeft = input.scrollWidth;
          }, 0);
        }
      }, "onClick")
    }),
    ...props
  }, /* @__PURE__ */ React25.createElement("div", {
    className: cn({
      "h-6": state === "locked"
    })
  }, isOpen ? /* @__PURE__ */ React25.createElement(ChevronUp5, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }) : /* @__PURE__ */ React25.createElement(ChevronDown5, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  })))), /* @__PURE__ */ React25.createElement("ul", {
    ...getMenuProps(),
    className: cn(comboboxOptionListVariant())
  }, inputItems.length === 0 && inputValue && isOpen && /* @__PURE__ */ React25.createElement("div", {
    className: "p-2 text-xs text-text-disabled bg-main-primary-white"
  }, "No results."), isOpen && inputItems.map((item, index) => /* @__PURE__ */ React25.createElement("li", {
    key: `${item}${index}`
  }, /* @__PURE__ */ React25.createElement("button", {
    ...getItemProps({
      item,
      index
    }),
    className: cn(comboboxOptionVariant({
      state: item.disabled ? "disabled" : "active",
      textSize
    }), {
      "bg-interaction-hover": highlightedIndex === index
    }),
    disabled: item.disabled
  }, /* @__PURE__ */ React25.createElement("span", {
    className: "label grid grid-cols-[1fr_16px] justify-between items-start gap-2"
  }, /* @__PURE__ */ React25.createElement("div", null, item?.label), /* @__PURE__ */ React25.createElement(Check6, {
    size: 16,
    className: cn("w-4 block", {
      hidden: selectedItem2?.value !== item.value
    })
  })), item.subLabel && /* @__PURE__ */ React25.createElement("span", {
    className: "subLabel"
  }, item.subLabel))))))), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React25.createElement("p", {
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : /* @__PURE__ */ React25.createElement(React25.Fragment, null), /* @__PURE__ */ React25.createElement(ErrorMessage6, {
    errors: formErrorMessage,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React25.createElement("p", {
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }), errorMessage ? /* @__PURE__ */ React25.createElement("p", {
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : /* @__PURE__ */ React25.createElement(React25.Fragment, null, " "), /* @__PURE__ */ React25.createElement("div", {
    tabIndex: 0
  }));
}, "ComboboxFormInput");

// src/components/Combobox/ComboboxForm.tsx
var ComboboxFormComponent = /* @__PURE__ */ __name(({ name, methods, variant = "underline", state = "active", textSize = "xs", options, helperText, setFirstOption = true, placeholder, errorMessage, validateFunction, isRequired, className, ...props }, ref) => {
  const { errors } = useFormState6({
    control: methods.control,
    name
  });
  const firstEnabled = React26.useMemo(() => options.find((o) => !o.disabled) ?? null, [
    options
  ]);
  const { field: { onChange, value } } = useController3({
    name,
    control: methods.control,
    rules: {
      validate: /* @__PURE__ */ __name((value2, formValues) => {
        if (isRequired && (value2 === "" || value2 === null || value2 === void 0)) {
          return "Required field";
        }
        if (validateFunction) {
          if (typeof validateFunction === "function") {
            return validateFunction(value2, formValues);
          } else {
            const validator = (
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              validateFunction[name]
            );
            return validator ? validator(value2, formValues) : true;
          }
        }
        return true;
      }, "validate")
    },
    defaultValue: setFirstOption ? firstEnabled?.value : void 0
  });
  React26.useEffect(() => {
    const currentOption = options.find((option) => option.value == value);
    let nextValue;
    if (currentOption && !currentOption.disabled) {
      nextValue = currentOption.value;
    } else if (setFirstOption) {
      nextValue = firstEnabled ? firstEnabled.value : null;
    } else {
      nextValue = null;
    }
    if (nextValue !== value) onChange(nextValue);
  }, [
    options,
    value,
    setFirstOption,
    onChange,
    firstEnabled
  ]);
  const areThereErrors = checkFormErrors(errors, name);
  const selectedItem = React26.useMemo(() => {
    const current = options.find((o) => o.value == value);
    if (current && !current.disabled) return current;
    if (setFirstOption) return firstEnabled;
    return null;
  }, [
    options,
    value,
    setFirstOption,
    firstEnabled
  ]);
  return /* @__PURE__ */ React26.createElement(ComboboxFormInput, {
    ref,
    selectedItem,
    onChangeForm: onChange,
    formErrorMessage: errors,
    name,
    options,
    variant,
    state: areThereErrors ? "error" : state,
    textSize,
    helperText,
    placeholder,
    errorMessage,
    className,
    ...props
  });
}, "ComboboxFormComponent");
ComboboxFormComponent.displayName = "ComboboxForm";
var ComboboxForm = /* @__PURE__ */ React26.forwardRef(ComboboxFormComponent);

// src/components/MultiSelect/MultiSelect.tsx
import * as React27 from "react";
import { useMultipleSelection, useSelect } from "downshift";

// src/components/MultiSelect/multiSelectStyleVariant.ts
var selectToggleButtonVariant2 = cva([
  "w-full",
  "flex",
  "justify-between",
  "items-center",
  "px-1",
  "w-full",
  "outline-none",
  "focus:outline-none",
  "focus:ring-0"
], {
  variants: {
    variant: {
      underline: [
        "border border-transparent",
        "border-b border-b-main-pure-black",
        "bg-main-primary-white",
        "focus:border-b",
        "focus:border-b-main-pure-black"
      ],
      outline: [
        "border border-main-pure-black",
        "focus:border",
        "focus:border-main-pure-black",
        "bg-main-primary-white",
        "pl-[10px]"
      ],
      hot: [
        "border-0 border-b border-signal-hot focus:border-signal-hot"
      ],
      cold: [
        "border-0 border-b border-signal-cold focus:border-signal-cold"
      ],
      noStyle: [
        "bg-transparent"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-interaction-disabled",
        "text-text-disabled"
      ],
      error: [
        "border-signal-error",
        "border",
        "text-text-error",
        "focus:border",
        "focus:border-signal-error"
      ],
      locked: [
        "cursor-not-allowed",
        "[&>input]:cursor-not-allowed",
        "bg-interaction-disabled"
      ],
      active: [
        ""
      ]
    },
    textSize: {
      xs: [
        "[&>div>.label]:text-label-xs-regular",
        "min-h-[36px]",
        "py-[4px]"
      ],
      sm: [
        "[&>div>.label]:text-label-sm-regular",
        "min-h-[36px]",
        "py-[2px]"
      ]
    }
  },
  compoundVariants: [
    {
      variant: "cold",
      state: "disabled",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "disabled",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "disabled",
      class: [
        "border-none"
      ]
    },
    {
      variant: "cold",
      state: "locked",
      class: [
        "border-b border-signal-cold"
      ]
    },
    {
      variant: "hot",
      state: "locked",
      class: [
        "border-b border-signal-hot"
      ]
    },
    {
      variant: "underline",
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: "outline",
      state: "locked",
      class: [
        "border-none"
      ]
    },
    {
      variant: "noStyle",
      state: "disabled",
      class: [
        "border-none",
        "bg-transparent"
      ]
    },
    {
      variant: "noStyle",
      state: "locked",
      class: [
        "border-none",
        "bg-interaction-disabled"
      ]
    }
  ]
});
var selectedItemsAmount = cva([
  "flex",
  "items-center",
  "justify-center",
  "gap-2",
  "w-fit",
  "ml-1"
], {
  variants: {
    textSize: {
      xs: [
        "text-label-xs-bold"
      ],
      sm: [
        "text-label-sm-bold"
      ]
    },
    state: {
      active: [
        "bg-interaction-active",
        "text-text-inverted",
        "p-1",
        "pl-2",
        "hover:bg-interaction-hover",
        "hover:text-text-primary"
      ],
      locked: [
        "bg-transparent",
        "text-text-primary",
        "border",
        "border-main-pure-black",
        "font-normal",
        "cursor-not-allowed",
        "px-2",
        "py-1"
      ],
      disabled: [
        "bg-interaction-disabled",
        "text-text-disabled"
      ],
      error: [
        "bg-interaction-active",
        "text-text-inverted",
        "p-1",
        "pl-2",
        "hover:bg-interaction-hover",
        "hover:text-text-primary"
      ]
    }
  }
});
var labelWrapperVariant3 = cva("flex gap-2 justify-start items-center", {
  variants: {
    textSize: {
      xs: [
        "[&>div>.label]:text-label-xs-regular"
      ],
      sm: [
        "[&>div>.label]:text-label-sm-regular"
      ]
    }
  }
});
var labelVariant = cva("grid grid-cols-[2fr-1fr] justify-start items-center");
var selectOptionListVariant2 = cva([
  "shadow-interface",
  "absolute",
  "z-20",
  "max-h-[200px]",
  "overflow-y-auto",
  "no-scrollbar",
  "w-full"
]);
var selectOptionVariant2 = cva([
  "px-4",
  "py-3",
  "cursor-pointer",
  "grid",
  "items-start",
  "text-left",
  "gap-[6px]",
  "bg-main-primary-white",
  "w-full",
  "hover:bg-interaction-hover",
  "group"
]);
var selectOptionLabelVariant = cva([
  "flex gap-3 items-start",
  "group-hover:bg-interaction-hover"
], {
  variants: {
    textSize: {
      xs: [
        "text-label-xs-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ],
      sm: [
        "text-label-sm-regular",
        "[&>.subLabel]:text-label-xxs-regular"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "bg-main-primary-white",
        "text-text-disabled"
      ],
      active: [
        "[&>div>div>.subLabel]:text-text-secondary"
      ]
    }
  }
});
var selectAllOption = cva([
  "border-b",
  "border-b-stroke-divider",
  "flex",
  "items-center",
  "gap-3",
  "w-full",
  "outline-none",
  "focus:outline-none",
  "focus:ring-0",
  "px-4",
  "py-3",
  "cursor-pointer",
  "bg-main-primary-white",
  "hover:bg-interaction-hover"
], {
  variants: {
    textSize: {
      xs: [
        "text-label-xs-regular"
      ],
      sm: [
        "text-label-sm-regular"
      ]
    }
  }
});

// src/components/MultiSelect/MultiSelect.tsx
import { ChevronUp as ChevronUp6, ChevronDown as ChevronDown6, X, Check as Check7 } from "lucide-react";
var MultiSelectComponent = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, placeholder, errorMessage, onSelectOption, defaultSelectedOptions, selectLabel, enableSelectAll, className, selectedItems: controlledSelectedItems, onSelectedItemsChange, ...props }, ref) => {
  const isControlled = controlledSelectedItems !== void 0;
  const { getDropdownProps, addSelectedItem, removeSelectedItem, selectedItems, setSelectedItems } = useMultipleSelection({
    selectedItems: isControlled ? controlledSelectedItems : void 0,
    initialSelectedItems: !isControlled ? defaultSelectedOptions : void 0,
    onSelectedItemsChange: isControlled ? ({ selectedItems: selectedItems2 }) => {
      onSelectedItemsChange?.(selectedItems2 || []);
    } : void 0
  });
  const { isOpen, selectedItem, getToggleButtonProps, getMenuProps, getItemProps, highlightedIndex } = useSelect({
    selectedItem: null,
    items: options,
    stateReducer: /* @__PURE__ */ __name((_state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true,
            highlightedIndex: 0
          };
      }
      return changes;
    }, "stateReducer"),
    onStateChange: /* @__PURE__ */ __name(({ type, selectedItem: newSelectedItem }) => {
      switch (type) {
        case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect.stateChangeTypes.ItemClick:
        case useSelect.stateChangeTypes.ToggleButtonBlur:
          if (newSelectedItem) {
            if (!isControlled) {
              addSelectedItem(newSelectedItem);
            }
            onSelectOption && onSelectOption(newSelectedItem);
          }
          break;
        default:
          break;
      }
    }, "onStateChange")
  });
  const enabledOptionsCount = React27.useMemo(() => options.filter((option) => !option.disabled).length, [
    options
  ]);
  const allEnabledSelected = React27.useMemo(() => selectedItems.length === enabledOptionsCount && enabledOptionsCount > 0, [
    selectedItems.length,
    enabledOptionsCount
  ]);
  const selectAll = React27.useCallback(() => {
    const enabledOptions = options.filter((option) => !option.disabled);
    if (isControlled) {
      onSelectedItemsChange?.(enabledOptions);
    } else {
      setSelectedItems(enabledOptions);
    }
    if (onSelectOption) {
      onSelectOption(enabledOptions);
    }
  }, [
    options,
    isControlled,
    onSelectedItemsChange,
    setSelectedItems,
    onSelectOption
  ]);
  const unselectAll = React27.useCallback(() => {
    if (isControlled) {
      onSelectedItemsChange?.([]);
    } else {
      setSelectedItems([]);
    }
    if (onSelectOption) {
      onSelectOption([]);
    }
  }, [
    isControlled,
    onSelectedItemsChange,
    setSelectedItems,
    onSelectOption
  ]);
  const handleOptionClick = React27.useCallback((e, option) => {
    e.stopPropagation();
    const isSelected = selectedItems.some((item) => item.value === option.value);
    if (isControlled) {
      const newItems = isSelected ? selectedItems.filter((item) => item.value !== option.value) : [
        ...selectedItems,
        option
      ];
      onSelectedItemsChange?.(newItems);
    } else {
      isSelected ? removeSelectedItem(option) : addSelectedItem(option);
    }
    if (onSelectOption) {
      onSelectOption(option);
    }
  }, [
    selectedItems,
    isControlled,
    onSelectedItemsChange,
    removeSelectedItem,
    addSelectedItem,
    onSelectOption
  ]);
  const handleClearAll = React27.useCallback((e) => {
    e.stopPropagation();
    unselectAll();
  }, [
    unselectAll
  ]);
  const handleSelectAll = React27.useCallback(() => {
    if (allEnabledSelected) {
      unselectAll();
    } else {
      selectAll();
    }
  }, [
    allEnabledSelected,
    unselectAll,
    selectAll
  ]);
  return /* @__PURE__ */ React27.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React27.createElement("button", {
    ...getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen,
      disabled: state === "disabled" || state === "locked",
      ref,
      id: name,
      "aria-label": placeholder || selectLabel,
      "aria-invalid": state === "error",
      "aria-describedby": errorMessage ? `${name}-error` : helperText ? `${name}-helper` : void 0
    })),
    className: cn(selectToggleButtonVariant2({
      variant,
      state,
      textSize
    })),
    ...props
  }, /* @__PURE__ */ React27.createElement("div", {
    className: cn(labelWrapperVariant3({
      textSize
    }))
  }, selectedItems.length > 0 ? state != "locked" ? /* @__PURE__ */ React27.createElement(Tooltip2, {
    content: "Clear all",
    contentClassName: "px-3 py-4"
  }, /* @__PURE__ */ React27.createElement("div", {
    className: cn(selectedItemsAmount({
      textSize,
      state
    }))
  }, /* @__PURE__ */ React27.createElement("div", null, selectedItems.length), /* @__PURE__ */ React27.createElement("div", {
    onClick: handleClearAll
  }, /* @__PURE__ */ React27.createElement(X, {
    width: 16,
    height: 16,
    "data-testid": "clear-all-icon"
  })))) : /* @__PURE__ */ React27.createElement("div", {
    className: cn(selectedItemsAmount({
      textSize,
      state
    }))
  }, /* @__PURE__ */ React27.createElement("div", null, selectedItems.length)) : null, /* @__PURE__ */ React27.createElement("div", {
    className: cn(labelVariant())
  }, /* @__PURE__ */ React27.createElement("div", {
    className: "w-full truncate text-left label"
  }, selectedItems.length > 0 ? /* @__PURE__ */ React27.createElement("span", null, selectLabel) : /* @__PURE__ */ React27.createElement("span", {
    className: "text-text-disabled"
  }, placeholder)), selectedItem?.subLabel && /* @__PURE__ */ React27.createElement("span", {
    className: cn("w-full text-left text-text-secondary text-label-xxs-regular truncate h-fit", {
      "text-text-error": state === "error"
    })
  }, selectedItem?.subLabel))), /* @__PURE__ */ React27.createElement("div", {
    className: cn({
      "h-6": state === "locked"
    })
  }, isOpen ? /* @__PURE__ */ React27.createElement(ChevronUp6, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }) : /* @__PURE__ */ React27.createElement(ChevronDown6, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }))), /* @__PURE__ */ React27.createElement("ul", {
    ...getMenuProps(),
    className: cn(selectOptionListVariant2()),
    role: "listbox"
  }, isOpen && /* @__PURE__ */ React27.createElement(React27.Fragment, null, enableSelectAll && /* @__PURE__ */ React27.createElement("div", {
    onClick: handleSelectAll,
    className: cn(selectAllOption({
      textSize
    })),
    role: "option",
    "aria-selected": allEnabledSelected
  }, /* @__PURE__ */ React27.createElement("div", {
    className: "w-4 h-4 border border-text-primary flex items-center justify-center"
  }, allEnabledSelected ? /* @__PURE__ */ React27.createElement(Check7, {
    width: 16,
    height: 16,
    strokeWidth: 3,
    className: cn("w-4 h-4 block", {
      "bg-text-primary text-main-primary-white": allEnabledSelected
    })
  }) : /* @__PURE__ */ React27.createElement("div", {
    className: cn("w-2 h-2 block", {
      "bg-text-primary": selectedItems.length > 0,
      hidden: selectedItems.length === 0
    })
  })), /* @__PURE__ */ React27.createElement("span", null, "Select all")), options.map((option, index) => {
    const isSelected = selectedItems.some((item) => item.value === option.value);
    return /* @__PURE__ */ React27.createElement("li", {
      key: `${option.value}${index}`
    }, /* @__PURE__ */ React27.createElement("button", {
      ...getItemProps({
        item: option,
        index
      }),
      className: cn(selectOptionVariant2()),
      disabled: option.disabled,
      onClick: /* @__PURE__ */ __name((e) => handleOptionClick(e, option), "onClick"),
      role: "option",
      "aria-selected": isSelected,
      "aria-disabled": option.disabled
    }, /* @__PURE__ */ React27.createElement("span", {
      className: cn(selectOptionLabelVariant({
        textSize,
        state: option.disabled ? "disabled" : "active"
      }), {
        "bg-interaction-hover": highlightedIndex === index
      })
    }, /* @__PURE__ */ React27.createElement("div", {
      className: "flex flex-col gap-2"
    }, /* @__PURE__ */ React27.createElement("div", {
      className: "grid grid-cols-[16px_auto] items-start gap-3"
    }, /* @__PURE__ */ React27.createElement("div", {
      className: "w-4 h-4 border border-text-primary flex items-center justify-center"
    }, /* @__PURE__ */ React27.createElement(Check7, {
      width: 16,
      height: 16,
      strokeWidth: 3,
      className: cn("w-4 block", {
        hidden: !isSelected,
        "bg-text-primary text-main-primary-white": isSelected
      })
    })), /* @__PURE__ */ React27.createElement("div", null, option?.label)), option.subLabel && /* @__PURE__ */ React27.createElement("div", {
      className: "grid grid-cols-[16px_auto] items-start gap-3"
    }, /* @__PURE__ */ React27.createElement("div", {
      className: "w-4 h-4"
    }), /* @__PURE__ */ React27.createElement("span", {
      className: "subLabel"
    }, option.subLabel))))));
  }))), helperText && !(state === "error" && errorMessage) ? /* @__PURE__ */ React27.createElement("p", {
    id: `${name}-helper`,
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText) : null, errorMessage ? /* @__PURE__ */ React27.createElement("p", {
    id: `${name}-error`,
    role: "alert",
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage) : null, /* @__PURE__ */ React27.createElement("div", {
    tabIndex: 0
  }));
}, "MultiSelectComponent");
MultiSelectComponent.displayName = "MultiSelect";
var MultiSelectWithRef = /* @__PURE__ */ React27.forwardRef(MultiSelectComponent);
var MultiSelect = /* @__PURE__ */ React27.memo(MultiSelectWithRef);

// src/components/MultiSelect/MultiSelectForm.tsx
import * as React29 from "react";
import { useController as useController4, useFormState as useFormState7 } from "react-hook-form";

// src/components/MultiSelect/MultiSelectFormInput.tsx
import * as React28 from "react";
import { useMultipleSelection as useMultipleSelection2, useSelect as useSelect2 } from "downshift";
import { ChevronUp as ChevronUp7, ChevronDown as ChevronDown7, X as X2, Check as Check8 } from "lucide-react";
import { ErrorMessage as ErrorMessage7 } from "@hookform/error-message";
var MultiSelectFormInput = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, selectLabel, placeholder, errorMessage, onSelectOption, enableSelectAll, onChangeForm, selectedItemList = [], formErrorMessage, ref, className, ...props }) => {
  const { getDropdownProps, addSelectedItem, removeSelectedItem, selectedItems } = useMultipleSelection2({
    selectedItems: selectedItemList
  });
  const { isOpen, selectedItem, getToggleButtonProps, getMenuProps, getItemProps } = useSelect2({
    items: options,
    stateReducer: /* @__PURE__ */ __name((_state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect2.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: true,
            highlightedIndex: 0
          };
        default:
          return changes;
      }
    }, "stateReducer"),
    onStateChange: /* @__PURE__ */ __name(({ type, selectedItem: newSelectedItem }) => {
      switch (type) {
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownEnter:
        case useSelect2.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
        case useSelect2.stateChangeTypes.ItemClick:
        case useSelect2.stateChangeTypes.ToggleButtonBlur:
          if (newSelectedItem && !selectedItems.find((item) => item.value === newSelectedItem.value)) {
            const updatedItems = [
              ...selectedItems,
              newSelectedItem
            ];
            addSelectedItem(newSelectedItem);
            onChangeForm(updatedItems.map((item) => item.value));
            onSelectOption?.(updatedItems);
          }
          break;
        default:
          break;
      }
    }, "onStateChange")
  });
  const selectAll = /* @__PURE__ */ __name(() => {
    const selectable = options.filter((option) => !option.disabled);
    selectable.forEach((option) => {
      if (!selectedItems.find((item) => item.value === option.value)) {
        addSelectedItem(option);
      }
    });
    onChangeForm(selectable.map((option) => option.value));
    onSelectOption?.(selectable);
  }, "selectAll");
  const unselectAll = /* @__PURE__ */ __name(() => {
    selectedItems.forEach(removeSelectedItem);
    onChangeForm([]);
    onSelectOption?.([]);
  }, "unselectAll");
  return /* @__PURE__ */ React28.createElement("div", {
    className: cn("relative", className)
  }, /* @__PURE__ */ React28.createElement("button", {
    ...getToggleButtonProps(getDropdownProps({
      preventKeyAction: isOpen,
      disabled: state === "disabled" || state === "locked",
      ref,
      id: name
    })),
    className: cn(selectToggleButtonVariant2({
      variant,
      state,
      textSize
    })),
    ...props
  }, /* @__PURE__ */ React28.createElement("div", {
    className: cn(labelWrapperVariant3({
      textSize
    }))
  }, selectedItems.length > 0 ? state !== "locked" ? /* @__PURE__ */ React28.createElement(Tooltip2, {
    content: "Clear all",
    contentClassName: "px-3 py-4"
  }, /* @__PURE__ */ React28.createElement("div", {
    className: cn(selectedItemsAmount({
      textSize,
      state
    }))
  }, /* @__PURE__ */ React28.createElement("div", null, selectedItems.length), /* @__PURE__ */ React28.createElement("div", {
    onClick: /* @__PURE__ */ __name((e) => {
      e.stopPropagation();
      unselectAll();
    }, "onClick")
  }, /* @__PURE__ */ React28.createElement(X2, {
    width: 16,
    height: 16
  })))) : /* @__PURE__ */ React28.createElement("div", {
    className: cn(selectedItemsAmount({
      textSize,
      state
    }))
  }, /* @__PURE__ */ React28.createElement("div", null, selectedItems.length)) : null, /* @__PURE__ */ React28.createElement("div", {
    className: cn(labelVariant())
  }, /* @__PURE__ */ React28.createElement("div", {
    className: "w-full truncate text-left label"
  }, selectedItems.length > 0 ? /* @__PURE__ */ React28.createElement("span", null, selectLabel) : /* @__PURE__ */ React28.createElement("span", {
    className: "text-text-disabled"
  }, placeholder)), selectedItem?.subLabel && /* @__PURE__ */ React28.createElement("span", {
    className: cn("w-full text-left text-text-secondary text-label-xxs-regular truncate h-fit", {
      "text-text-error": state === "error"
    })
  }, selectedItem?.subLabel))), /* @__PURE__ */ React28.createElement("div", {
    className: cn({
      "h-6": state === "locked"
    })
  }, isOpen ? /* @__PURE__ */ React28.createElement(ChevronUp7, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }) : /* @__PURE__ */ React28.createElement(ChevronDown7, {
    className: cn("stroke-regular", {
      "text-icon-primary": state === "error",
      hidden: state === "locked"
    })
  }))), /* @__PURE__ */ React28.createElement("ul", {
    ...getMenuProps(),
    className: cn(selectOptionListVariant2())
  }, isOpen && /* @__PURE__ */ React28.createElement(React28.Fragment, null, enableSelectAll && /* @__PURE__ */ React28.createElement("div", {
    onClick: selectedItems.length === options.filter((option) => !option.disabled).length ? unselectAll : selectAll,
    className: cn(selectAllOption({
      textSize
    }))
  }, /* @__PURE__ */ React28.createElement("div", {
    className: "w-4 h-4 border border-text-primary flex items-center justify-center"
  }, selectedItems.length === options.filter((option) => !option.disabled).length ? /* @__PURE__ */ React28.createElement(Check8, {
    width: 16,
    height: 16,
    strokeWidth: 3,
    className: "w-4 h-4 block bg-text-primary text-main-primary-white"
  }) : selectedItems.length > 0 ? /* @__PURE__ */ React28.createElement("div", {
    className: "w-2 h-2 block bg-text-primary"
  }) : null), /* @__PURE__ */ React28.createElement("span", null, "Select all")), options.map((option, index) => {
    const isSelected = selectedItems.some((item) => item.value === option.value);
    return /* @__PURE__ */ React28.createElement("li", {
      key: `${option.value}${index}`
    }, /* @__PURE__ */ React28.createElement("button", {
      ...getItemProps({
        item: option,
        index
      }),
      className: cn(selectOptionVariant2(), "hover:bg-interaction-hover"),
      disabled: option.disabled,
      onClick: /* @__PURE__ */ __name((e) => {
        e.stopPropagation();
        let updated;
        if (isSelected) {
          removeSelectedItem(option);
          updated = selectedItems.filter((item) => item.value !== option.value);
        } else {
          addSelectedItem(option);
          updated = [
            ...selectedItems,
            option
          ];
        }
        onChangeForm(updated.map((item) => item.value));
        onSelectOption?.(updated);
      }, "onClick")
    }, /* @__PURE__ */ React28.createElement("span", {
      className: cn(selectOptionLabelVariant({
        textSize,
        state: option.disabled ? "disabled" : "active"
      }))
    }, /* @__PURE__ */ React28.createElement("div", {
      className: "flex flex-col gap-2"
    }, /* @__PURE__ */ React28.createElement("div", {
      className: "grid grid-cols-[16px_auto] items-start gap-3"
    }, /* @__PURE__ */ React28.createElement("div", {
      className: "w-4 h-4 border border-text-primary flex items-center justify-center"
    }, /* @__PURE__ */ React28.createElement(Check8, {
      width: 16,
      height: 16,
      strokeWidth: 3,
      className: cn("w-4 block", {
        hidden: !isSelected,
        "bg-text-primary text-main-primary-white": isSelected
      })
    })), /* @__PURE__ */ React28.createElement("div", null, option.label)), option.subLabel && /* @__PURE__ */ React28.createElement("div", {
      className: "grid grid-cols-[16px_auto] items-start gap-3"
    }, /* @__PURE__ */ React28.createElement("div", {
      className: "w-4 h-4"
    }), /* @__PURE__ */ React28.createElement("span", {
      className: "subLabel"
    }, option.subLabel))))));
  }))), helperText && !(state === "error" && errorMessage) && /* @__PURE__ */ React28.createElement("p", {
    className: "text-label-xxs-regular text-text-secondary justify-self-end text-right"
  }, helperText), /* @__PURE__ */ React28.createElement(ErrorMessage7, {
    errors: formErrorMessage,
    name,
    render: /* @__PURE__ */ __name(({ message }) => /* @__PURE__ */ React28.createElement("p", {
      className: "text-label-xxs-regular text-text-error"
    }, message), "render")
  }), errorMessage && /* @__PURE__ */ React28.createElement("p", {
    className: "text-label-xxs-regular text-text-error"
  }, errorMessage), /* @__PURE__ */ React28.createElement("div", {
    tabIndex: 0
  }));
}, "MultiSelectFormInput");

// src/components/MultiSelect/MultiSelectForm.tsx
var MultiSelectFormComponent = /* @__PURE__ */ __name(({ name, variant = "underline", state = "active", textSize = "xs", options, helperText, placeholder, errorMessage, onSelectOption, defaultSelectedOptions, selectLabel, enableSelectAll, methods, validateFunction, isRequired, className, ...props }, ref) => {
  const { errors } = useFormState7({
    control: methods.control,
    name
  });
  const { field: { onChange, value } } = useController4({
    name,
    control: methods.control,
    rules: {
      required: isRequired ? "Required field" : false,
      validate: validateFunction
    }
  });
  const areThereErrors = checkFormErrors(errors, name);
  let selectedItemList = [];
  if (Array.isArray(value)) {
    selectedItemList = options.filter((option) => value.includes(option.value));
  } else if (value !== void 0 && value !== null) {
    selectedItemList = options.filter((option) => option.value === value);
  } else {
    selectedItemList = defaultSelectedOptions ?? [];
  }
  return /* @__PURE__ */ React29.createElement(MultiSelectFormInput, {
    ref,
    name,
    variant,
    state: areThereErrors ? "error" : state,
    textSize,
    options,
    helperText,
    placeholder,
    errorMessage,
    formErrorMessage: errors,
    onChangeForm: onChange,
    onSelectOption,
    selectedItemList,
    selectLabel,
    enableSelectAll,
    className,
    ...props
  });
}, "MultiSelectFormComponent");
MultiSelectFormComponent.displayName = "MultiSelectForm";
var MultiSelectForm = /* @__PURE__ */ React29.forwardRef(MultiSelectFormComponent);

// src/components/Breadcrumb/Breadcrumb.tsx
import * as React30 from "react";
import { Link } from "react-router-dom";
var DefaultBreadcrumb = /* @__PURE__ */ React30.forwardRef(({ ...props }, ref) => /* @__PURE__ */ React30.createElement("nav", {
  ref,
  "aria-label": "breadcrumb",
  ...props
}));
DefaultBreadcrumb.displayName = "DefaultBreadcrumb";
var BreadcrumbList = /* @__PURE__ */ React30.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React30.createElement("ol", {
  ref,
  className: cn("flex flex-wrap items-center gap-2 break-words", className),
  ...props
}));
BreadcrumbList.displayName = "BreadcrumbList";
var BreadcrumbItem = /* @__PURE__ */ React30.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React30.createElement("li", {
  ref,
  className: cn("inline-flex items-center gap-1.5", className),
  ...props
}));
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = /* @__PURE__ */ React30.forwardRef(({ asReactLink, href, className, ...props }, ref) => {
  const Comp = asReactLink ? Link : "a";
  return /* @__PURE__ */ React30.createElement(Comp, {
    ref,
    to: href,
    href,
    className: cn("text-label-sm-regular text-text-primary cursor-pointer", className),
    ...props
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";
var BreadcrumbPage = /* @__PURE__ */ React30.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React30.createElement("span", {
  ref,
  role: "link",
  "aria-disabled": "true",
  "aria-current": "page",
  className: cn("text-label-sm-bold text-text-primary", className),
  ...props
}));
BreadcrumbPage.displayName = "BreadcrumbPage";
var BreadcrumbSeparator = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React30.createElement("li", {
  role: "presentation",
  "aria-hidden": "true",
  className: cn("text-label-sm-regular text-text-primary", className),
  ...props
}, "/"), "BreadcrumbSeparator");
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
var Breadcrumb = /* @__PURE__ */ React30.forwardRef(({ options, rootClassName, labelClassName, activeLabelClassName, ...props }, ref) => /* @__PURE__ */ React30.createElement(DefaultBreadcrumb, {
  ref,
  ...props,
  className: cn(rootClassName)
}, /* @__PURE__ */ React30.createElement(BreadcrumbList, null, options.map((option, index) => /* @__PURE__ */ React30.createElement(React30.Fragment, {
  key: option.label
}, /* @__PURE__ */ React30.createElement(BreadcrumbItem, null, options.length === 1 || options.length - 1 === index ? /* @__PURE__ */ React30.createElement(BreadcrumbPage, {
  className: cn(labelClassName)
}, option.label) : /* @__PURE__ */ React30.createElement(BreadcrumbLink, {
  className: cn(activeLabelClassName),
  href: option.href
}, option.label)), options.length - 1 !== index && /* @__PURE__ */ React30.createElement(BreadcrumbSeparator, null))))));
Breadcrumb.displayName = "Breadcrumb";

// src/components/Pagination/Pagination.tsx
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as React31 from "react";
var DefaultPagination = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React31.createElement("nav", {
  role: "navigation",
  "aria-label": "pagination",
  className: cn("flex justify-center", className),
  ...props
}), "DefaultPagination");
DefaultPagination.displayName = "DefaultPagination";
var PaginationContent = /* @__PURE__ */ React31.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React31.createElement("ul", {
  ref,
  className: cn("flex flex-row items-center gap-1", className),
  ...props
}));
PaginationContent.displayName = "PaginationContent";
var PaginationItem = /* @__PURE__ */ React31.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React31.createElement("li", {
  ref,
  className,
  ...props
}));
PaginationItem.displayName = "PaginationItem";
var PaginationLink = /* @__PURE__ */ __name(({ className, children, isActive, ...props }) => /* @__PURE__ */ React31.createElement(Button, {
  variant: isActive ? "primary" : "secondary",
  className: cn("w-fit min-w-0 max-h-7 px-[9.5px] border-none text-label-xs-regular", "hover:bg-interaction-hover hover:text-text-primary disabled:bg-main-primary-white disabled:text-text-disabled disabled:cursor-not-allowed", {
    "text-label-xs-bold": isActive
  }, className),
  ...props
}, children), "PaginationLink");
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React31.createElement(PaginationLink, {
  "aria-label": "Go to previous page",
  className: "p-0",
  ...props
}, /* @__PURE__ */ React31.createElement(ChevronLeft, {
  className: "h-6 w-6 !stroke-[1.5]"
})), "PaginationPrevious");
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationNext = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React31.createElement(PaginationLink, {
  "aria-label": "Go to next page",
  className: "w-7 p-0",
  ...props
}, /* @__PURE__ */ React31.createElement(ChevronRight, {
  className: "h-6 w-6 !stroke-[1.5]"
})), "PaginationNext");
PaginationNext.displayName = "PaginationNext";
var ELLIPSIS = "...";
var DEFAULT_OPTIONS = [
  {
    label: "10",
    value: 10
  },
  {
    label: "20",
    value: 20
  },
  {
    label: "30",
    value: 30
  },
  {
    label: "40",
    value: 40
  },
  {
    label: "50",
    value: 50
  }
];
var Pagination = /* @__PURE__ */ React31.forwardRef(({ className, table, hidePageSizeSelector, options, isDisabled, pageSizeLabel = "Rows per page", onClickPage, onClickPrevious, onClickNext, onSelectOption }, ref) => {
  const currentPage = table.getState().pagination.pageIndex + 1;
  const totalPages = table.getPageCount();
  const pageNumbers = React31.useMemo(() => {
    if (totalPages <= 0) return [];
    if (totalPages === 1) return [
      1
    ];
    if (totalPages <= 7) {
      return Array.from({
        length: totalPages
      }, (_, i) => i + 1);
    }
    const center = [
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2
    ];
    const filteredCenter = center.filter((p) => p > 1 && p < totalPages);
    const includeThreeLeft = currentPage === 5;
    const includeThreeRight = currentPage === totalPages - 4;
    const includeLeftDots = currentPage > 5;
    const includeRightDots = currentPage < totalPages - 4;
    if (includeThreeLeft) filteredCenter.unshift(2);
    if (includeThreeRight) filteredCenter.push(totalPages - 1);
    if (includeLeftDots) filteredCenter.unshift(ELLIPSIS);
    if (includeRightDots) filteredCenter.push(ELLIPSIS);
    return [
      1,
      ...filteredCenter,
      totalPages
    ];
  }, [
    currentPage,
    totalPages
  ]);
  const handleClickPrevious = React31.useCallback(() => {
    if (!isDisabled && table.getCanPreviousPage()) {
      if (onClickPrevious) {
        onClickPrevious();
      } else {
        table.previousPage();
      }
    }
  }, [
    isDisabled,
    table,
    onClickPrevious
  ]);
  const handleClickNext = React31.useCallback(() => {
    if (!isDisabled && table.getCanNextPage()) {
      if (onClickNext) {
        onClickNext();
      } else {
        table.nextPage();
      }
    }
  }, [
    isDisabled,
    table,
    onClickNext
  ]);
  const handleClickPage = React31.useCallback((pageNumber) => {
    if (!isDisabled && pageNumber !== currentPage) {
      if (onClickPage) {
        onClickPage(pageNumber);
      } else {
        table.setPageIndex(pageNumber - 1);
      }
    }
  }, [
    isDisabled,
    currentPage,
    onClickPage,
    table
  ]);
  const handleSelectOption = React31.useCallback((value) => {
    if (!isDisabled && value !== null) {
      if (onSelectOption) {
        onSelectOption(value);
      } else {
        table.setPageSize(value);
      }
    }
  }, [
    isDisabled,
    table,
    onSelectOption
  ]);
  return /* @__PURE__ */ React31.createElement("div", {
    ref,
    className: cn("flex items-center justify-center gap-4", className)
  }, /* @__PURE__ */ React31.createElement(DefaultPagination, null, /* @__PURE__ */ React31.createElement(PaginationContent, null, /* @__PURE__ */ React31.createElement(PaginationItem, null, /* @__PURE__ */ React31.createElement(PaginationPrevious, {
    disabled: isDisabled || !table.getCanPreviousPage(),
    onClick: handleClickPrevious
  })), pageNumbers.map((pageNumber, index) => /* @__PURE__ */ React31.createElement(PaginationItem, {
    key: typeof pageNumber === "number" ? pageNumber : `ellipsis-${index}`
  }, pageNumber === ELLIPSIS ? /* @__PURE__ */ React31.createElement("span", {
    className: "text-label-xs-regular text-text-disabled px-2",
    "aria-hidden": "true"
  }, ELLIPSIS) : /* @__PURE__ */ React31.createElement(PaginationLink, {
    isActive: pageNumber === currentPage,
    onClick: /* @__PURE__ */ __name(() => handleClickPage(pageNumber), "onClick"),
    disabled: isDisabled,
    "aria-label": `Go to page ${pageNumber}`,
    "aria-current": pageNumber === currentPage ? "page" : void 0
  }, pageNumber))), /* @__PURE__ */ React31.createElement(PaginationItem, null, /* @__PURE__ */ React31.createElement(PaginationNext, {
    disabled: isDisabled || !table.getCanNextPage(),
    onClick: handleClickNext
  })))), !hidePageSizeSelector && /* @__PURE__ */ React31.createElement("div", {
    className: "flex items-center gap-2"
  }, /* @__PURE__ */ React31.createElement("label", {
    className: "text-label-xs-regular w-fit whitespace-nowrap",
    htmlFor: "pagination-page-size"
  }, pageSizeLabel), /* @__PURE__ */ React31.createElement(Select, {
    id: "pagination-page-size",
    options: options || DEFAULT_OPTIONS,
    name: "pagination",
    variant: "outline",
    selectedOption: (options || DEFAULT_OPTIONS).find((o) => o.value === table.getState().pagination.pageSize),
    className: "min-w-[60px]",
    iconClassName: "w-4 h-4 [&>svg]:w-4 [&>svg]:h-4",
    onSelectOption: handleSelectOption,
    state: isDisabled ? "disabled" : "active",
    "aria-label": "Select page size",
    direction: "up"
  })));
});
Pagination.displayName = "Pagination";

// src/components/Dropdown/Dropdown.tsx
import * as React32 from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

// src/components/Dropdown/dropdownVariant.ts
var dropdownContentVariant = cva([
  "shadow-interface",
  "bg-main-primary-white border border-none",
  "min-w-[140px] max-w-[320px]",
  "origin-(--radix-dropdown-menu-content-transform-origin)",
  "overflow-hidden",
  "max-h-[50vh]",
  "z-50"
]);
var dropdownMenuTriggerVariant = cva("focus:ring-0 focus:outline-none", {
  variants: {},
  defaultVariants: {
    variant: "default",
    state: "default"
  }
});
var dropdownItemVariant = cva([
  "w-full min-w-[120px] max-w-[320px]",
  "focus-visible:outline-none",
  "px-4 py-3",
  "text-label-xs-regular",
  "flex gap-4 items-start justify-between",
  "hover:cursor-pointer hover:bg-interaction-hover",
  "[&>div>.subLabel]:text-text-secondary [&>div>.subLabel]:text-label-xxs-regular [&>div>.subLabel]:mt-[6px]",
  "[&>div]:self-center",
  "overflow-hidden"
], {
  defaultVariants: {
    state: "default"
  },
  variants: {
    state: {
      default: "text-text-primary",
      disabled: "text-text-disabled hover:cursor-not-allowed hover:bg-transparent"
    }
  }
});
var dropdownRadioItemVariant = cva([
  "w-full",
  "focus-visible:outline-none",
  "text-label-xs-regular",
  "hover:cursor-pointer hover:bg-interaction-hover",
  "flex",
  "min-w-[120px]",
  "overflow-hidden",
  "data-[state=checked]:bg-neutral-grey-50 data-[state=checked]:text-label-xs-bold"
], {
  defaultVariants: {
    state: "default"
  },
  variants: {
    state: {
      default: "text-text-primary",
      disabled: "text-text-disabled hover:cursor-not-allowed hover:bg-transparent"
    }
  }
});
var dropdownRadioItemLabelWrapperVariant = cva([
  "w-full flex justify-between items-start",
  "px-4 py-3"
]);
var dropdownRadioItemLabelVariant = cva([
  "w-full flex gap-4",
  "[&>div>.subLabel]:text-text-secondary [&>div>.subLabel]:text-label-xxs-regular [&>div>.subLabel]:mt-0.5",
  "self-center",
  "overflow-hidden"
]);

// src/components/Dropdown/Dropdown.tsx
var DropdownMenu = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Root, {
  "data-slot": "dropdown-menu",
  ...props
}), "DropdownMenu");
var DropdownMenuPortal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Portal, {
  "data-slot": "dropdown-menu-portal",
  ...props
}), "DropdownMenuPortal");
var DropdownMenuTrigger = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Trigger, {
  "data-slot": "dropdown-menu-trigger",
  className: cn(dropdownMenuTriggerVariant(), className),
  ...props
}), "DropdownMenuTrigger");
var DropdownMenuContent = /* @__PURE__ */ __name(({ className, sideOffset = 0, align = "start", children, ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Portal, null, /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Content, {
  "data-slot": "dropdown-menu-content",
  sideOffset,
  align,
  className: cn(dropdownContentVariant(), className),
  ...props
}, /* @__PURE__ */ React32.createElement("div", {
  className: "overflow-y-auto overflow-x-hidden max-h-[inherit] scrollbar-thin scrollbar-thumb-neutral-200 scrollbar-track-transparent"
}, children))), "DropdownMenuContent");
var DropdownMenuGroup = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Group, {
  "data-slot": "dropdown-menu-group",
  ...props
}), "DropdownMenuGroup");
var DropdownMenuItem = /* @__PURE__ */ __name(({ label, subLabel, icon, onClick, state, disabled, className, ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Item, {
  "data-slot": "dropdown-menu-item",
  "data-inset": false,
  "data-variant": "default",
  className: cn(dropdownItemVariant({
    state: disabled ? "disabled" : state
  }), className),
  onClick: disabled || state === "disabled" ? void 0 : onClick,
  disabled: disabled || state === "disabled",
  ...props
}, /* @__PURE__ */ React32.createElement("div", {
  className: "flex flex-col overflow-hidden"
}, /* @__PURE__ */ React32.createElement("div", {
  className: "text-wrap break-words"
}, label), subLabel && /* @__PURE__ */ React32.createElement("div", {
  className: "subLabel text-wrap break-words"
}, subLabel)), icon && /* @__PURE__ */ React32.createElement("span", null, /* @__PURE__ */ React32.cloneElement(icon, {
  width: 16,
  height: 16,
  absoluteStrokeWidth: true
}))), "DropdownMenuItem");
var DropdownMenuSeparator = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.Separator, {
  "data-slot": "dropdown-menu-separator",
  className: cn("h-px w-full bg-stroke-divider", className),
  ...props
}), "DropdownMenuSeparator");
var DropdownMenuRadioGroup = /* @__PURE__ */ __name(({ value, onValueChange, ...props }) => {
  return /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.RadioGroup, {
    "data-slot": "dropdown-menu-radio-group",
    value,
    onValueChange,
    ...props
  });
}, "DropdownMenuRadioGroup");
var DropdownMenuRadioItem = /* @__PURE__ */ __name(({ label, value, subLabel, iconAfter, avatar, onClick, state, disabled, className, ...props }) => {
  return /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.RadioItem, {
    "data-slot": "dropdown-menu-radio-item",
    className: cn(dropdownRadioItemVariant({
      state: disabled ? "disabled" : state
    }), className),
    value,
    onClick: disabled || state === "disabled" ? void 0 : onClick,
    disabled: disabled || state === "disabled",
    ...props
  }, /* @__PURE__ */ React32.createElement("span", {
    className: "w-[3px] flex items-stretch"
  }, /* @__PURE__ */ React32.createElement(DropdownMenuPrimitive.ItemIndicator, {
    className: "w-[3px] border-l-[3px] border-stroke-stroke"
  })), /* @__PURE__ */ React32.createElement("div", {
    className: cn(dropdownRadioItemLabelWrapperVariant())
  }, /* @__PURE__ */ React32.createElement("div", {
    className: cn(dropdownRadioItemLabelVariant())
  }, avatar && /* @__PURE__ */ React32.createElement(React32.Fragment, null, avatar), /* @__PURE__ */ React32.createElement("div", {
    className: "flex flex-col overflow-hidden"
  }, /* @__PURE__ */ React32.createElement("div", {
    className: "text-wrap break-words"
  }, label), subLabel && /* @__PURE__ */ React32.createElement("div", {
    className: "subLabel text-wrap break-words"
  }, subLabel))), iconAfter && /* @__PURE__ */ React32.createElement("div", {
    className: "icon-after"
  }, /* @__PURE__ */ React32.cloneElement(iconAfter, {
    width: 16,
    height: 16,
    absoluteStrokeWidth: true
  }))));
}, "DropdownMenuRadioItem");

// src/components/ContextMenu/ContextMenu.tsx
import * as React33 from "react";
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu";

// src/components/ContextMenu/contextMenuVariant.ts
var contextMenuContentVariant = cva([
  "shadow-interface",
  "bg-main-primary-white border border-none",
  "min-w-[140px] max-w-[320px]",
  "origin-(--radix-context-menu-content-transform-origin)",
  "overflow-hidden",
  "max-h-[50vh]"
]);
var contextMenuMenuTriggerVariant = cva("focus:ring-0 focus:outline-none", {
  variants: {},
  defaultVariants: {
    variant: "default",
    state: "default"
  }
});
var contextMenuItemVariant = cva([
  "w-full min-w-[120px] max-w-[320px]",
  "focus-visible:outline-none",
  "px-4 py-3",
  "text-label-xs-regular",
  "flex gap-4 items-start justify-between",
  "hover:cursor-pointer hover:bg-interaction-hover",
  "[&>div>.subLabel]:text-text-secondary [&>div>.subLabel]:text-label-xxs-regular [&>div>.subLabel]:mt-[6px]",
  "[&>div]:self-center",
  "overflow-hidden"
], {
  defaultVariants: {
    state: "default"
  },
  variants: {
    state: {
      default: "text-text-primary",
      disabled: "text-text-disabled hover:cursor-not-allowed hover:bg-transparent"
    }
  }
});
var contextMenuRadioItemVariant = cva([
  "w-full",
  "focus-visible:outline-none",
  "text-label-xs-regular",
  "hover:cursor-pointer hover:bg-interaction-hover",
  "flex",
  "min-w-[120px]",
  "overflow-hidden",
  "data-[state=checked]:bg-neutral-grey-50 data-[state=checked]:text-label-xs-bold"
], {
  defaultVariants: {
    state: "default"
  },
  variants: {
    state: {
      default: "text-text-primary",
      disabled: "text-text-disabled hover:cursor-not-allowed hover:bg-transparent"
    }
  }
});
var contextMenuRadioItemLabelWrapperVariant = cva([
  "w-full flex justify-between items-start",
  "px-4 py-3"
]);
var contextMenuRadioItemLabelVariant = cva([
  "w-full flex gap-4",
  "[&>div>.subLabel]:text-text-secondary [&>div>.subLabel]:text-label-xxs-regular [&>div>.subLabel]:mt-0.5",
  "self-center",
  "overflow-hidden"
]);

// src/components/ContextMenu/ContextMenu.tsx
var ContextMenu = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Root, {
  "data-slot": "context-menu",
  ...props
}), "ContextMenu");
var ContextMenuPortal = ContextMenuPrimitive.Portal;
var ContextMenuTrigger = /* @__PURE__ */ React33.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Trigger, {
  ref,
  "data-slot": "context-menu-trigger",
  className: cn(contextMenuMenuTriggerVariant(), className),
  ...props
}));
ContextMenuTrigger.displayName = "ContextMenuTrigger";
var ContextMenuContent = /* @__PURE__ */ React33.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Portal, null, /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Content, {
  ref,
  "data-slot": "context-menu-content",
  className: cn(contextMenuContentVariant(), className),
  ...props
}, /* @__PURE__ */ React33.createElement("div", {
  className: "overflow-y-auto overflow-x-hidden max-h-[inherit] scrollbar-thin scrollbar-thumb-neutral-200 scrollbar-track-transparent"
}, children))));
ContextMenuContent.displayName = "ContextMenuContent";
var ContextMenuItem = /* @__PURE__ */ React33.forwardRef(({ label, subLabel, icon, onClick, state, disabled, className, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Item, {
  ref,
  "data-slot": "context-menu-item",
  "data-inset": false,
  "data-variant": "default",
  className: cn(contextMenuItemVariant({
    state: disabled ? "disabled" : state
  }), className),
  onClick: disabled || state === "disabled" ? void 0 : onClick,
  disabled: disabled || state === "disabled",
  ...props
}, /* @__PURE__ */ React33.createElement("div", {
  className: "flex flex-col overflow-hidden"
}, /* @__PURE__ */ React33.createElement("div", {
  className: "text-wrap break-words"
}, label), subLabel && /* @__PURE__ */ React33.createElement("div", {
  className: "subLabel text-wrap break-words"
}, subLabel)), icon && /* @__PURE__ */ React33.createElement("span", null, /* @__PURE__ */ React33.cloneElement(icon, {
  width: 16,
  height: 16,
  absoluteStrokeWidth: true
}))));
ContextMenuItem.displayName = "ContextMenuItem";
var ContextMenuRadioGroup = /* @__PURE__ */ React33.forwardRef(({ value, onValueChange, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.RadioGroup, {
  ref,
  "data-slot": "context-menu-radio-group",
  value,
  onValueChange,
  ...props
}));
ContextMenuRadioGroup.displayName = "ContextMenuRadioGroup";
var ContextMenuRadioItem = /* @__PURE__ */ React33.forwardRef(({ label, value, subLabel, iconAfter, avatar, onClick, state, disabled, className, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.RadioItem, {
  ref,
  "data-slot": "context-menu-radio-item",
  className: cn(contextMenuRadioItemVariant({
    state: disabled ? "disabled" : state
  }), className),
  value,
  onClick: disabled || state === "disabled" ? void 0 : onClick,
  disabled: disabled || state === "disabled",
  ...props
}, /* @__PURE__ */ React33.createElement("span", {
  className: "w-[3px] flex items-stretch"
}, /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.ItemIndicator, {
  className: "w-[3px] border-l-[3px] border-stroke-stroke"
})), /* @__PURE__ */ React33.createElement("div", {
  className: cn(contextMenuRadioItemLabelWrapperVariant())
}, /* @__PURE__ */ React33.createElement("div", {
  className: cn(contextMenuRadioItemLabelVariant())
}, avatar && /* @__PURE__ */ React33.createElement(React33.Fragment, null, avatar), /* @__PURE__ */ React33.createElement("div", {
  className: "flex flex-col overflow-hidden"
}, /* @__PURE__ */ React33.createElement("div", {
  className: "text-wrap break-words"
}, label), subLabel && /* @__PURE__ */ React33.createElement("div", {
  className: "subLabel text-wrap break-words"
}, subLabel))), iconAfter && /* @__PURE__ */ React33.createElement("div", {
  className: "icon-after"
}, /* @__PURE__ */ React33.cloneElement(iconAfter, {
  width: 16,
  height: 16,
  absoluteStrokeWidth: true
})))));
ContextMenuRadioItem.displayName = "ContextMenuRadioItem";
var ContextMenuGroup = /* @__PURE__ */ React33.forwardRef((props, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Group, {
  ref,
  "data-slot": "context-menu-group",
  ...props
}));
ContextMenuGroup.displayName = "ContextMenuGroup";
var ContextMenuSeparator = /* @__PURE__ */ React33.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React33.createElement(ContextMenuPrimitive.Separator, {
  ref,
  "data-slot": "context-menu-separator",
  className: cn("h-px w-full bg-stroke-divider", className),
  ...props
}));
ContextMenuSeparator.displayName = "ContextMenuSeparator";

// src/components/FieldsLayout/FieldsLayout.tsx
import React34 from "react";
var FieldsLayout = /* @__PURE__ */ React34.memo(({ type = "line", children, numberOfColumns = 2, className, ...props }) => {
  return /* @__PURE__ */ React34.createElement("div", {
    className: cn(fieldsLayoutVariants({
      numberOfColumns,
      type
    }), className),
    ...props
  }, children);
});
FieldsLayout.displayName = "FieldsLayout";
var fieldsLayoutVariants = cva([
  "items-start",
  "w-full"
], {
  variants: {
    type: {
      stack: "flex flex-col gap-1 [&>*:first-child]:min-h-6",
      line: "grid grid-cols-[0.8fr_0.2fr_0.2fr_0.2fr_0.2fr_0.2fr_0.2fr] gap-1 items-center"
    },
    numberOfColumns: {
      2: "",
      3: "",
      3.5: "",
      4: ""
    }
  },
  compoundVariants: [
    {
      type: "line",
      numberOfColumns: 2,
      className: "[&>*:nth-child(1)]:col-span-1 [&>*:nth-child(2)]:col-start-2 [&>*:nth-child(2)]:col-end-8"
    },
    {
      type: "line",
      numberOfColumns: 3,
      className: "[&>*:nth-child(1)]:col-span-1 [&>*:nth-child(2)]:col-start-2 [&>*:nth-child(2)]:col-end-5 [&>*:nth-child(3)]:col-start-5 [&>*:nth-child(3)]:col-end-8"
    },
    {
      type: "line",
      numberOfColumns: 3.5,
      className: "[&>*:nth-child(1)]:col-span-1 [&>*:nth-child(2)]:col-start-2 [&>*:nth-child(2)]:col-end-6 [&>*:nth-child(3)]:col-start-6 [&>*:nth-child(3)]:col-end-8"
    },
    {
      type: "line",
      numberOfColumns: 4,
      className: "[&>*:nth-child(1)]:col-span-1 [&>*:nth-child(2)]:col-start-2 [&>*:nth-child(2)]:col-end-4 [&>*:nth-child(3)]:col-start-4 [&>*:nth-child(3)]:col-end-6 [&>*:nth-child(4)]:col-start-6 [&>*:nth-child(4)]:col-end-8"
    }
  ],
  defaultVariants: {
    type: "line",
    numberOfColumns: 2
  }
});

// src/components/Avatar/Avatar.tsx
import * as React35 from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
var avatarVariants = cva("relative font-bold flex justify-center items-center shrink-0 overflow-hidden", {
  variants: {
    size: {
      small: "h-4 w-4 text-[6.4px] leading-[112.5%]",
      medium: "h-6 w-6 text-[9.6px] leading-[10.8px]",
      large: "h-10 w-10 text-header-base-bold",
      xlarge: "h-14 w-14 text-[22.4px] leading-[25.2px]"
    },
    type: {
      initial: [
        "[&>span]:flex",
        "[&>span]:h-full [&>span]:w-full",
        "[&>span]:items-center [&>span]:justify-center"
      ],
      image: [
        "[&>img]:aspect-square",
        "[&>img]:h-full [&>img]:w-full",
        "[&>img]:object-cover"
      ]
    },
    shape: {
      round: "rounded-full [&>img]:rounded-full",
      square: "rounded-none [&>img]:rounded-none"
    },
    color: {
      green: "bg-signal-success text-text-inverted",
      blue: "bg-signal-info text-text-inverted",
      orange: "bg-signal-warning text-text-inverted",
      grey: "bg-main-medium-grey text-text-inverted",
      vahterus: "bg-main-pure-black text-text-inverted",
      vahterusDark: "bg-main-primary-white text-main-primary-white"
    }
  }
});
var Avatar = /* @__PURE__ */ React35.forwardRef(({ type, shape, username, color, src, alt, size = "large", classNameContainer, classNameImage, classNameFallback, ...props }, ref) => {
  const usernameFallback = username.split(" ").length >= 2 ? (username.split(" ")[0]?.charAt(0)?.toUpperCase() || "") + (username.split(" ")[1]?.charAt(0)?.toUpperCase() || "") : username.charAt(0).toUpperCase();
  return /* @__PURE__ */ React35.createElement(AvatarContainer, {
    className: cn(avatarVariants({
      type,
      shape,
      color,
      size
    }), classNameContainer),
    ref,
    ...props
  }, /* @__PURE__ */ React35.createElement(AvatarImage, {
    src,
    alt,
    className: classNameImage
  }), /* @__PURE__ */ React35.createElement(AvatarFallback, {
    className: classNameFallback
  }, usernameFallback));
});
Avatar.displayName = "Avatar";
var AvatarContainer = /* @__PURE__ */ React35.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React35.createElement(AvatarPrimitive.Root, {
  ref,
  className: cn(className),
  ...props
}));
AvatarContainer.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = /* @__PURE__ */ React35.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React35.createElement(AvatarPrimitive.Image, {
  ref,
  className: cn(className),
  ...props
}));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = /* @__PURE__ */ React35.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React35.createElement(AvatarPrimitive.Fallback, {
  ref,
  className: cn(className),
  ...props
}));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

// src/components/Chip/Chip.tsx
import React36 from "react";
import { X as X3 } from "lucide-react";
var chipVariants = cva([
  "flex justify-between items-center w-full",
  "border border-solid border-main-pure-black bg-main-primary-white",
  "text-text-primary text-label-xs-regular",
  "py-2 pl-3 pr-1 gap-2",
  "transition-colors"
], {
  variants: {
    state: {
      disabled: [
        "cursor-not-allowed",
        "text-text-disabled border-interaction-disabled"
      ],
      default: "hover:bg-interaction-hover cursor-pointer"
    }
  },
  defaultVariants: {
    state: "default"
  }
});
var Chip = /* @__PURE__ */ React36.forwardRef(({ className, state = "default", removable = true, icon, labelText, onClickRemove, ...props }, ref) => {
  const [isOverflowed, setIsOverflowed] = React36.useState(false);
  const labelRef = React36.useRef(null);
  React36.useEffect(() => {
    const checkOverflow = /* @__PURE__ */ __name(() => {
      if (labelRef.current) {
        setIsOverflowed(labelRef.current.scrollWidth > labelRef.current.clientWidth);
      }
    }, "checkOverflow");
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [
    labelText
  ]);
  const chipContent = /* @__PURE__ */ React36.createElement("div", {
    ref,
    className: cn(chipVariants({
      state
    }), className),
    ...props
  }, /* @__PURE__ */ React36.createElement("span", {
    ref: labelRef,
    className: "truncate min-h-4 pt-0.5"
  }, labelText), removable && state !== "disabled" && /* @__PURE__ */ React36.createElement("button", {
    type: "button",
    className: "flex items-center justify-center p-0.5 hover:bg-interaction-hover rounded transition-colors",
    onClick: /* @__PURE__ */ __name((e) => {
      e.stopPropagation();
      if (onClickRemove) {
        onClickRemove(e);
      }
    }, "onClick"),
    "aria-label": `Remove ${labelText}`
  }, icon || /* @__PURE__ */ React36.createElement(X3, {
    width: 16,
    height: 16,
    strokeWidth: 1.75
  })));
  if (isOverflowed) {
    return /* @__PURE__ */ React36.createElement(Tooltip2, {
      content: labelText,
      placement: "top",
      contentAlign: "center",
      asChild: true
    }, chipContent);
  }
  return chipContent;
});
Chip.displayName = "Chip";

// src/components/Accordion/Accordion.tsx
import * as React37 from "react";
import { Minus, Plus } from "lucide-react";
var Accordion = /* @__PURE__ */ React37.forwardRef(({ className, titleClassName, contentClassName, defaultOpen = false, open = void 0, disabled = false, title, name, onOpenChange, children, ...props }, ref) => {
  return /* @__PURE__ */ React37.createElement("div", {
    ref,
    className: cn("group", className),
    ...props
  }, /* @__PURE__ */ React37.createElement("div", {
    className: "border border-stroke-container px-4 py-3 flex gap-3 items-center bg-neutral-grey-25"
  }, /* @__PURE__ */ React37.createElement("div", {
    className: cn("border border-main-pure-black h-6 w-6 flex items-center justify-center bg-main-primary-white", "hover:bg-interaction-hover", {
      "border-interaction-disabled text-icon-disabled hover:bg-main-primary-white": disabled
    })
  }, /* @__PURE__ */ React37.createElement("input", {
    type: "checkbox",
    className: "hidden",
    defaultChecked: open === void 0 ? defaultOpen : void 0,
    checked: open,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => onOpenChange && onOpenChange(e.target.checked), "onChange"),
    id: name
  }), /* @__PURE__ */ React37.createElement("label", {
    className: cn("cursor-pointer", {
      "cursor-not-allowed": disabled
    }),
    htmlFor: name
  }, /* @__PURE__ */ React37.createElement(Plus, {
    strokeWidth: 1.25,
    className: "block group-has-[:checked]:hidden"
  }), /* @__PURE__ */ React37.createElement(Minus, {
    strokeWidth: 1.25,
    className: "hidden group-has-[:checked]:block"
  }))), /* @__PURE__ */ React37.createElement("div", {
    className: cn("text-header-base-bold text-text-primary w-full", titleClassName)
  }, title)), /* @__PURE__ */ React37.createElement("div", {
    className: cn("border border-t-0 border-stroke-container px-6 py-8", "group-has-[:checked]:block hidden", contentClassName)
  }, children));
});
Accordion.displayName = "Accordion";

// src/components/ContextualHelp/ContextualHelp.tsx
import React38 from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Info, CircleHelp } from "lucide-react";
var contextualHelpVariants = cva("inline-flex items-center justify-center cursor-pointer transition-all rounded-none p-0.5", {
  variants: {
    type: {
      help: "",
      info: ""
    },
    parentFontSize: {
      xs: "relative -top-[-4px]",
      sm: "relative -top-[-3px]",
      "text-base": "relative -top-[-3px]",
      "2xl": "relative -top-[-1px]"
    }
  },
  defaultVariants: {
    type: "help"
  }
});
var triggerStateClasses = {
  default: "text-icon-primary",
  hover: "hover:bg-neutral-grey-100",
  selected: "data-[state=open]:bg-main-pure-black data-[state=open]:text-icon-inverted"
};
var contentVariants = cva("z-50 rounded-none bg-main-primary-white border border-stroke-stroke shadow-interface animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", {
  variants: {
    width: {
      sm: "w-[240px]",
      md: "w-[320px]",
      lg: "w-[400px]"
    }
  },
  defaultVariants: {
    width: "md"
  }
});
var PopoverContent = /* @__PURE__ */ React38.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React38.createElement(PopoverPrimitive.Portal, null, /* @__PURE__ */ React38.createElement(PopoverPrimitive.Content, {
  ref,
  className: cn(className),
  ...props
})));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
var ContextualHelp = /* @__PURE__ */ React38.forwardRef(({ type = "help", title, content, sections, examples, width = "md", defaultOpen, open, onOpenChange, triggerClassName, contentClassName, side = "bottom", sideOffset = 4, align = "center", avoidCollisions = true, parentFontSize, "data-testid": dataTestId, ...props }, ref) => {
  const Icon = type === "help" ? CircleHelp : Info;
  return /* @__PURE__ */ React38.createElement(PopoverPrimitive.Root, {
    defaultOpen,
    open,
    onOpenChange
  }, /* @__PURE__ */ React38.createElement(PopoverPrimitive.Trigger, {
    ref,
    className: cn(contextualHelpVariants({
      type,
      parentFontSize
    }), triggerStateClasses.default, triggerStateClasses.hover, triggerStateClasses.selected, "focus:outline-none focus-visible:ring-2 focus-visible:ring-main-pure-black focus-visible:ring-offset-2", triggerClassName),
    "aria-label": `Show ${type === "help" ? "help" : "information"}`,
    "data-testid": dataTestId
  }, /* @__PURE__ */ React38.createElement(Icon, {
    className: "h-4 w-4",
    strokeWidth: 2
  })), /* @__PURE__ */ React38.createElement(PopoverContent, {
    side,
    sideOffset,
    align,
    avoidCollisions,
    className: cn(contentVariants({
      width
    }), "p-4", contentClassName),
    ...props
  }, /* @__PURE__ */ React38.createElement("div", {
    className: "space-y-3"
  }, /* @__PURE__ */ React38.createElement("h4", {
    className: "text-label-xs-bold text-text-primary"
  }, title), /* @__PURE__ */ React38.createElement("div", {
    className: "text-paragraph-xs-regular text-text-primary"
  }, content), sections && sections.length > 0 && /* @__PURE__ */ React38.createElement("div", {
    className: "space-y-3 pt-2"
  }, sections.map((section, index) => /* @__PURE__ */ React38.createElement("div", {
    key: index,
    className: "space-y-1"
  }, /* @__PURE__ */ React38.createElement("h5", {
    className: "text-label-xs-bold text-text-primary"
  }, section.label), /* @__PURE__ */ React38.createElement("div", {
    className: "text-paragraph-xs-regular text-text-primary"
  }, section.content)))), examples && /* @__PURE__ */ React38.createElement("div", {
    className: "pt-2"
  }, /* @__PURE__ */ React38.createElement("h5", {
    className: "text-label-xs-bold text-text-primary mb-2"
  }, "Examples"), /* @__PURE__ */ React38.createElement("div", {
    className: "space-y-2"
  }, examples)))));
});
ContextualHelp.displayName = "ContextualHelp";

// src/components/Notification/AlertBanner.tsx
import * as React39 from "react";
import { X as X4 } from "lucide-react";
var AlertBanner = /* @__PURE__ */ __name(({ title, description, visible, setVisible, link, onButtonClick, buttonTitle, dismissible = true, className }) => {
  const contentRef = React39.useRef(null);
  const [isSingleLine, setIsSingleLine] = React39.useState(true);
  React39.useLayoutEffect(() => {
    if (contentRef.current) {
      setIsSingleLine(contentRef.current.offsetHeight <= 52);
    }
  }, [
    title,
    description,
    buttonTitle,
    link
  ]);
  return visible ? /* @__PURE__ */ React39.createElement("div", {
    className: cn("text-paragraph-xs-regular w-full min-h-[52px] px-4 py-2 flex justify-between gap-6 items-center text-xs bg-main-vahterus-blue text-text-inverted", className)
  }, /* @__PURE__ */ React39.createElement("div", {
    className: "flex flex-wrap w-full items-center gap-6",
    ref: contentRef
  }, /* @__PURE__ */ React39.createElement("span", {
    className: "flex"
  }, /* @__PURE__ */ React39.createElement("span", {
    className: "font-bold w-fit text-wrap"
  }, title, /* @__PURE__ */ React39.createElement("span", {
    className: "text-wrap font-normal ml-0.5"
  }, description))), /* @__PURE__ */ React39.createElement("div", {
    className: "flex items-center gap-6 flex-none ml-auto"
  }, link && /* @__PURE__ */ React39.createElement("a", {
    href: link.href,
    target: "_blank",
    className: "underline text-text-inverted",
    rel: "noopener noreferrer"
  }, link.title), buttonTitle && /* @__PURE__ */ React39.createElement(Button, {
    onClick: onButtonClick,
    variant: "secondary",
    size: "small"
  }, buttonTitle))), dismissible && setVisible ? /* @__PURE__ */ React39.createElement("button", {
    onClick: /* @__PURE__ */ __name(() => setVisible(false), "onClick"),
    className: isSingleLine ? "self-center" : "self-start"
  }, /* @__PURE__ */ React39.createElement(X4, {
    className: "text-text-inverted",
    height: 24,
    width: 24,
    strokeWidth: 1.25
  })) : /* @__PURE__ */ React39.createElement(React39.Fragment, null)) : /* @__PURE__ */ React39.createElement(React39.Fragment, null);
}, "AlertBanner");

// src/components/Notification/InfoBox.tsx
import * as React40 from "react";
import { CircleHelp as CircleHelp2, Info as Info2, TriangleAlert } from "lucide-react";
var alertVariants = cva([
  "w-full round-none p-4 text-paragraph-xs-regular text-text-primary bg-main-primary-white",
  "[&>*]:break-normal [&>*]:text-wrap"
], {
  variants: {
    variant: {
      default: [
        "border-2 border-stroke-container",
        "flex flex-col gap-4"
      ],
      info: [
        "border-2 border-stroke-container",
        "grid grid-cols-[20px_auto] gap-3 items-center [&>*:not(:first-child)]:col-start-2 [&>*:first-child]:self-start"
      ],
      help: [
        "border-2 border-stroke-container",
        "grid grid-cols-[20px_auto] gap-3 items-center [&>*:not(:first-child)]:col-start-2 [&>*:first-child]:self-start"
      ],
      alert: [
        "border-2 border-signal-error",
        "grid grid-cols-[20px_auto] gap-3 items-center [&>*:not(:first-child)]:col-start-2 [&>*:first-child]:self-start"
      ]
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var Alert = /* @__PURE__ */ __name(({ className, variant, ...props }) => {
  return /* @__PURE__ */ React40.createElement("div", {
    "data-slot": "alert",
    role: "alert",
    className: cn(alertVariants({
      variant
    }), className),
    ...props
  });
}, "Alert");
var AlertTitle = /* @__PURE__ */ __name(({ className, ...props }) => {
  return /* @__PURE__ */ React40.createElement("div", {
    "data-slot": "alert-title",
    className: cn("font-bold", className),
    ...props
  });
}, "AlertTitle");
var AlertDescription = /* @__PURE__ */ __name(({ className, ...props }) => {
  return /* @__PURE__ */ React40.createElement("div", {
    "data-slot": "alert-description",
    className: cn("text-text-primary", className),
    ...props
  });
}, "AlertDescription");
var InfoBox = /* @__PURE__ */ React40.memo(({ variant = "default", title, description, link, className }) => {
  const icon = React40.useMemo(() => {
    switch (variant) {
      case "alert":
        return /* @__PURE__ */ React40.createElement(TriangleAlert, {
          width: 20,
          height: 20,
          strokeWidth: 2.25
        });
      case "info":
        return /* @__PURE__ */ React40.createElement(Info2, {
          width: 20,
          height: 20,
          strokeWidth: 2.25
        });
      case "help":
        return /* @__PURE__ */ React40.createElement(CircleHelp2, {
          width: 20,
          height: 20,
          strokeWidth: 2.25
        });
      default:
        return null;
    }
  }, [
    variant
  ]);
  return /* @__PURE__ */ React40.createElement(Alert, {
    variant,
    className
  }, icon, /* @__PURE__ */ React40.createElement(AlertTitle, null, title), /* @__PURE__ */ React40.createElement(AlertDescription, null, description), link && /* @__PURE__ */ React40.createElement("a", {
    href: link.href,
    target: link.target || "_blank",
    className: "underline text-text-primary",
    rel: "noopener noreferrer"
  }, link.title));
});
InfoBox.displayName = "InfoBox";

// src/components/Modal/DefaultModal.tsx
import * as React41 from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X as X5 } from "lucide-react";

// src/components/Modal/modalVariant.ts
var modalContentVariant = cva("fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] border bg-main-primary-white p-6 border-black shadow-modal rounded-none");
var modalOverlayVariant = cva("fixed inset-0 z-50 overlay");

// src/components/Modal/DefaultModal.tsx
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogOverlay = /* @__PURE__ */ React41.memo(/* @__PURE__ */ React41.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React41.createElement(DialogPrimitive.Overlay, {
  ref,
  className: cn(modalOverlayVariant(), className),
  ...props
})));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = /* @__PURE__ */ React41.memo(/* @__PURE__ */ React41.forwardRef(({ className, children, dismissable, iconClassName, ...props }, ref) => /* @__PURE__ */ React41.createElement(DialogPortal, null, /* @__PURE__ */ React41.createElement(DialogOverlay, null), /* @__PURE__ */ React41.createElement(DialogPrimitive.Content, {
  ref,
  className: cn(modalContentVariant(), className),
  ...props
}, children, dismissable && /* @__PURE__ */ React41.createElement(DialogPrimitive.Close, {
  className: cn("absolute right-2 top-2", iconClassName)
}, /* @__PURE__ */ React41.createElement(X5, {
  id: "close-icon",
  strokeWidth: 1.25
}), /* @__PURE__ */ React41.createElement("span", {
  className: "sr-only"
}, "Close"))))));
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = /* @__PURE__ */ React41.memo(({ className, ...props }) => /* @__PURE__ */ React41.createElement("div", {
  className: cn("flex gap-4 mt-4 mb-14", className),
  ...props
}));
DialogHeader.displayName = "DialogHeader";
var DialogFooter = /* @__PURE__ */ React41.memo(({ className, ...props }) => /* @__PURE__ */ React41.createElement("div", {
  className: cn("w-full flex justify-between gap-4", className),
  ...props
}));
DialogFooter.displayName = "DialogFooter";
var DialogTitle = /* @__PURE__ */ React41.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React41.createElement(DialogPrimitive.Title, {
  ref,
  className: cn("font-bold text-base leading-[18px] text-text-primary", className),
  ...props
}));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = /* @__PURE__ */ React41.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React41.createElement(DialogPrimitive.Description, {
  ref,
  className: cn("text-sm text-text-primary leading-[21px]", className),
  ...props
}));
DialogDescription.displayName = DialogPrimitive.Description.displayName;
var DialogClose = /* @__PURE__ */ __name(({ ...props }) => {
  return /* @__PURE__ */ React41.createElement(DialogPrimitive.Close, {
    "data-slot": "dialog-close",
    ...props
  });
}, "DialogClose");

// src/components/Modal/ConfirmationModal.tsx
import * as React42 from "react";
import * as DialogPrimitive2 from "@radix-ui/react-dialog";
import { TriangleAlert as TriangleAlert2, X as X6 } from "lucide-react";
var ConfirmationModal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Root, {
  "data-slot": "dialog",
  ...props
}), "ConfirmationModal");
var ConfirmationModalTrigger = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Trigger, {
  "data-slot": "dialog-trigger",
  asChild: true,
  ...props
}), "ConfirmationModalTrigger");
var ConfirmationModalPortal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Portal, {
  "data-slot": "dialog-portal",
  ...props
}), "ConfirmationModalPortal");
var ConfirmationModalClose = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Close, {
  "data-slot": "dialog-close",
  ...props
}), "ConfirmationModalClose");
var ConfirmationModalOverlay = /* @__PURE__ */ React42.memo(({ className, ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Overlay, {
  "data-slot": "dialog-overlay",
  className: cn(modalOverlayVariant(), className),
  ...props
}));
ConfirmationModalOverlay.displayName = "ConfirmationModalOverlay";
var ConfirmationModalHeader = /* @__PURE__ */ React42.memo(({ className, ...props }) => /* @__PURE__ */ React42.createElement("div", {
  "data-slot": "dialog-header",
  className: cn("flex flex-col gap-2 text-header-base-bold", className),
  ...props
}));
ConfirmationModalHeader.displayName = "ConfirmationModalHeader";
var ConfirmationModalFooter = /* @__PURE__ */ React42.memo(({ className, ...props }) => /* @__PURE__ */ React42.createElement("div", {
  "data-slot": "dialog-footer",
  className: cn("flex gap-4 w-full justify-between sticky bottom-0 bg-main-primary-white", className),
  ...props
}));
ConfirmationModalFooter.displayName = "ConfirmationModalFooter";
var ConfirmationModalTitle = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Title, {
  "data-slot": "dialog-title",
  className: cn("text-lg leading-none font-semibold", className),
  ...props
}), "ConfirmationModalTitle");
var ConfirmationModalDescription = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React42.createElement(DialogPrimitive2.Description, {
  "data-slot": "dialog-description",
  className: cn("text-paragraph-sm-regular", className),
  ...props
}), "ConfirmationModalDescription");
var ConfirmationModalContent = /* @__PURE__ */ React42.memo(({ className, title, type = "default", description, dismissable = true, buttonText, secondaryButtonText, onClick, onClickSecondary, iconClassName, isLoading = false, ...props }) => /* @__PURE__ */ React42.createElement(ConfirmationModalPortal, {
  "data-slot": "dialog-portal"
}, /* @__PURE__ */ React42.createElement(ConfirmationModalOverlay, null), /* @__PURE__ */ React42.createElement(DialogPrimitive2.Content, {
  "data-slot": "dialog-content",
  className: cn(modalContentVariant(), "pt-10", className),
  onInteractOutside: /* @__PURE__ */ __name((e) => {
    if (!dismissable) {
      e.preventDefault();
    }
  }, "onInteractOutside"),
  onEscapeKeyDown: /* @__PURE__ */ __name((e) => {
    if (!dismissable) {
      e.preventDefault();
    }
  }, "onEscapeKeyDown"),
  ...props
}, /* @__PURE__ */ React42.createElement("div", {
  className: "flex gap-4"
}, type === "warning" && /* @__PURE__ */ React42.createElement("div", {
  className: "w-6 h-6"
}, /* @__PURE__ */ React42.createElement(TriangleAlert2, {
  width: 24,
  height: 24
})), /* @__PURE__ */ React42.createElement("div", {
  className: "flex flex-col gap-6 mt-[2px]"
}, /* @__PURE__ */ React42.createElement(ConfirmationModalTitle, null, title), /* @__PURE__ */ React42.createElement(ConfirmationModalDescription, null, description))), /* @__PURE__ */ React42.createElement(ConfirmationModalFooter, {
  className: "pt-14 w-full"
}, secondaryButtonText && /* @__PURE__ */ React42.createElement(DialogPrimitive2.Close, {
  asChild: true
}, /* @__PURE__ */ React42.createElement(Button, {
  className: "w-full",
  variant: "secondary",
  onClick: onClickSecondary
}, secondaryButtonText)), /* @__PURE__ */ React42.createElement(DialogPrimitive2.Close, {
  asChild: true
}, /* @__PURE__ */ React42.createElement(Button, {
  className: "w-full",
  onClick,
  state: isLoading ? "loading" : "default"
}, buttonText))), dismissable && /* @__PURE__ */ React42.createElement(DialogPrimitive2.Close, {
  className: cn("absolute right-2 top-2", iconClassName)
}, /* @__PURE__ */ React42.createElement(X6, {
  id: "close-icon",
  strokeWidth: 1.25
}), /* @__PURE__ */ React42.createElement("span", {
  className: "sr-only"
}, "Close")))));
ConfirmationModalContent.displayName = "ConfirmationModalContent";

// src/components/Modal/InputModal.tsx
import * as React43 from "react";
import * as DialogPrimitive3 from "@radix-ui/react-dialog";
import { X as X7 } from "lucide-react";
var InputModal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Root, {
  "data-slot": "dialog",
  ...props
}), "InputModal");
var InputModalTrigger = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Trigger, {
  "data-slot": "dialog-trigger",
  asChild: true,
  ...props
}), "InputModalTrigger");
var InputModalPortal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Portal, {
  "data-slot": "dialog-portal",
  ...props
}), "InputModalPortal");
var InputModalClose = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Close, {
  "data-slot": "dialog-close",
  ...props
}), "InputModalClose");
var InputModalOverlay = /* @__PURE__ */ React43.memo(({ className, ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Overlay, {
  "data-slot": "dialog-overlay",
  className: cn(modalOverlayVariant(), className),
  ...props
}));
InputModalOverlay.displayName = "InputModalOverlay";
var InputModalHeader = /* @__PURE__ */ React43.memo(({ className, ...props }) => /* @__PURE__ */ React43.createElement("div", {
  "data-slot": "dialog-header",
  className: cn("flex justify-between items-center w-full py-4 px-6 border-b border-stroke-container text-header-base-bold", className),
  ...props
}));
InputModalHeader.displayName = "InputModalHeader";
var InputModalFooter = /* @__PURE__ */ React43.memo(({ primaryButton, secondaryButton, secondaryActions, className, ...props }) => {
  const renderButton = /* @__PURE__ */ __name((button, variant = "secondary") => {
    const { buttonText, buttonState, testId, isClosing, onClick, buttonType, ...rest } = button;
    const footerButton = /* @__PURE__ */ React43.createElement(Button, {
      className: "h-10 w-fit px-6",
      variant,
      size: "small",
      type: buttonType || "button",
      ...rest,
      onClick,
      state: buttonState ?? "default",
      "data-testid": testId
    }, buttonText);
    return isClosing ? /* @__PURE__ */ React43.createElement(InputModalClose, {
      asChild: true
    }, footerButton) : footerButton;
  }, "renderButton");
  return /* @__PURE__ */ React43.createElement("div", {
    "data-slot": "dialog-footer",
    className: cn("py-4 px-6 w-full flex justify-between items-center border-t border-stroke-container sticky bottom-0 bg-main-primary-white", className),
    ...props
  }, /* @__PURE__ */ React43.createElement("div", null, secondaryActions), /* @__PURE__ */ React43.createElement("div", {
    className: "flex gap-4"
  }, secondaryButton && renderButton(secondaryButton), renderButton(primaryButton, "primary")));
});
InputModalFooter.displayName = "InputModalFooter";
var InputModalTitle = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Title, {
  "data-slot": "dialog-title",
  className: cn("text-lg leading-none font-semibold", className),
  ...props
}), "InputModalTitle");
var InputModalDescription = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React43.createElement(DialogPrimitive3.Description, {
  "data-slot": "dialog-description",
  className: cn("text-paragraph-sm-regular", className),
  ...props
}), "InputModalDescription");
var InputModalContent = /* @__PURE__ */ React43.memo(({ className, title, children, contextualContent, contextualTitle, ...props }) => /* @__PURE__ */ React43.createElement(InputModalPortal, {
  "data-slot": "dialog-portal"
}, /* @__PURE__ */ React43.createElement(InputModalOverlay, null), /* @__PURE__ */ React43.createElement(DialogPrimitive3.Content, {
  "data-slot": "dialog-content",
  className: cn(modalContentVariant(), "p-0 max-h-[calc(100vh-130px)] flex flex-col", className),
  ...props
}, /* @__PURE__ */ React43.createElement(InputModalHeader, null, /* @__PURE__ */ React43.createElement(InputModalTitle, {
  className: "text-header-base-bold"
}, /* @__PURE__ */ React43.createElement("span", null, title), contextualTitle && contextualContent && /* @__PURE__ */ React43.createElement(ContextualHelp, {
  title: contextualTitle,
  content: contextualContent,
  parentFontSize: "text-base"
})), /* @__PURE__ */ React43.createElement(InputModalClose, {
  className: "h-full self-start focus:outline-none focus:ring-0"
}, /* @__PURE__ */ React43.createElement(X7, {
  id: "close-icon",
  strokeWidth: 1.25
}), /* @__PURE__ */ React43.createElement("span", {
  className: "sr-only"
}, "Close"))), /* @__PURE__ */ React43.createElement("div", {
  className: "flex-1 overflow-y-auto custom-scrollbar text-xs"
}, children))));
InputModalContent.displayName = "InputModalContent";

// src/components/Modal/ToolModal.tsx
import * as React44 from "react";
import * as DialogPrimitive4 from "@radix-ui/react-dialog";
import { X as X8 } from "lucide-react";
var ToolModal = /* @__PURE__ */ __name(({ modal = false, ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Root, {
  "data-slot": "dialog",
  modal,
  ...props
}), "ToolModal");
var ToolModalTrigger = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Trigger, {
  "data-slot": "dialog-trigger",
  ...props
}), "ToolModalTrigger");
var ToolModalPortal = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Portal, {
  "data-slot": "dialog-portal",
  ...props
}), "ToolModalPortal");
var ToolModalClose = /* @__PURE__ */ __name(({ ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Close, {
  "data-slot": "dialog-close",
  ...props
}), "ToolModalClose");
var ToolModalOverlay = /* @__PURE__ */ React44.memo(({ className, ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Overlay, {
  "data-slot": "dialog-overlay",
  className: cn("fixed inset-0 z-50 bg-transparent", className),
  ...props
}));
ToolModalOverlay.displayName = "ToolModalOverlay";
var ToolModalFooter = /* @__PURE__ */ React44.memo(({ primaryButton, secondaryButton, secondaryActions, className, ...props }) => {
  const renderButton = /* @__PURE__ */ __name((button, variant = "secondary") => {
    const { buttonText, buttonState, testId, isClosing, onClick, buttonType, ...rest } = button;
    const footerButton = /* @__PURE__ */ React44.createElement(Button, {
      className: "h-10 w-fit px-6",
      variant,
      size: "small",
      type: buttonType || "button",
      ...rest,
      onClick,
      state: buttonState ?? "default",
      "data-testid": testId
    }, buttonText);
    return isClosing ? /* @__PURE__ */ React44.createElement(ToolModalClose, {
      asChild: true
    }, footerButton) : footerButton;
  }, "renderButton");
  return /* @__PURE__ */ React44.createElement("div", {
    "data-slot": "dialog-footer",
    className: cn("py-4 px-6 w-full flex justify-between items-center border-t border-stroke-container", "sticky bottom-0 bg-main-primary-white", className),
    ...props
  }, /* @__PURE__ */ React44.createElement("div", null, secondaryActions), /* @__PURE__ */ React44.createElement("div", {
    className: "flex gap-4"
  }, secondaryButton && renderButton(secondaryButton), renderButton(primaryButton, "primary")));
});
ToolModalFooter.displayName = "ToolModalFooter";
var ToolModalHeader = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React44.createElement("div", {
  "data-slot": "dialog-header",
  className: cn("flex justify-between items-center w-full py-4 px-6 border-b border-stroke-container text-header-base-bold", className),
  ...props
}), "ToolModalHeader");
var ToolModalTitle = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Title, {
  "data-slot": "dialog-title",
  className: cn("text-header-base-bold", className),
  ...props
}), "ToolModalTitle");
var ToolModalDescription = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React44.createElement(DialogPrimitive4.Description, {
  "data-slot": "dialog-description",
  className: cn("text-paragraph-sm-regular", className),
  ...props
}), "ToolModalDescription");
var ToolModalContent = /* @__PURE__ */ React44.memo(({ className, contextualContent, contextualTitle, title, subTitle, dismissable = true, children, onInteractOutside, ...props }) => {
  const shouldBlockBackgroundClicks = !!onInteractOutside;
  const [position, setPosition] = React44.useState(null);
  const isDragging = React44.useRef(false);
  const dragStartMouse = React44.useRef({
    x: 0,
    y: 0
  });
  const dragStartPos = React44.useRef({
    x: 0,
    y: 0
  });
  const positionRef = React44.useRef({
    x: 0,
    y: 0
  });
  const frame = React44.useRef(void 0);
  const contentRef = React44.useRef(null);
  const onMouseMoveRef = React44.useRef(void 0);
  const onMouseUpRef = React44.useRef(void 0);
  React44.useEffect(() => {
    if (position === null && contentRef.current) {
      const modalRect = contentRef.current.getBoundingClientRect();
      const centerX = (window.innerWidth - modalRect.width) / 2;
      const centerY = (window.innerHeight - modalRect.height) / 2;
      setPosition({
        x: centerX,
        y: centerY
      });
      positionRef.current = {
        x: centerX,
        y: centerY
      };
      contentRef.current.style.transform = `translate(${centerX}px, ${centerY}px)`;
    }
  }, [
    position
  ]);
  React44.useEffect(() => {
    if (position && contentRef.current) {
      contentRef.current.style.transform = `translate(${position.x}px, ${position.y}px)`;
      positionRef.current = {
        ...position
      };
    }
  }, [
    position
  ]);
  const onMouseMove = React44.useCallback((e) => {
    if (!isDragging.current) return;
    if (frame.current) cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(() => {
      const dx = e.clientX - dragStartMouse.current.x;
      const dy = e.clientY - dragStartMouse.current.y;
      positionRef.current = {
        x: dragStartPos.current.x + dx,
        y: dragStartPos.current.y + dy
      };
      if (contentRef.current) {
        contentRef.current.style.transform = `translate(${positionRef.current.x}px, ${positionRef.current.y}px)`;
      }
    });
  }, []);
  const onMouseUp = React44.useCallback(() => {
    if (isDragging.current) {
      isDragging.current = false;
      setPosition({
        ...positionRef.current
      });
      document.body.style.userSelect = "";
    }
    if (onMouseMoveRef.current) {
      window.removeEventListener("mousemove", onMouseMoveRef.current);
    }
    if (onMouseUpRef.current) {
      window.removeEventListener("mouseup", onMouseUpRef.current);
    }
  }, []);
  onMouseMoveRef.current = onMouseMove;
  onMouseUpRef.current = onMouseUp;
  const handleHeaderMouseDown = /* @__PURE__ */ __name((e) => {
    if (e.button !== 0) return;
    isDragging.current = true;
    dragStartMouse.current = {
      x: e.clientX,
      y: e.clientY
    };
    dragStartPos.current = {
      ...positionRef.current
    };
    document.body.style.userSelect = "none";
    if (onMouseMoveRef.current && onMouseUpRef.current) {
      window.addEventListener("mousemove", onMouseMoveRef.current);
      window.addEventListener("mouseup", onMouseUpRef.current);
    }
    e.preventDefault();
  }, "handleHeaderMouseDown");
  React44.useEffect(() => {
    return () => {
      if (onMouseMoveRef.current) {
        window.removeEventListener("mousemove", onMouseMoveRef.current);
      }
      if (onMouseUpRef.current) {
        window.removeEventListener("mouseup", onMouseUpRef.current);
      }
      if (frame.current) cancelAnimationFrame(frame.current);
      document.body.style.userSelect = "";
    };
  }, []);
  return /* @__PURE__ */ React44.createElement(ToolModalPortal, {
    "data-slot": "dialog-portal"
  }, shouldBlockBackgroundClicks && /* @__PURE__ */ React44.createElement("div", {
    "data-slot": "dialog-click-blocker",
    className: "fixed inset-0 z-40 bg-transparent",
    "aria-hidden": "true"
  }), /* @__PURE__ */ React44.createElement(DialogPrimitive4.Content, {
    ref: contentRef,
    "data-slot": "dialog-content",
    className: cn("fixed z-50 grid w-full border bg-main-primary-white border-stroke-stroke shadow-modal rounded-none", "max-h-[calc(100vh-130px)] flex flex-col", className),
    style: {
      right: 40,
      top: 120,
      position: "fixed",
      transform: position ? `translate(${position.x}px, ${position.y}px)` : void 0
    },
    onInteractOutside: !onInteractOutside ? (e) => e.preventDefault() : onInteractOutside,
    onEscapeKeyDown: /* @__PURE__ */ __name((e) => e.preventDefault(), "onEscapeKeyDown"),
    ...props
  }, /* @__PURE__ */ React44.createElement("div", {
    "data-slot": "dialog-header",
    className: cn("flex justify-between items-center w-full py-4 px-6 border-b border-stroke-container text-header-base-bold select-none cursor-move"),
    onMouseDown: handleHeaderMouseDown
  }, /* @__PURE__ */ React44.createElement(DialogPrimitive4.Title, {
    className: "text-header-base-bold text-lg leading-none font-semibold"
  }, /* @__PURE__ */ React44.createElement("span", null, title), subTitle && /* @__PURE__ */ React44.createElement("span", {
    className: "ml-2 text-header-base-regular"
  }, subTitle), contextualTitle && contextualContent && /* @__PURE__ */ React44.createElement(ContextualHelp, {
    title: contextualTitle,
    content: contextualContent,
    parentFontSize: "text-base"
  })), dismissable && /* @__PURE__ */ React44.createElement(ToolModalClose, {
    className: "h-full self-start"
  }, /* @__PURE__ */ React44.createElement(X8, {
    id: "close-icon",
    strokeWidth: 1.25
  }), /* @__PURE__ */ React44.createElement("span", {
    className: "sr-only"
  }, "Close"))), /* @__PURE__ */ React44.createElement("div", {
    className: "flex-1 overflow-y-auto overscroll-contain text-xs"
  }, children)));
});
ToolModalContent.displayName = "ToolModalContent";

// src/components/Draggable/Draggable.tsx
import { closestCorners, DndContext, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import React45 from "react";
var DraggableItemComponent = /* @__PURE__ */ __name(({ id, title, children, className, titleClassName, labelClassName }) => {
  const { attributes, listeners, setNodeRef, transition, transform, isDragging } = useSortable({
    id
  });
  const style = {
    transition,
    transform: CSS.Transform.toString({
      ...transform,
      x: transform?.x ?? 0,
      y: transform?.y ?? 0,
      scaleX: 1,
      scaleY: 1
    }),
    opacity: isDragging ? 0.5 : 1
  };
  return /* @__PURE__ */ React45.createElement("div", {
    style,
    className: cn("flex gap-6 touch-none", className)
  }, /* @__PURE__ */ React45.createElement("div", {
    className: cn("flex items-start gap-2 w-[170px] min-w-[170px] h-fit", labelClassName),
    ref: setNodeRef
  }, /* @__PURE__ */ React45.createElement("div", {
    className: "cursor-move text-icon-primary hover:text-icon-primary-hover transition-colors",
    "aria-label": "Drag handle",
    ...listeners,
    ...attributes
  }, /* @__PURE__ */ React45.createElement(GripVertical, {
    strokeWidth: 1.25,
    width: 24,
    height: 24
  })), /* @__PURE__ */ React45.createElement("div", {
    className: cn("text-label-sm-bold text-text-primary", titleClassName)
  }, title)), /* @__PURE__ */ React45.createElement("div", {
    className: "flex-1 min-w-0"
  }, children));
}, "DraggableItemComponent");
var DraggableItem = /* @__PURE__ */ React45.memo(DraggableItemComponent);
DraggableItem.displayName = "DraggableItem";
var Draggable = /* @__PURE__ */ __name(({ data, className, titleClassName, rootClassName, labelClassName, onDragEnd }) => {
  const sensors = useSensors(useSensor(PointerSensor, {
    activationConstraint: {
      delay: 0,
      tolerance: 1
    }
  }), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }), useSensor(TouchSensor));
  return /* @__PURE__ */ React45.createElement(DndContext, {
    sensors,
    modifiers: [
      restrictToVerticalAxis
    ],
    collisionDetection: closestCorners,
    onDragEnd
  }, /* @__PURE__ */ React45.createElement(SortableContext, {
    items: data.map((item) => item.id),
    strategy: verticalListSortingStrategy
  }, /* @__PURE__ */ React45.createElement("div", {
    className: cn("flex flex-col gap-6", rootClassName)
  }, data.map((item) => /* @__PURE__ */ React45.createElement(DraggableItem, {
    title: item.title,
    key: item.id,
    id: item.id,
    className: cn(className),
    titleClassName: cn(titleClassName),
    labelClassName: cn(labelClassName)
  }, item.children)))));
}, "Draggable");
var MemoizedDraggable = /* @__PURE__ */ React45.memo(Draggable);

// src/components/ErrorBoundary/ErrorBoundary.tsx
import React46, { Component } from "react";
import { AlertTriangle } from "lucide-react";
var ErrorBoundary = class extends Component {
  static {
    __name(this, "ErrorBoundary");
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({
      errorInfo
    });
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }
  handleReset = /* @__PURE__ */ __name(() => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
  }, "handleReset");
  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return /* @__PURE__ */ React46.createElement(React46.Fragment, null, this.props.fallback);
      }
      return /* @__PURE__ */ React46.createElement("div", {
        className: "flex flex-col items-center justify-center min-h-[400px] p-8 bg-main-primary-white border-2 border-stroke-container rounded-none"
      }, /* @__PURE__ */ React46.createElement(AlertTriangle, {
        className: "w-12 h-12 text-signal-error mb-4",
        strokeWidth: 2
      }), /* @__PURE__ */ React46.createElement("h2", {
        className: "text-header-base-bold text-text-primary mb-2"
      }, "Oops! Something went wrong"), /* @__PURE__ */ React46.createElement("p", {
        className: "text-paragraph-xs-regular text-text-secondary mb-6 text-center max-w-md"
      }, "We're sorry for the inconvenience. An unexpected error has occurred. Please try refreshing the page or contact support if the problem persists."), this.props.showDetails && this.state.error && /* @__PURE__ */ React46.createElement("details", {
        className: "mb-6 p-4 bg-neutral-grey-200 rounded-none w-full max-w-2xl"
      }, /* @__PURE__ */ React46.createElement("summary", {
        className: "cursor-pointer text-label-xs-bold text-text-primary mb-2"
      }, "Error Details"), /* @__PURE__ */ React46.createElement("pre", {
        className: "text-paragraph-xxs-regular text-text-secondary overflow-auto"
      }, this.state.error.toString(), this.state.errorInfo && this.state.errorInfo.componentStack)), /* @__PURE__ */ React46.createElement("div", {
        className: "flex gap-4"
      }, /* @__PURE__ */ React46.createElement(Button, {
        variant: "primary",
        size: "medium",
        onClick: /* @__PURE__ */ __name(() => window.location.reload(), "onClick")
      }, "Refresh Page"), /* @__PURE__ */ React46.createElement(Button, {
        variant: "secondary",
        size: "medium",
        onClick: this.handleReset
      }, "Try Again")));
    }
    return this.props.children;
  }
};
var useErrorBoundaryReset = /* @__PURE__ */ __name(() => {
  const [, setResetKey] = React46.useState(0);
  return React46.useCallback(() => {
    setResetKey((prev) => prev + 1);
  }, []);
}, "useErrorBoundaryReset");

// src/components/LoadingSpinner/LoadingSpinner.tsx
import * as React47 from "react";
var loadingSpinnerVariants = cva("animate-spin", {
  variants: {
    size: {
      xs: "w-4 h-4",
      sm: "w-6 h-6",
      md: "w-8 h-8",
      lg: "w-12 h-12",
      xl: "w-16 h-16"
    },
    color: {
      primary: "text-main-pure-black",
      inverted: "text-main-primary-white",
      error: "text-signal-error",
      muted: "text-neutral-grey-400"
    }
  },
  defaultVariants: {
    size: "md",
    color: "primary"
  }
});
var LoadingSpinner = /* @__PURE__ */ React47.forwardRef((props, ref) => {
  const { size, color, className, label = "Loading", ...restProps } = props;
  return /* @__PURE__ */ React47.createElement("span", {
    ref,
    role: "status",
    "aria-label": label,
    className: cn("inline-block", className),
    ...restProps
  }, /* @__PURE__ */ React47.createElement("svg", {
    className: cn(loadingSpinnerVariants({
      size,
      color
    })),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /* @__PURE__ */ React47.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /* @__PURE__ */ React47.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })), /* @__PURE__ */ React47.createElement("span", {
    className: "sr-only"
  }, label));
});
LoadingSpinner.displayName = "LoadingSpinner";
var overlayOpacityVariants = cva("absolute inset-0 bg-main-primary-white flex items-center justify-center z-50", {
  variants: {
    opacity: {
      light: "bg-opacity-50",
      medium: "bg-opacity-75",
      heavy: "bg-opacity-90"
    }
  },
  defaultVariants: {
    opacity: "medium"
  }
});
var LoadingOverlay = /* @__PURE__ */ __name(({ show, children, fullScreen = false, opacity = "medium", size = "lg", color = "primary", ...spinnerProps }) => {
  if (!show) return /* @__PURE__ */ React47.createElement(React47.Fragment, null, children);
  const overlayContent = /* @__PURE__ */ React47.createElement("div", {
    className: cn(overlayOpacityVariants({
      opacity
    }), fullScreen && "fixed")
  }, /* @__PURE__ */ React47.createElement(LoadingSpinner, {
    size,
    color,
    ...spinnerProps
  }));
  if (fullScreen) {
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, children, overlayContent);
  }
  return /* @__PURE__ */ React47.createElement("div", {
    className: "relative"
  }, children, overlayContent);
}, "LoadingOverlay");

// src/components/Skeleton/Skeleton.tsx
import * as React48 from "react";
function Skeleton({ className, ...props }) {
  return /* @__PURE__ */ React48.createElement("div", {
    "data-slot": "skeleton",
    className: cn("bg-neutral-grey-50 animate-pulse rounded-md", className),
    ...props
  });
}
__name(Skeleton, "Skeleton");

// src/components/Toast/Toast.tsx
import { toast as sonnerToast2 } from "sonner";

// src/components/Toast/ToastComponent.tsx
import React49, { memo as memo14 } from "react";
import { CircleCheck, TriangleAlert as TriangleAlert3 } from "lucide-react";
var toastVariants = cva([
  "flex gap-2 rounded-none shadow-interface justify-start items-center",
  "bg-neutral-grey-800 text-text-inverted",
  "text-paragraph-sm-regular",
  "max-w-[400px] p-3 w-fit",
  "font-default"
], {
  variants: {
    type: {
      default: "",
      success: "",
      error: "",
      loading: "",
      descriptiveError: [
        "border-2 border-signal-error",
        "text-text-primary bg-main-primary-white"
      ]
    }
  },
  defaultVariants: {
    type: "default"
  }
});
var Toast = /* @__PURE__ */ memo14(({ title, description, type }) => {
  return /* @__PURE__ */ React49.createElement(React49.Fragment, null, type === "descriptiveError" ? /* @__PURE__ */ React49.createElement("div", {
    className: cn(toastVariants({
      type
    }), "text-paragraph-sm-regular grid grid-cols-[20px_auto] gap-0 justify-start items-center"),
    "data-testid": "toast-descriptive-error"
  }, /* @__PURE__ */ React49.createElement(TriangleAlert3, {
    width: 20,
    height: 20
  }), /* @__PURE__ */ React49.createElement("div", {
    className: "text-paragraph-sm-bold pl-2"
  }, title), /* @__PURE__ */ React49.createElement("div", null), description && /* @__PURE__ */ React49.createElement("div", {
    className: "pl-2 whitespace-pre-line"
  }, description), /* @__PURE__ */ React49.createElement("div", {
    className: "ml-2"
  })) : /* @__PURE__ */ React49.createElement("div", {
    className: toastVariants({
      type
    }),
    role: "status",
    "aria-live": "polite",
    "data-testid": `toast-${type}`
  }, type === "loading" ? /* @__PURE__ */ React49.createElement(LoadingSpinner, {
    className: "[&>svg]:w-5 [&>svg]:h-5",
    color: "inverted"
  }) : type === "error" ? /* @__PURE__ */ React49.createElement(TriangleAlert3, {
    strokeWidth: 1.25,
    width: 20,
    height: 20,
    "aria-hidden": "true"
  }) : type === "success" ? /* @__PURE__ */ React49.createElement(CircleCheck, {
    strokeWidth: 1.25,
    width: 20,
    height: 20,
    "aria-hidden": "true"
  }) : null, /* @__PURE__ */ React49.createElement("div", null, title, type === "loading" && "...")));
});
Toast.displayName = "Toast";
var ToastComponent_default = Toast;

// src/components/Toast/Toaster.tsx
import React50 from "react";
import { Toaster as SonnerToaster, useSonner, toast as sonnerToast } from "sonner";
import { X as X9 } from "lucide-react";
var DismissAllButton = /* @__PURE__ */ __name(() => {
  const { toasts } = useSonner();
  const ours = toasts.filter((t) => t.toasterId === VAHTERUS_TOASTER_ID);
  const showButton = ours.length >= 3;
  if (!showButton) return null;
  return /* @__PURE__ */ React50.createElement(IconButton, {
    onClick: /* @__PURE__ */ __name(() => ours.forEach((t) => sonnerToast.dismiss(t.id)), "onClick"),
    icon: /* @__PURE__ */ React50.createElement(X9, null),
    hideTooltip: true,
    className: "bg-main-pure-black text-main-primary-white"
  });
}, "DismissAllButton");
var VAHTERUS_TOASTER_ID = "vahterus-app";
var Toaster = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React50.createElement("div", {
  className: "fixed bottom-[60px] right-5 flex flex-col items-end gap-1 z-[10000]"
}, /* @__PURE__ */ React50.createElement(SonnerToaster, {
  id: VAHTERUS_TOASTER_ID,
  visibleToasts: 5,
  expand: true,
  position: "bottom-right",
  offset: 60,
  gap: 4,
  ...props
}), /* @__PURE__ */ React50.createElement(DismissAllButton, null)), "Toaster");

// src/components/Toast/Toast.tsx
import React51 from "react";
var toast = /* @__PURE__ */ __name((toast2) => sonnerToast2.custom((id) => /* @__PURE__ */ React51.createElement(ToastComponent_default, {
  id,
  title: toast2.title,
  description: toast2.description,
  type: toast2.type
}), {
  toasterId: VAHTERUS_TOASTER_ID,
  duration: toast2.type == "descriptiveError" ? 6e3 : toast2.type == "loading" ? 12e4 : 3e3,
  dismissible: toast2.type != "descriptiveError"
}), "toast");
var toastPromise = /* @__PURE__ */ __name((promise, { loading, success, error }) => {
  const id = sonnerToast2.custom((id2) => /* @__PURE__ */ React51.createElement(ToastComponent_default, {
    id: id2,
    title: loading.title,
    type: "loading"
  }), {
    toasterId: VAHTERUS_TOASTER_ID
  });
  return promise.then((value) => {
    sonnerToast2.custom(
      (id2) => /* @__PURE__ */ React51.createElement(ToastComponent_default, {
        id: id2,
        title: success.title,
        type: success.type ?? "default"
      }),
      // The in-place update must re-state the toasterId — an update
      // without it would strip the routing and jump hosts.
      {
        id,
        toasterId: VAHTERUS_TOASTER_ID,
        duration: 3e3
      }
    );
    return value;
  }, (err) => {
    sonnerToast2.custom((id2) => /* @__PURE__ */ React51.createElement(ToastComponent_default, {
      id: id2,
      title: error.title,
      description: error.description,
      type: error.type ?? "error"
    }), {
      id,
      toasterId: VAHTERUS_TOASTER_ID,
      duration: error.type === "descriptiveError" ? 6e3 : 3e3,
      dismissible: error.type !== "descriptiveError"
    });
    throw err;
  });
}, "toastPromise");
var dismiss = /* @__PURE__ */ __name((id) => sonnerToast2.dismiss(id), "dismiss");
var exportedToast = Object.assign(toast, {
  promise: toastPromise,
  dismiss
});

// src/components/Label/Label.tsx
import * as React52 from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
var Label = /* @__PURE__ */ React52.memo(({ label, subLabel, htmlFor, required = false, className, ...props }) => {
  return /* @__PURE__ */ React52.createElement(LabelPrimitive.Root, {
    "data-slot": "label",
    className: cn("text-text-primary text-wrap break-normal text-label-xs-bold w-full", className),
    htmlFor,
    ...props
  }, /* @__PURE__ */ React52.createElement("div", null, label, required && /* @__PURE__ */ React52.createElement("span", {
    className: "text-text-error"
  }, "*")), subLabel && /* @__PURE__ */ React52.createElement("div", {
    className: "text-label-xxs-regular w-full text-text-secondary text-wrap break-normal"
  }, subLabel));
});
Label.displayName = "Label";

// src/components/Label/DiscrepancyLabel.tsx
import React53 from "react";
import { Lock } from "lucide-react";
var DiscrepancyLabel = /* @__PURE__ */ React53.memo(({ label, subLabel, labelClassName, tooltipClassName, required, placement = "top", contentAlign = "center", calculationValue, datasheetValue, ...props }) => {
  return /* @__PURE__ */ React53.createElement(Tooltip2, {
    variant: "info",
    placement,
    contentAlign,
    className: cn(tooltipClassName),
    contentClassName: "min-w-[270px]",
    content: /* @__PURE__ */ React53.createElement("div", {
      className: "text-paragraph-xs-regular flex flex-col gap-6 w-full"
    }, /* @__PURE__ */ React53.createElement("span", {
      className: "font-bold"
    }, "Difference in data sheet"), /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement("div", {
      className: "grid grid-cols-[50%_50%] gap-1 mb-2"
    }, /* @__PURE__ */ React53.createElement("span", null, "Calculation"), /* @__PURE__ */ React53.createElement("span", null, calculationValue)), /* @__PURE__ */ React53.createElement("div", {
      className: "grid grid-cols-[50%_50%] gap-1"
    }, /* @__PURE__ */ React53.createElement("span", null, "Data sheet"), /* @__PURE__ */ React53.createElement("span", null, Array.isArray(datasheetValue) ? datasheetValue.map((value, index) => /* @__PURE__ */ React53.createElement("div", {
      key: `datasheet-${index}-${value}`
    }, value)) : datasheetValue ?? ""))), /* @__PURE__ */ React53.createElement("div", {
      className: "flex gap-1 text-paragraph-xs-regular text-text-secondary"
    }, /* @__PURE__ */ React53.createElement(Lock, {
      strokeWidth: 1.5,
      width: 16,
      height: 16,
      absoluteStrokeWidth: true
    }), "Value is locked in data sheet"))
  }, /* @__PURE__ */ React53.createElement(Label, {
    label,
    subLabel,
    className: cn("border w-full border-signal-info border-dashed py-[10px]", labelClassName),
    required,
    ...props
  }));
});
DiscrepancyLabel.displayName = "DiscrepancyLabel";

// src/components/Popover/Popover.tsx
import * as React54 from "react";
import * as PopoverPrimitive2 from "@radix-ui/react-popover";
function Popover({ ...props }) {
  return /* @__PURE__ */ React54.createElement(PopoverPrimitive2.Root, {
    "data-slot": "popover",
    ...props
  });
}
__name(Popover, "Popover");
function PopoverTrigger({ ...props }) {
  return /* @__PURE__ */ React54.createElement(PopoverPrimitive2.Trigger, {
    "data-slot": "popover-trigger",
    ...props
  });
}
__name(PopoverTrigger, "PopoverTrigger");
function PopoverContent2({ className, align = "center", sideOffset = 4, ...props }) {
  return /* @__PURE__ */ React54.createElement(PopoverPrimitive2.Portal, null, /* @__PURE__ */ React54.createElement(PopoverPrimitive2.Content, {
    "data-slot": "popover-content",
    align,
    sideOffset,
    className: cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden", className),
    ...props
  }));
}
__name(PopoverContent2, "PopoverContent");
function PopoverAnchor({ ...props }) {
  return /* @__PURE__ */ React54.createElement(PopoverPrimitive2.Anchor, {
    "data-slot": "popover-anchor",
    ...props
  });
}
__name(PopoverAnchor, "PopoverAnchor");

// src/components/Tabs/Tabs.tsx
import * as React55 from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
var Tabs = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React55.createElement(TabsPrimitive.Root, {
  "data-slot": "tabs",
  className: cn(className),
  ...props
}), "Tabs");
var TabsList = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React55.createElement(TabsPrimitive.List, {
  "data-slot": "tabs-list",
  className: cn("flex w-fit justify-center items-center", className),
  ...props
}), "TabsList");
var TabsTriggerComponent = /* @__PURE__ */ __name(({ variant, disabled, className, ...props }) => {
  return /* @__PURE__ */ React55.createElement(TabsPrimitive.Trigger, {
    "data-slot": "tabs-trigger",
    className: cn(tabsTriggerVariant({
      variant,
      state: disabled ? "disabled" : null
    }), className),
    disabled,
    ...props
  });
}, "TabsTriggerComponent");
var TabsTrigger = /* @__PURE__ */ __name(({ variant, label, icon, counterValue, disabled, className, value, ...props }) => /* @__PURE__ */ React55.createElement(TabsPrimitive.Trigger, {
  "data-slot": "tabs-trigger",
  value,
  disabled,
  className: cn(tabsTriggerVariant({
    variant,
    state: disabled ? "disabled" : null
  }), className),
  ...props
}, icon && /* @__PURE__ */ React55.createElement("span", null, /* @__PURE__ */ React55.cloneElement(icon, {
  width: 20,
  height: 20,
  className: cn("stroke-regular group-data-[state=active]:stroke-bold")
})), /* @__PURE__ */ React55.createElement("div", null, label), counterValue && /* @__PURE__ */ React55.createElement("div", {
  className: cn("text-label-xs-bold text-text-inverted bg-main-pure-black rounded-full px-[3.5px] h-4 flex items-center justify-center", {
    "bg-interaction-disabled text-text-disabled": disabled
  })
}, counterValue)), "TabsTrigger");
var TabsContent = /* @__PURE__ */ __name(({ children, className, ...props }) => /* @__PURE__ */ React55.createElement(TabsPrimitive.Content, {
  "data-slot": "tabs-content",
  className: cn(className),
  ...props
}, children), "TabsContent");
var tabsTriggerVariant = cva([
  "flex gap-2 justify-center items-center",
  "focus-visible:ring-0 focus-visible:outline-0",
  "text-label-sm-regular data-[state=active]:text-label-sm-bold",
  "group"
], {
  variants: {
    variant: {
      primary: [
        "h-[60px] border-t-[3px] border-t-transparent px-6",
        "data-[state=active]:border-t-stroke-stroke data-[state=active]:bg-neutral-grey-50"
      ],
      secondary: [
        "border-b-[3px] h-[44px] border-b-transparent",
        "data-[state=active]:border-b-stroke-stroke"
      ]
    },
    state: {
      disabled: "cursor-not-allowed text-text-disabled"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
});

// src/components/Sidebar/Sidebar.tsx
import * as React58 from "react";
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { ChevronsLeft, ChevronsRight } from "lucide-react";

// src/hooks/sidebarContext.tsx
import React56 from "react";
var SidebarContext = /* @__PURE__ */ React56.createContext(null);
var useSidebar = /* @__PURE__ */ __name(() => {
  const context = React56.useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }
  return context;
}, "useSidebar");

// src/components/Sidebar/SidebarTooltipButton.tsx
import React57 from "react";
import * as TooltipPrimitive3 from "@radix-ui/react-tooltip";
var sidebarTooltipButtonVariants = cva("rounded-none p-1 w-fit h-fit flex justify-center items-center outline-none", {
  variants: {
    variant: {
      default: [
        "text-icon-primary",
        "bg-transparent",
        "border-none"
      ],
      inverted: [
        "text-icon-inverted",
        "bg-transparent",
        "border-none"
      ]
    },
    state: {
      disabled: [
        "cursor-not-allowed",
        "text-icon-disabled"
      ],
      default: "",
      selected: ""
    },
    size: {
      small: [
        "[&>svg]:h-[18px] [&>svg]:w-[18px]"
      ],
      medium: [
        "[&>svg]:h-[24px] [&>svg]:w-[24px]"
      ]
    }
  },
  defaultVariants: {
    variant: "default",
    size: "medium"
  },
  compoundVariants: [
    {
      variant: [
        "default"
      ],
      state: "selected",
      class: [
        "bg-main-pure-black",
        "text-icon-inverted"
      ]
    },
    {
      variant: [
        "inverted"
      ],
      state: "selected",
      class: [
        "bg-main-primary-white",
        "text-icon-primary"
      ]
    }
  ]
});
var TooltipContent3 = /* @__PURE__ */ React57.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ React57.createElement(TooltipPrimitive3.Content, {
  ref,
  sideOffset,
  className: cn("z-[2000] max-w-[200px] text-wrap truncate rounded-none bg-neutral-grey-800 py-4 px-3 text-text-inverted text-paragraph-xxs-regular shadow-interface", className),
  ...props
}));
TooltipContent3.displayName = TooltipPrimitive3.Content.displayName;
var SidebarTooltipButton = /* @__PURE__ */ React57.forwardRef(({ className, variant = "default", size = "medium", state = "default", labelText, icon, placement = "right", contentAlign = "center", asChild = false, contentClassName, hideTooltip = false, ...props }, ref) => {
  const hoverStyles = state == "disabled" ? "cursor-not-allowed" : "hover:bg-interaction-hover hover:cursor-pointer";
  return /* @__PURE__ */ React57.createElement(TooltipComponent, null, /* @__PURE__ */ React57.createElement(TooltipTrigger2, {
    className: cn(sidebarTooltipButtonVariants({
      variant,
      size,
      state
    }), hoverStyles, className),
    disabled: state === "disabled",
    ref,
    asChild,
    ...props
  }, asChild ? /* @__PURE__ */ React57.createElement("div", null, icon) : icon), !hideTooltip && /* @__PURE__ */ React57.createElement(TooltipContent3, {
    side: placement,
    align: contentAlign,
    className: contentClassName
  }, /* @__PURE__ */ React57.createElement(TooltipPrimitive3.Arrow, {
    className: "fill-neutral-grey-800"
  }), /* @__PURE__ */ React57.createElement("p", null, labelText)));
});
SidebarTooltipButton.displayName = "SidebarTooltipButton";

// src/components/Sidebar/Sidebar.tsx
import { TooltipArrow } from "@radix-ui/react-tooltip";
var SIDEBAR_COOKIE_NAME = "sidebar_state";
var SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
var SIDEBAR_WIDTH = "240px";
var SIDEBAR_WIDTH_ICON = "64px";
var SidebarProvider = /* @__PURE__ */ __name(({ defaultOpen = true, open: openProp, onOpenChange: setOpenProp, className, style, children, ...props }) => {
  const [_open, _setOpen] = React58.useState(defaultOpen);
  const open = openProp ?? _open;
  const setOpen = React58.useCallback((value) => {
    const openState = typeof value === "function" ? value(open) : value;
    if (setOpenProp) {
      setOpenProp(openState);
    } else {
      _setOpen(openState);
    }
    document.cookie = `${SIDEBAR_COOKIE_NAME}=${openState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
  }, [
    setOpenProp,
    open
  ]);
  const toggleSidebar = React58.useCallback(() => setOpen((open2) => !open2), [
    setOpen
  ]);
  const state = open ? "expanded" : "collapsed";
  const contextValue = React58.useMemo(() => ({
    state,
    open,
    setOpen,
    toggleSidebar
  }), [
    state,
    open,
    setOpen,
    toggleSidebar
  ]);
  return /* @__PURE__ */ React58.createElement(SidebarContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */ React58.createElement(TooltipProvider2, null, /* @__PURE__ */ React58.createElement("div", {
    "data-slot": "sidebar-wrapper",
    style: {
      "--sidebar-width": SIDEBAR_WIDTH,
      "--sidebar-width-icon": SIDEBAR_WIDTH_ICON,
      ...style
    },
    className: cn("group/sidebar-wrapper flex min-h-svh w-full", className),
    ...props
  }, children)));
}, "SidebarProvider");
var Sidebar = /* @__PURE__ */ __name(({ side = "left", variant = "sidebar", collapsible = "offcanvas", className, children, ...props }) => {
  const { state } = useSidebar();
  if (collapsible === "none") {
    return /* @__PURE__ */ React58.createElement("div", {
      "data-slot": "sidebar",
      style: {
        "--sidebar-width": "240px"
      },
      className: cn("bg-sidebar text-sidebar-foreground flex h-full w-[var(--sidebar-width)] flex-col", className),
      ...props
    }, children);
  }
  return /* @__PURE__ */ React58.createElement("div", {
    className: "group peer text-sidebar-foreground hidden md:block",
    "data-state": state,
    "data-collapsible": state === "collapsed" ? collapsible : "",
    "data-variant": variant,
    "data-side": side,
    "data-slot": "sidebar"
  }, /* @__PURE__ */ React58.createElement("div", {
    "data-slot": "sidebar-gap",
    className: cn("relative w-[var(--sidebar-width)] bg-transparent transition-[width] duration-200 ease-linear", "group-data-[collapsible=offcanvas]:w-0", "group-data-[side=right]:rotate-180", "group-data-[collapsible=icon]:w-[var(--sidebar-width-icon)]")
  }), /* @__PURE__ */ React58.createElement("div", {
    "data-slot": "sidebar-container",
    className: cn("fixed inset-y-0 z-10 hidden h-svh w-[var(--sidebar-width)] md:flex", side === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[-240px]" : "right-0 group-data-[collapsible=offcanvas]:right-[-240px]", "group-data-[collapsible=icon]:w-[var(--sidebar-width-icon)] group-data-[side=left]:border-r group-data-[side=right]:border-l", className),
    ...props
  }, /* @__PURE__ */ React58.createElement("div", {
    "data-sidebar": "sidebar",
    "data-slot": "sidebar-inner",
    className: cn("group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm", "border-r border-r-stroke-divider", {
      "bg-main-primary-white": state === "expanded",
      "bg-main-pure-black": state === "collapsed"
    })
  }, children)));
}, "Sidebar");
var SidebarTrigger = /* @__PURE__ */ __name(({ className, onClick, ...props }) => {
  const { toggleSidebar, state } = useSidebar();
  return /* @__PURE__ */ React58.createElement(SidebarTooltipButton, {
    "data-sidebar": "trigger",
    "data-slot": "sidebar-trigger",
    variant: state === "collapsed" ? "inverted" : "default",
    icon: state === "collapsed" ? /* @__PURE__ */ React58.createElement(ChevronsRight, {
      className: "stroke-regular",
      width: 24,
      height: 24
    }) : /* @__PURE__ */ React58.createElement(ChevronsLeft, {
      className: "stroke-regular",
      width: 24,
      height: 24
    }),
    labelText: state == "collapsed" ? "Expand sidebar" : "Collapse sidebar",
    onClick: /* @__PURE__ */ __name((event) => {
      onClick?.(event);
      toggleSidebar();
    }, "onClick"),
    className: cn({
      "hover:text-icon-primary": state === "collapsed"
    }, className),
    ...props
  }, /* @__PURE__ */ React58.createElement("span", {
    className: "sr-only"
  }, "Toggle Sidebar"));
}, "SidebarTrigger");
var SidebarInset = /* @__PURE__ */ __name(({ className, ...props }) => {
  return /* @__PURE__ */ React58.createElement("main", {
    "data-slot": "sidebar-inset",
    className: cn("relative flex w-full flex-1 flex-col", className),
    ...props
  });
}, "SidebarInset");
var SidebarHeader = /* @__PURE__ */ __name(({ vahterusLogo, className, ...props }) => {
  const { state } = useSidebar();
  return /* @__PURE__ */ React58.createElement("div", {
    "data-slot": "sidebar-header",
    "data-sidebar": "header",
    className: cn("flex justify-between items-center px-4 mb-6 h-[60px]", className),
    ...props
  }, state === "expanded" && /* @__PURE__ */ React58.createElement("img", {
    className: "h-3",
    src: vahterusLogo
  }), /* @__PURE__ */ React58.createElement(SidebarTrigger, null));
}, "SidebarHeader");
var SidebarFooter = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React58.createElement("div", {
  "data-slot": "sidebar-footer",
  "data-sidebar": "footer",
  className: cn("flex flex-col", className),
  ...props
}), "SidebarFooter");
var SidebarContent = /* @__PURE__ */ __name(({ className, ...props }) => {
  return /* @__PURE__ */ React58.createElement("div", {
    "data-slot": "sidebar-content",
    "data-sidebar": "content",
    className: cn("flex min-h-0 flex-1 border-stroke-divider flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden", className),
    ...props
  });
}, "SidebarContent");
var SidebarGroup = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React58.createElement("div", {
  "data-slot": "sidebar-group",
  "data-sidebar": "group",
  className: cn("relative flex w-full min-w-0 flex-col py-6", className),
  ...props
}), "SidebarGroup");
var SidebarGroupLabel = /* @__PURE__ */ __name(({ className, asChild = false, ...props }) => {
  const Comp = asChild ? Slot2 : "div";
  const { state } = useSidebar();
  return state === "expanded" && /* @__PURE__ */ React58.createElement(Comp, {
    "data-slot": "sidebar-group-label",
    "data-sidebar": "group-label",
    className: cn("text-text-disabled text-label-xs-regular pt-2 px-4 pb-4", className),
    ...props
  });
}, "SidebarGroupLabel");
var SidebarGroupContent = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React58.createElement("div", {
  "data-slot": "sidebar-group-content",
  "data-sidebar": "group-content",
  className: cn("w-full text-sm", className),
  ...props
}), "SidebarGroupContent");
var SidebarMenu = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React58.createElement("ul", {
  "data-slot": "sidebar-menu",
  "data-sidebar": "menu",
  className: cn("flex w-full min-w-0 flex-col gap-1", className),
  ...props
}), "SidebarMenu");
var SidebarMenuItem = /* @__PURE__ */ __name(({ className, ...props }) => /* @__PURE__ */ React58.createElement("li", {
  "data-slot": "sidebar-menu-item",
  "data-sidebar": "menu-item",
  className: cn("group/menu-item relative", className),
  ...props
}), "SidebarMenuItem");
var SidebarMenuButton = /* @__PURE__ */ __name(({ asChild = false, isActive = false, icon, label, hideTooltip, className, ...props }) => {
  const Comp = asChild ? Slot2 : "button";
  const { state } = useSidebar();
  const button = /* @__PURE__ */ React58.createElement(Comp, {
    "data-slot": "sidebar-menu-button",
    "data-sidebar": "menu-button",
    "data-active": isActive,
    className: cn("px-2 h-12 border-l-[3px] border-transparent text-label-sm-regular", "hover:bg-interaction-hover hover:cursor-pointer", {
      "hover:text-icon-primary text-icon-inverted": state === "collapsed",
      "bg-neutral-grey-50 border-l-stroke-stroke text-label-sm-bold": isActive
    }, className),
    ...props
  }, /* @__PURE__ */ React58.createElement("span", {
    className: cn("flex items-center gap-4", {
      "justify-center": state === "collapsed"
    })
  }, /* @__PURE__ */ React58.createElement("span", {
    className: cn("[&>svg]:size-6 [&>svg]:stroke-regular", {
      "[&>svg]:stroke-bold text-icon-primary": isActive
    })
  }, icon), state === "expanded" && /* @__PURE__ */ React58.createElement("span", null, label), state === "expanded" && props.children && props.children));
  return /* @__PURE__ */ React58.createElement(TooltipComponent, null, /* @__PURE__ */ React58.createElement(TooltipTrigger2, {
    asChild: true
  }, button), /* @__PURE__ */ React58.createElement(TooltipContent2, {
    side: "right",
    align: "center",
    hidden: state !== "collapsed" || hideTooltip
  }, /* @__PURE__ */ React58.createElement(TooltipArrow, {
    className: "fill-[#323232]"
  }), label));
}, "SidebarMenuButton");
var SidebarMenuAction = /* @__PURE__ */ __name(({ className, asChild = false, showOnHover = false, ...props }) => {
  const Comp = asChild ? Slot2 : "button";
  return /* @__PURE__ */ React58.createElement(Comp, {
    "data-slot": "sidebar-menu-action",
    "data-sidebar": "menu-action",
    className: cn("text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-hidden transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "after:absolute after:-inset-2 md:after:hidden", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", showOnHover && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0", className),
    ...props
  });
}, "SidebarMenuAction");
export {
  Accordion,
  AlertBanner,
  Avatar,
  Breadcrumb,
  Button,
  ButtonLoadingSpinner,
  Checkbox,
  CheckboxForm,
  Chip,
  Combobox,
  ComboboxForm,
  ComboboxFormInput,
  ConfirmationModal,
  ConfirmationModalClose,
  ConfirmationModalContent,
  ConfirmationModalDescription,
  ConfirmationModalFooter,
  ConfirmationModalHeader,
  ConfirmationModalOverlay,
  ConfirmationModalPortal,
  ConfirmationModalTitle,
  ConfirmationModalTrigger,
  ContextMenu,
  ContextMenuContent,
  ContextMenuGroup,
  ContextMenuItem,
  ContextMenuPortal,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
  ContextualHelp,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DiscrepancyLabel,
  MemoizedDraggable as Draggable,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  ErrorBoundary,
  FieldsLayout,
  HotAndColdToggle,
  IconButton,
  InfoBox,
  InputModal,
  InputModalClose,
  InputModalContent,
  InputModalDescription,
  InputModalFooter,
  InputModalHeader,
  InputModalOverlay,
  InputModalPortal,
  InputModalTitle,
  InputModalTrigger,
  Label,
  LoadingOverlay,
  LoadingSpinner,
  MultiSelect,
  MultiSelectForm,
  MultiSelectFormInput,
  MemoizedNumberInput as NumberInput,
  MemoizedNumberInputForm as NumberInputForm,
  Pagination,
  Popover,
  PopoverAnchor,
  PopoverContent2 as PopoverContent,
  PopoverTrigger,
  RadioGroup,
  RadioGroupForm,
  RadioGroupItem,
  RadioGroupItemForm,
  Select,
  SelectForm,
  SelectFormInput,
  Sidebar,
  SidebarContent,
  SidebarContext,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInset,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
  SidebarTooltipButton,
  SidebarTrigger,
  Skeleton,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  TabsTriggerComponent,
  TextInput,
  TextInputForm,
  Textarea,
  TextareaForm,
  Toaster,
  Toggle,
  ToggleForm,
  ToolModal,
  ToolModalClose,
  ToolModalContent,
  ToolModalDescription,
  ToolModalFooter,
  ToolModalHeader,
  ToolModalOverlay,
  ToolModalPortal,
  ToolModalTitle,
  ToolModalTrigger,
  Tooltip2 as Tooltip,
  checkFormErrors,
  checkboxVariants,
  cn,
  labelWrapperVariant2 as comboboxLabelWrapperVariant,
  comboboxOptionListVariant,
  comboboxOptionVariant,
  comboboxToggleButtonVariant,
  contextMenuContentVariant,
  contextMenuItemVariant,
  contextMenuMenuTriggerVariant,
  contextMenuRadioItemLabelVariant,
  contextMenuRadioItemLabelWrapperVariant,
  contextMenuRadioItemVariant,
  countLeadingZeros,
  dynamicRoundingNumber,
  formatNumber,
  getPrecision,
  labelVariant,
  mergeRefs,
  modalContentVariant,
  modalOverlayVariant,
  labelWrapperVariant3 as multiSelectLabelWrapperVariant,
  selectOptionListVariant2 as multiSelectOptionListVariant,
  selectOptionVariant2 as multiSelectOptionVariant,
  selectToggleButtonVariant2 as multiSelectToggleButtonVariant,
  numberInputVariants,
  radioIndicatorVariants,
  radioLabelVariants,
  radioPrimitiveVariants,
  radioSecondLabelVariants,
  roundNumberToPrecision,
  selectAllOption,
  labelWrapperVariant as selectLabelWrapperVariant,
  selectOptionLabelVariant,
  selectOptionListVariant,
  selectOptionVariant,
  selectToggleButtonVariant,
  selectedItemsAmount,
  textInputVariants,
  textareaVariants,
  exportedToast as toast,
  toggleRootVariant,
  toggleTextVariant,
  toggleThumbVariant,
  useErrorBoundaryReset,
  useOverflowObserver,
  useSidebar
};
//# sourceMappingURL=index.js.map